import { AfterViewInit, Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ConfirmComponent } from './confirm/confirm.component';
import { AddEmailComponent } from './add-email/add-email.component';
import {
  Attachments2_LinesModel,
  BatchNumbersModel,
  BatchNumbersModelSAP,
  DocumentAdditionalExpensesModel,
  DocumentLinesModel,
  ElectronicProtocol,
  IMarketingDocument,
  IMarketingDocumentSAP,
  MarketingDocument,
  MarketingDocumentSAP,
  PickListsLinesModel,
  PickListsLinesModelSAP,
  SerialNumbersModel,
  SerialNumbersModelSAP,
  TaxExtensionModel,
} from 'src/app/core/models/masters/marketing-document.model';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import {
  enumErrorMessageText,
  enumFormModes,
  enumMarketingDocumentEntryForm,
  enumMarketingDocumentType,
  enumMarketingDocumentTypeCode,
} from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { mapper } from 'src/app/infrastructure/infrastructure-services/common/mapper';
import { debounceTime, filter, lastValueFrom } from 'rxjs';
import {
  WrapperStandardFilter,
  WrapperStandardRequest,
} from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { FreightDetailComponent } from '../sales-order/freight-detail/freight-detail.component';
import { BatchSelectionComponent } from '../batch-selection/batch-selection.component';
import { SerialNumberSelectionComponent } from '../serial-number-selection/serial-number-selection.component';
import { HttpClient } from '@angular/common/http';
import { DateAdapter } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { AddBatchComponent } from '../add-batch/add-batch.component';
import { AddSerialComponent } from '../add-serial/add-serial.component';
import { TaxAmountPopupComponent } from '../tax-amount-popup/tax-amount-popup.component';
import { CopyFromPopupComponent } from '../sales-order/copy-from-popup/copy-from-popup.component';
import { TdsPopupComponent } from '../tds-popup/tds-popup.component';
import { GenericAttachmentUploadView } from 'src/app/infrastructure/infrastructure-services/generics/generic-attachment-upload/generic-attachment-upload-view';
import { GenericAttachmentUploadProperties } from 'src/app/infrastructure/infrastructure-services/generics/generic-attachment-upload/generic-attachment-upload-properties';
import { FormControl, FormGroup } from '@angular/forms';
import { UpdateExchangeRateComponent } from '../../settings/update-exchange-rate/update-exchange-rate.component';
import { ExchangeRateEntryFormComponent } from '../../settings/exchangerate-master-entryform/exchangerate-entryform.component';
import { AttachmentViewComponent } from 'src/app/shared/attachment-view/attachment-view.component';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { BatchSerialPopupComponent } from '../../production/issue-for-production-order-entry-form/batch-serial-popup/batch-serial-popup.component';
import { GlobalProperties } from 'src/app/global/global-properties';
import { ItemComponent } from './item-component/item-component.component';
import { ViewChildren, QueryList } from '@angular/core';
import { NgxMatDatetimepicker } from '@angular-material-components/datetime-picker';
import { createMap, forMember, mapFrom } from '@automapper/core';
import { BatchSerialAddPopupComponent } from '../../production/reciept-from-production-entryform/batch-serial-add-popup/batch-serial-add-popup.component';
import { EInvoiceDropdownComponent } from '../e-invoice/e-invoice-dropdown/e-invoice-dropdown.component';
import { EInvoiceComponent } from '../e-invoice/e-invoice/e-invoice.component';
import { EWayTabComponent } from '../e-way/e-way-tab/e-way-tab.component';
import { EWayAlertPopupComponent } from '../e-way/e-way-alert-popup/e-way-alert-popup.component';
import { EWayBillPopupComponent } from '../e-way/e-way-bill-popup/e-way-bill-popup.component';
import { SecurityService } from 'src/app/login-layout/Service/security.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommentDialogComponent } from '../../approval-process/comment-dialog/comment-dialog.component';

@Component({
  selector: 'app-marketing-document-entry-form',
  templateUrl: './marketing-document-entry-form.component.html',
  styleUrls: ['./marketing-document-entry-form.component.css'],
  providers: [
    EWayBillPopupComponent,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {},
    },
  ],
})

// ============================================================================
// ========================= CLASS PROPERTIES & VARIABLES =========================
// ============================================================================

// ============================================================================
// ========================= CLASS PROPERTIES & VARIABLES =========================
// ============================================================================
export class MarketingDocumentEntryFormComponent
  extends GenericEntryForm<IMarketingDocument, IMarketingDocumentSAP>
  implements AfterViewInit {
  selectedFile: any[] = [];
  selectedAttacment: any[] = [];
  ArrayofSelectedFile = new Array<string>();
  isLinear = false;
  apiString: any;
  freightArr: DocumentAdditionalExpensesModel[] = [];
  genAttachUpload = new GenericAttachmentUploadView<IMarketingDocument>(
    this.http
  );
  allItem: any[] = [];
  itemCode: any;
  isExpanded: boolean = false;
  myForm!: FormGroup;
  lineLevelFormGroup!: FormGroup;
  lineLevelFormGroupArray: FormGroup[] = [];
  currentState: any;
  customFields: boolean = false;
  billToAddress: any[] = [];
  shipToAddress: any[] = [];
  currencyList: any[] = [];
  selectedLineItems: any[] = [];
  documentLinesData: any[] = [];
  slaesQuatationForm: boolean = false;
  getCustomerVendorTitle = 'Language.CustomerDetailText';
  getCustomerVendorCodeText = 'Language.CustomerCodeText';
  getCustomerVendorNameText = 'Language.CustomerNameText';
  getPurchaseSalesDetailText = 'Language.SalesDetailText';
  requester = '';
  cutomerOrVendorDisabled: boolean = false;
  itemData: any[] = [];
  @ViewChildren('picker') pickersQueryList!: QueryList<NgxMatDatetimepicker<Date>>;
  pickers: NgxMatDatetimepicker<Date>[] = [];
  optionsDepartment: any[] = [];
  // removed lineRemarkMaxSize
  // removed leadTimeMaxSize

  // Infinite scroll variables
  pageNumber: number = 1;
  isLoadingMoreLines: boolean = false;
  hasMoreLines: boolean = true;

  // Dirty tracking for updates
  originalDocumentLines: any[] = [];



  // displayedColumns: string[] = ['f_name', 'remarks', 'tax_code', 'total_tax_amt',
  //   'net_amount', 'gross_amount', 'status', 'action'];
  // dataSource: any[] = [
  //   {
  //     'f_name': 'jkdfk', 'remarks': 'jkdfk', 'tax_code': 78346, 'total_tax_amt': 43358,
  //     'distrib_method': 'jkdfk', 'net_amount': 56378, 'status': 'jkdfk', 'f_tax_distrib_method': 'jkdfk',
  //     'gross_amount': 34534, 'action': 'jkdfk'
  //   }
  // ];

  // model!: PickListsModel | IMarketingDocument;
  displayedColumns: string[] = [
    'item_srno',
    'item_detail',
    'amount',
  ];
  dataSource: any[] = [{}];

  displayedColumns1: string[] = [
    'item_detail',
    'unit_qty_open_qty',
    'warehouse_detail',
    'delivery_date',
    'unit_price',
    'tax',
    'amount',
  ];
  dataSource1: any[] = [{}];
  vendorOrCustomer: string = 'Customer';
  test: any;
  _URL: any;
  itemRequest: any;
  date = new FormControl(new Date());
  getNotesText = 'Language.CustomerNotesText';
  copyToScreens: any[] = [];
  copyScreens: any[] = [
    {
      name: 'Sales Order',
      routeTo: 'salesOrderEntryForm',
      listEndPoint: 'Orders/GetOrdersListService',
      getEndPoint: 'Orders/GetOrdersService',
    },
    {
      name: 'Sales Quotation',
      routeTo: 'salesQutationEntryForm',
      listEndPoint: 'Quotations/GetQuotationsListService',
      getEndPoint: 'Quotations/GetQuotationsService',
    },
    {
      name: 'Sales Down Payment Request',
      routeTo: 'salesDownPaymentRequestEntryForm',
      listEndPoint: 'ARDownPaymentRequest/GetARDownPaymentRequestListService',
      getEndPoint: 'ARDownPaymentRequest/GetARDownPaymentRequestService',
    },
    {
      name: 'Sales Invoice',
      routeTo: 'salesInvoiceEntryForm',
      listEndPoint: 'Invoices/GetInvoicesListService',
      getEndPoint: 'Invoices/GetInvoicesService',
    },
    {
      name: 'Credit Notes',
      routeTo: 'creditNotesEntryForm',
      listEndPoint: 'CreditNotes/GetCreditNotesListService',
      getEndPoint: 'CreditNotes/GetCreditNotesService',
    },
  ];
  seriesList: any[] = [];
  branchList: any[] = [];
  @ViewChild('eInvoiceComp') eInvoiceComp!: EInvoiceComponent;
  @ViewChild('einvoiceBtnComp') einvoiceBtnComp!: EInvoiceDropdownComponent;
  @ViewChild('eWayTabComp') eWayTabComp!: EWayTabComponent;
  isBoolGenerateewayBill: boolean = true;
  showEInvoice: boolean = false;
  public copyProgressMessage: string = '';
  navFrom: string = '';
  draftEntry: string = '';
  objectType: string = '';
  selectedCode: number = 0;
  allResults: any[] = [];
  allResultsLIneLevel: any[] = [];
  cancelOrRevert: any = [
    { value: 'Canceled', viewValue: '1' },
    { value: 'Reversed', viewValue: '2' },
    { value: 'Normal', viewValue: '3' },
  ];

  shipToBranch: any[] = [
    { value: 'Delhi', viewValue: '1', shipToAddress: '303, Siddarth Building, 96, Nehru Place, Delhi - 110019, (DL)' },
    { value: 'Gurgaon', viewValue: '2', shipToAddress: 'Independent Module No. 38, Hartron Complex, Sector - 18, Electronic City, Gurgaon - 122015, (HR)' },
    { value: 'Banglore', viewValue: '3', shipToAddress: '127, FF, Jakasandra, Block - 8A, Main Road, Koramangala, Bangalore - 560034, (KA)' },
    { value: 'Jaipur', viewValue: '4', shipToAddress: '3/163, Shivam Apartments, Jawahar Nagar, Jaipur - 302004, (RJ)' },
    { value: 'Mumbai', viewValue: '5', shipToAddress: 'C/o AFL Pvt. Limited, NDR Warehousing, Survey No. 95, Behind Sai Baba, Mumbai-Nashik Highway, Village Vadape, Bhiwandi - 421302, Dist. Thane, Maharashtra' },
    { value: 'Panipat', viewValue: '6', shipToAddress: 'Shop No. 6, Plot No. 1087, Bishan Saroop Colony, Panipat - 132103, Haryana' },
    { value: 'Hyderabad', viewValue: '7', shipToAddress: 'Hyderabad' },
    { value: 'Indore', viewValue: '8', shipToAddress: 'No. 196/2/1, S R Compound, Gram Lasudia Mori, Indore - 452010, Madhya Pradesh' },
  ];


  get isOriginatorPendingRequest(): boolean {
    return window.location.href.includes('orignatorPendingReuests');
  }

  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;

  checkMenuPermissions() {
    // We can inject SecurityService or instantiate it if it's not injected properly, 
    // but the component already has a generic way or we can just use the service directly.
    let securityService = new SecurityService(); // It has no dependencies in its constructor, so safe to instantiate
    let permissions = securityService.getMenuPermissions(this.getFormSubTitle);

    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
  }

  // ============================================================================
  // ========================= CONSTRUCTOR & INITIALIZATION =========================
  // ============================================================================

  // ============================================================================
  // ========================= CONSTRUCTOR & INITIALIZATION =========================
  // ============================================================================
  constructor(
    agenericRepository: GenericService<IMarketingDocument>,
    private http: HttpClient,
    public matDialogRefForCfl: MatDialogRef<
      GenericCflViewComponent<IMarketingDocument>
    >,
    public agenericRepositoryForCfl: GenericService<IMarketingDocument>,
    public routerForCfl: Router,
    private dateAdapter: DateAdapter<Date>,
    public snackbarService: BaseService<any>,
    private ngxUiLoaderService: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public eWayBill: EWayBillPopupComponent,
    public matDialogforCfl: MatDialog,
    dialog: MatDialog,

    private activatedRoute: ActivatedRoute,
    router: Router,
    private dbService: NgxIndexedDBService,
    private activated: ActivatedRoute,
    public generic: GenericService<any>
  ) {
    super(agenericRepository, router, dialog);
    // this.model = this.determineModel();
    //  this.testt()
    //this.getOrders();
    this.activated.url.subscribe(async (data) => {
      if (
        data[0].path == 'marketingDocumentEntryForm') {
        this.navFrom = 'PendingApprovals';
        let navRoute = localStorage.getItem('navRoute');
        if (navRoute == 'pendingApprovalIndividual') {
          this.setListViewFormRouteTo =
            '/home/approval-process/pendingApprovalIndv/';
        } else if (navRoute == 'originatorPendingReuest') {
          this.setListViewFormRouteTo =
            '/home/approval-process/orignatorPendingReuests/';
        } else {
          this.setListViewFormRouteTo =
            '/home/approval-process/pendingApprovalBulk/';
        }
        this.draftEntry = data[1]?.path ?? null;
        this.objectType = data[2]?.path ?? null;
        if (this.objectType == "17") {
          this.setFormSubTitle = 'Sales Order';
        } else if (this.objectType == "23") {
          this.setFormSubTitle = 'Sales Quotation';
        } else if (this.objectType == "13") {
          this.setFormSubTitle = 'Sales Invoice';
        } else if (this.objectType == "203") {
          this.setFormSubTitle = 'Sales Down Payment Request';
        } else if (this.objectType == "22") {
          this.setFormSubTitle = 'Purchase Order';
        } else if (this.objectType == "1470000113") {
          this.setFormSubTitle = 'Purchase Request';
          this.getCustomerVendorTitle = 'Language.RequesterDetailText';
          this.getCustomerVendorCodeText = 'Language.RequesterCodeText';
          this.getCustomerVendorNameText = 'Language.RequesterNameText';
          this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
          this.getNotesText = 'Language.VendorNotesText';
          this.copyToScreens = [
            {
              name: 'Purchase Quotation',
              routeTo: 'purchaseQutationEntryForm',
              listEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsListService',
              getEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsService',
            },
            {
              name: 'Purchase Order',
              routeTo: 'purchaseOrderEntryForm',
              listEndPoint: 'PurchaseOrders/GetPurchaseOrdersListService',
              getEndPoint: 'PurchaseOrders/GetPurchaseOrdersService',
            },
          ];
        } else if (this.objectType == "540000006") {
          this.setFormSubTitle = 'Purchase Quotation';
        } else if (this.objectType == "15") {
          this.setFormSubTitle = 'Delivery Challans';
        } else if (this.objectType == "20") {
          this.setFormSubTitle = 'GRPO';
        } else if (this.objectType == "204") {
          this.setFormSubTitle = 'Purchase Down Payment Request';
        } else if (this.objectType == "14") {
          this.setFormSubTitle = 'Credit Notes';
        } else if (this.objectType == "19") {
          this.setFormSubTitle = 'Debit Notes';
        }

        this.setDraftsData(data[2].path);
        localStorage.removeItem('navRoute');
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.SalesOrderEntry
      ) {
        this.setURLForFormModeNew = 'Orders/NewOrdersService';
        this.setURLForFormModeEdit = 'Orders/GetOrdersService';
        this.setURLForFormModeAddSap = 'Orders';
        this.setURLForFormModeUpdateSap = `Orders(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/salesOrderListView/';
        this.setFormSubTitle = 'Sales Order';
        this.copyScreens = [
          {
            name: 'Sales Quotation',
            routeTo: 'salesQutationEntryForm',
            listEndPoint: 'Quotations/GetQuotationsListService',
            getEndPoint: 'Quotations/GetQuotationsService',
          },
        ];
        this.copyToScreens = [
          {
            name: 'Sales Invoice',
            routeTo: 'salesInvoiceEntryForm',
            listEndPoint: 'Invoices/GetInvoicesListService',
            getEndPoint: 'Invoices/GetInvoicesService',
          },
          {
            name: 'Delivery',
            routeTo: 'deliveryChallanEntryForm',
            listEndPoint: 'DeliveryNotes/GetDeliveryNotesListService',
            getEndPoint: 'DeliveryNotes/GetDeliveryNotesService',
          },
          // {
          //   name: 'Pick Lists',
          //   routeTo: 'pickListsEntryForm',
          //   listEndPoint: 'PickList/GetPickListListListService',
          //   getEndPoint: 'PickList/GetPickListService'
          // }
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.SalesQutationEntry
      ) {
        this.setURLForFormModeNew = 'Quotations/NewQuotationsService';
        this.setURLForFormModeEdit = 'Quotations/GetQuotationsService';
        this.setURLForFormModeAddSap = 'Quotations';
        this.setURLForFormModeUpdateSap = `Quotations(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/salesQutationListView/';
        this.setFormSubTitle = 'Sales Quotation';
        this.copyToScreens = [
          {
            name: 'Sales Invoice',
            routeTo: 'salesInvoiceEntryForm',
            listEndPoint: 'Invoices/GetInvoicesListService',
            getEndPoint: 'Invoices/GetInvoicesService',
          },
          {
            name: 'Sales Order',
            routeTo: 'salesOrderEntryForm',
            listEndPoint: 'Orders/GetOrdersListService',
            getEndPoint: 'Orders/GetOrdersService',
          },

          {
            name: 'Delivery',
            routeTo: 'deliveryChallanEntryForm',
            listEndPoint: 'DeliveryNotes/GetDeliveryNotesListService',
            getEndPoint: 'DeliveryNotes/GetDeliveryNotesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.SalesInvioceEntry
      ) {
        this.setURLForFormModeNew = 'Invoices/NewInvoicesService';
        this.setURLForFormModeEdit = 'Invoices/GetInvoicesService';
        this.setURLForFormModeAddSap = 'Invoices';
        this.setURLForFormModeUpdateSap = `Invoices(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/salesInvoiceListView/';
        this.setFormSubTitle = 'Sales Invoice';
        this.setFormDisable = true;
        this.copyScreens = [
          {
            name: 'Sales Order',
            routeTo: 'salesOrderEntryForm',
            listEndPoint: 'Orders/GetOrdersListService',
            getEndPoint: 'Orders/GetOrdersService',
          },
          {
            name: 'Sales Quotation',
            routeTo: 'salesQutationEntryForm',
            listEndPoint: 'Quotations/GetQuotationsListService',
            getEndPoint: 'Quotations/GetQuotationsService',
          },
          {
            name: 'Delivery',
            routeTo: 'deliveryChallanEntryForm',
            listEndPoint: 'DeliveryNotes/GetDeliveryNotesListService',
            getEndPoint: 'DeliveryNotes/GetDeliveryNotesService',
          },
        ];
        this.copyToScreens = [
          {
            name: 'Credit Notes',
            routeTo: 'creditNotesEntryForm',
            listEndPoint: 'CreditNotes/GetCreditNotesListService',
            getEndPoint: 'CreditNotes/GetCreditNotesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.ARDownPaymentRequestEntry
      ) {
        this.setURLForFormModeNew =
          'ARDownPaymentRequest/NewARDownPaymentRequestService';
        this.setURLForFormModeEdit =
          'ARDownPaymentRequest/GetARDownPaymentRequestService';
        this.setURLForFormModeAddSap = 'DownPayments';
        this.setURLForFormModeUpdateSap = `DownPayments(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo =
          '/home/sales/salesDownPaymentRequestListView/';
        this.setFormSubTitle = 'Sales Down Payment Request';
        this.copyScreens = [
          {
            name: 'Sales Order',
            routeTo: 'salesOrderEntryForm',
            listEndPoint: 'Orders/GetOrdersListService',
            getEndPoint: 'Orders/GetOrdersService',
          },
          {
            name: 'Sales Quotation',
            routeTo: 'salesQutationEntryForm',
            listEndPoint: 'Quotations/GetQuotationsListService',
            getEndPoint: 'Quotations/GetQuotationsService',
          },
          {
            name: 'Delivery',
            routeTo: 'deliveryChallanEntryForm',
            listEndPoint: 'DeliveryNotes/GetDeliveryNotesListService',
            getEndPoint: 'DeliveryNotes/GetDeliveryNotesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.PurchaseOrderEntry
      ) {
        this.setURLForFormModeNew = 'PurchaseOrders/NewPurchaseOrdersService';
        this.setURLForFormModeEdit = 'PurchaseOrders/GetPurchaseOrdersService';
        this.setURLForFormModeAddSap = 'PurchaseOrders';
        this.setURLForFormModeUpdateSap = `PurchaseOrders(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/purchaseOrderListView/';
        this.setFormSubTitle = 'Purchase Order';
        this.getCustomerVendorTitle = 'Language.VendorDetailText';
        this.getCustomerVendorCodeText = 'Language.VendorCodeText';
        this.getCustomerVendorNameText = 'Language.VendorNameText';
        this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
        this.getNotesText = 'Language.VendorNotesText';
        this.copyScreens = [
          {
            name: 'Purchase Request',
            routeTo: 'purchaseRequestEntryForm',
            listEndPoint: 'PurchaseRequest/GetPurchaseRequestListService',
            getEndPoint: 'PurchaseRequest/GetPurchaseRequestService',
          },
          {
            name: 'Purchase Quotation',
            routeTo: 'purchaseQutationEntryForm',
            listEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsListService',
            getEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsService',
          },
        ];
        this.copyToScreens = [
          {
            name: 'GRPO',
            routeTo: 'GRPOEntryForm',
            listEndPoint: 'GRPO/GetGRPOListService',
            getEndPoint: 'GRPO/GetGRPOService',
          },
          {
            name: 'Purchase Invoice',
            routeTo: 'purchaseInvoiceEntryForm',
            listEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesListService',
            getEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesService',
          },
          {
            name: 'Purchase Down Payment Request',
            routeTo: 'purchaseDownPaymentRequestentryform',
            listEndPoint:
              'APDownPaymentRequest/GetAPDownPaymentRequestListService',
            getEndPoint: 'APDownPaymentRequest/GetAPDownPaymentRequestService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.PurchaseRequestEntry
      ) {
        this.ForPurchaseRequestEntry();
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.PurchaseQutationEntry
      ) {
        this.setURLForFormModeNew =
          'PurchaseQuotations/NewPurchaseQuotationsService';
        this.setURLForFormModeEdit =
          'PurchaseQuotations/GetPurchaseQuotationsService';
        this.setURLForFormModeAddSap = 'PurchaseQuotations';
        this.setURLForFormModeUpdateSap = `PurchaseQuotations(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/purchaseQutationListView/';
        this.setFormSubTitle = 'Purchase Quotation';
        this.getCustomerVendorTitle = 'Language.VendorDetailText';
        this.getCustomerVendorCodeText = 'Language.VendorCodeText';
        this.getCustomerVendorNameText = 'Language.VendorNameText';
        this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
        this.getNotesText = 'Language.VendorNotesText';
        this.copyScreens = [];
        this.copyToScreens = [
          {
            name: 'Purchase Order',
            routeTo: 'purchaseOrderEntryForm',
            listEndPoint: 'PurchaseOrders/GetPurchaseOrdersListService',
            getEndPoint: 'PurchaseOrders/GetPurchaseOrdersService',
          },
          {
            name: 'GRPO',
            routeTo: 'GRPOEntryForm',
            listEndPoint: 'GRPO/GetGRPOListService',
            getEndPoint: 'GRPO/GetGRPOService',
          },
          {
            name: 'Purchase Invoice',
            routeTo: 'purchaseInvoiceEntryForm',
            listEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesListService',
            getEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.DeliveryChallansEntry
      ) {
        this.setURLForFormModeNew = 'DeliveryNotes/NewDeliveryService';
        this.setURLForFormModeEdit = 'DeliveryNotes/GetDeliveryNotesService';
        this.setURLForFormModeAddSap = 'DeliveryNotes';
        this.setURLForFormModeUpdateSap = `DeliveryNotes(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/deleveryChalanListView/';
        this.setFormSubTitle = 'Delivery Challans';
        this.copyScreens = [
          {
            name: 'Sales Order',
            routeTo: 'salesOrderEntryForm',
            listEndPoint: 'Orders/GetOrdersListService',
            getEndPoint: 'Orders/GetOrdersService',
          },
          {
            name: 'Sales Quotation',
            routeTo: 'salesQutationEntryForm',
            listEndPoint: 'Quotations/GetQuotationsListService',
            getEndPoint: 'Quotations/GetQuotationsService',
          },
        ];
        this.copyToScreens = [
          {
            name: 'Sales Invoice',
            routeTo: 'salesInvoiceEntryForm',
            listEndPoint: 'Invoices/GetInvoicesListService',
            getEndPoint: 'Invoices/GetInvoicesService',
          },
        ];
      } else if (data[0].path == enumMarketingDocumentEntryForm.GRPOEntryForm) {
        this.setURLForFormModeNew = 'GRPO/NewGRPOService';
        this.setURLForFormModeEdit = 'GRPO/GetGRPOService';
        this.setURLForFormModeAddSap = 'PurchaseDeliveryNotes';
        this.setURLForFormModeUpdateSap = `PurchaseDeliveryNotes(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/GRPOListView/';
        this.setFormSubTitle = 'GRPO';
        this.vendorOrCustomer = 'Vendor';
        this.getCustomerVendorTitle = 'Language.VendorDetailText';
        this.getCustomerVendorCodeText = 'Language.VendorCodeText';
        this.getCustomerVendorNameText = 'Language.VendorNameText';
        this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
        this.getNotesText = 'Language.VendorNotesText';
        this.copyScreens = [
          {
            name: 'Purchase Order',
            routeTo: 'purchaseOrderEntryForm',
            listEndPoint: 'PurchaseOrders/GetPurchaseOrdersListService',
            getEndPoint: 'PurchaseOrders/GetPurchaseOrdersService',
          },
          {
            name: 'Purchase Quotation',
            routeTo: 'purchaseQutationEntryForm',
            listEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsListService',
            getEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsService',
          },
        ];

        this.copyToScreens = [
          {
            name: 'Purchase Invoice',
            routeTo: 'purchaseInvoiceEntryForm',
            listEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesListService',
            getEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.APDownPaymentRequest
      ) {
        this.setURLForFormModeNew =
          'APDownPaymentRequest/NewAPDownPaymentRequestService';
        this.setURLForFormModeEdit =
          'APDownPaymentRequest/GetAPDownPaymentRequestService';
        this.setURLForFormModeAddSap = 'PurchaseDownPayments';
        this.setURLForFormModeUpdateSap = `PurchaseDownPayments(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo =
          '/home/sales/purchaseDownPaymentRequestListView/';
        this.setFormSubTitle = 'Purchase Down Payment Request';
        this.getCustomerVendorTitle = 'Language.VendorDetailText';
        this.getCustomerVendorCodeText = 'Language.VendorCodeText';
        this.getCustomerVendorNameText = 'Language.VendorNameText';
        this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
        this.getNotesText = 'Language.VendorNotesText';
        this.copyScreens = [
          {
            name: 'Purchase Order',
            routeTo: 'purchaseOrderEntryForm',
            listEndPoint: 'PurchaseOrders/GetPurchaseOrdersListService',
            getEndPoint: 'PurchaseOrders/GetPurchaseOrdersService',
          },
          {
            name: 'Purchase Quotation',
            routeTo: 'purchaseQutationEntryForm',
            listEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsListService',
            getEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsService',
          },
          {
            name: 'GRPO',
            routeTo: 'GRPOEntryForm',
            listEndPoint: 'GRPO/GetGRPOListService',
            getEndPoint: 'GRPO/GetGRPOService',
          },
        ];
        this.copyToScreens = [];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.CreditNoteEntry
      ) {
        this.setURLForFormModeNew = 'CreditNotes/NewCreditNotesService';
        this.setURLForFormModeEdit = 'CreditNotes/GetCreditNotesService';
        this.setURLForFormModeAddSap = 'CreditNotes';
        this.setURLForFormModeUpdateSap = `CreditNotes(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/creditNotesListView/';
        this.setFormSubTitle = 'Credit Notes';
        this.copyScreens = [
          {
            name: 'Sales Invoice',
            routeTo: 'salesInvoiceEntryForm',
            listEndPoint: 'Invoices/GetInvoicesListService',
            getEndPoint: 'Invoices/GetInvoicesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.DebitNoteEntry
      ) {
        this.setURLForFormModeNew = 'DebitNotes/NewDebitNotesService';
        this.setURLForFormModeEdit = 'DebitNotes/GetDebitNotesService';
        this.setURLForFormModeAddSap = 'PurchaseCreditNotes';
        this.setURLForFormModeUpdateSap = `PurchaseCreditNotes(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/debitNotesListView/';
        this.setFormSubTitle = 'Debit Notes';
        this.getCustomerVendorTitle = 'Language.VendorDetailText';
        this.getCustomerVendorCodeText = 'Language.VendorCodeText';
        this.getCustomerVendorNameText = 'Language.VendorNameText';
        this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
        this.getNotesText = 'Language.VendorNotesText';
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.PurchaseInvoiceEntry
      ) {
        this.setURLForFormModeNew =
          'PurchaseInvoices/NewPurchaseInvoicesService';
        this.setURLForFormModeEdit =
          'PurchaseInvoices/GetPurchaseInvoicesService';
        this.setURLForFormModeAddSap = 'PurchaseInvoices';
        this.setURLForFormModeUpdateSap = `PurchaseInvoices(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/purchaseInvoiceListView/';
        this.setFormSubTitle = 'Purchase Invoice';
        this.getCustomerVendorTitle = 'Language.VendorDetailText';
        this.getCustomerVendorCodeText = 'Language.VendorCodeText';
        this.getCustomerVendorNameText = 'Language.VendorNameText';
        this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
        this.getNotesText = 'Language.VendorNotesText';
        this.copyScreens = [
          {
            name: 'Purchase Order',
            routeTo: 'purchaseOrderEntryForm',
            listEndPoint: 'PurchaseOrders/GetPurchaseOrdersListService',
            getEndPoint: 'PurchaseOrders/GetPurchaseOrdersService',
          },
          {
            name: 'Purchase Quotation',
            routeTo: 'purchaseQutationEntryForm',
            listEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsListService',
            getEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsService',
          },
          {
            name: 'GRPO',
            routeTo: 'GRPOEntryForm',
            listEndPoint: 'GRPO/GetGRPOListService',
            getEndPoint: 'GRPO/GetGRPOService',
          },
        ];

        this.copyToScreens = [
          {
            name: 'Debit Notes',
            routeTo: 'debitNotesEntryForm',
            listEndPoint: 'CreditNotes/GetDebitNotesListService',
            getEndPoint: 'CreditNotes/GetDebitNotesService',
          },
        ];
      } else if (
        data[0].path == enumMarketingDocumentEntryForm.PickListsEntry
      ) {
        this.setURLForFormModeNew = '';
        this.setURLForFormModeEdit = 'PickList/GetPickListService';
        this.setURLForFormModeAddSap = 'PickLists';
        this.setURLForFormModeUpdateSap = `PickLists(${this.activatedRoute.snapshot.params['id']})`;
        this.setListViewFormRouteTo = '/home/sales/pickListsListView/';
        this.setFormSubTitle = 'Pick Lists';
      }
    });
    this.setMenuCode = 'M311';
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.setRequestDataForFormModeNew = '';
    let marketingDocument = new MarketingDocument();
    let marketingDocumentSAP = new MarketingDocumentSAP();
    //  marketingDocument.branchName=localStorage.getItem("BranchName")

    marketingDocument.docEntry =
      this.activatedRoute.snapshot.params['id'] != 0
        ? this.activatedRoute.snapshot.params['id']
        : '';
    this.setEntryFormDataSource = marketingDocument;
    this.setEntryFormDataSourceSAP = marketingDocumentSAP;

    let documentline = new DocumentLinesModel();
    let additionalexpenses = new DocumentAdditionalExpensesModel();
    let TaxExtension = new TaxExtensionModel();
    marketingDocument.documentLines.push(documentline);

    marketingDocument.documentAdditionalExpenses.push(additionalexpenses);
    marketingDocument.taxExtension = TaxExtension;

    if (marketingDocument.docEntry.toString().length > 0) {
      const paginatedForms = ['Purchase Quotation', 'Purchase Request', 'Purchase Order', 'Sales Down Payment Request', 'Sales Quotation', 'Sales Order', 'Delivery Challans', 'Sales Invoice', 'Credit Notes', 'Purchase Down Payment Request', 'GRPO', 'Purchase Invoice', 'Debit Notes', 'Outgoing Payment'];
      if (paginatedForms.includes(this.getFormSubTitle)) {
        this.setRequestDataForFormModeEdit = [
          { Key: "DocEntry", Value: marketingDocument.docEntry.toString(), OperatorType: "contains" },
          { Key: "ItemCode", Value: this.itemCode ? this.itemCode.toString() : "", OperatorType: "startsWith" },
          { Key: "ItemCode", Value: "", OperatorType: "endswith" }
        ];
        this.getRequestData.SortColumn = "ItemDescription";
        this.getRequestData.PageSize = 1;
        this.getRequestData.PageRecordCount = 10;
      } else {
        this.setRequestDataForFormModeEdit = marketingDocument.docEntry;
      }
      this.setFormMode = enumFormModes.ModeEdit;
      this.getRowCountEntry();
      this.setFormDisable = true;
    } else {
      this.setFormMode = enumFormModes.ModeNew;
      // this.addRow();
      this.setFormDisable = false;
    }

    if (
      this.getFormSubTitle == 'Sales Quotation' ||
      this.getFormSubTitle == 'Sales Down Payment Request' ||
      this.getFormSubTitle == 'Purchase Invoice'
    ) {
      this.slaesQuatationForm = true;
    }
    this.PopulateEntryForm_V2();

    if (this.getFormSubTitle == 'Pick Lists') {
      this.copyScreens = [
        {
          name: 'Sales Order',
          routeTo: 'salesOrderEntryForm',
          listEndPoint: 'Orders/GetOrdersListService',
          getEndPoint: 'Orders/GetOrdersService',
        },
      ];
    }

    if (this.getFormSubTitle == 'Debit Notes') {
      this.copyScreens = [
        {
          name: 'Purchase Invoice',
          routeTo: 'purchaseInvoiceEntryForm',
          listEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesListService',
          getEndPoint: 'PurchaseInvoices/GetPurchaseInvoicesService',
        },
      ];
    }

    if (this.getFormSubTitle == 'Purchase Request') {
      this.displayedColumns = [
        'item_srno',
        'item_detail',
        'amount',
      ];
    } else if (this.getFormSubTitle == 'Purchase Order') {
      this.displayedColumns = [
        'item_srno',
        'item_detail',
        'amount',
      ];
    }

    // console.log(' this.activated.url',window.location.pathname)

    let roleType = sessionStorage.getItem('roleType');
    if ((roleType == 'Customer' || roleType == 'Vendor') && this.getFormMode == enumFormModes.ModeNew && (this.getFormSubTitle == 'Sales Order' || this.getFormSubTitle == 'Sales Invoice' || this.getFormSubTitle == 'Sales Quotation' || this.getFormSubTitle == 'Credit Notes' || this.getFormSubTitle == 'Purchase Order' || this.getFormSubTitle == 'GRPO' || this.getFormSubTitle == 'Purchase Invoice' || this.getFormSubTitle == 'Debit Notes' || this.getFormSubTitle == 'Outgoing Payment')) {
      this.cutomerOrVendorDisabled = true;
      let currentUser: any = sessionStorage.getItem('currentUser');
      let user = JSON.parse(currentUser);
      this.getCustomerDetails(user.UserName)

    }


    this.getIntialAPIListForDepartment();
  }




  // ============================================================================
  // ========================= DATA FETCHING & API CALLS =========================
  // ============================================================================

  // ============================================================================
  // ========================= DATA FETCHING & API CALLS =========================
  // ============================================================================
  async getIntialAPIListForDepartment() {
    const payload = new WrapperStandardRequest();
    payload.SortColumn = 'name';
    payload.PageRecordCount = 1000;
    this.generic.PostAPI(
      GlobalProperties.getApiUrl + 'Department/GetDepartmentListService',
      payload
    ).subscribe((res: any) => {
      if (res && res.responseData) {
        this.optionsDepartment = res.responseData;
        this.setDepartmentNameFromList();
      }
    });
  }

  activeLineFilters: any = {};
  selectedFilters: any[] = [];

  async onItemFilter(column: string, from: string, to: string, label: string) {
    const paginatedForms = ['Purchase Quotation', 'Purchase Request', 'Purchase Order', 'Sales Down Payment Request', 'Sales Quotation', 'Sales Order', 'Delivery Challans', 'Sales Invoice', 'Credit Notes', 'Purchase Down Payment Request', 'GRPO', 'Purchase Invoice', 'Debit Notes', 'Outgoing Payment'];
    if (paginatedForms.includes(this.getFormSubTitle)) {
      this.pageNumber = 1;
      this.hasMoreLines = true;
      this.isLoadingMoreLines = false;
      this.getRequestData.SortColumn = "itemDescription";
      this.getRequestData.PageSize = 1;
      this.getRequestData.PageRecordCount = 10;

      this.activeLineFilters[column] = { from, to };

      let chipIndex = this.selectedFilters.findIndex((f: any) => f.label === column);
      if (from || to) {
        let chip = {
          label: column,
          from: from,
          to: to,
          labelType: label
        };
        if (chipIndex >= 0) {
          this.selectedFilters.splice(chipIndex, 1, chip);
        } else {
          this.selectedFilters.push(chip);
        }
      } else {
        if (chipIndex >= 0) {
          this.selectedFilters.splice(chipIndex, 1);
        }
      }

      const filters: any[] = [
        {
          "Key": "DocEntry",
          "Value": this.getEntryFormDataSource.docEntry?.toString() || "",
          "OperatorType": "contains"
        }
      ];

      for (const col of Object.keys(this.activeLineFilters)) {
        const val = this.activeLineFilters[col];
        if (val.from || val.to) {
          filters.push({
            "Key": col,
            "Value": val.from || "",
            "OperatorType": "startsWith"
          });
          filters.push({
            "Key": col,
            "Value": val.to || "",
            "OperatorType": "endswith"
          });
        }
      }

      this.setRequestDataForFormModeEdit = filters;
      this.getRequestData.RequestData = this.setRequestDataForFormModeEdit;

      await this.PopulateEntryForm();
      this.originalDocumentLines = JSON.parse(JSON.stringify(this.getEntryFormDataSource.documentLines || []));
    }
  }

  async onRemoveChip(index: number, item: any) {
    this.selectedFilters.splice(index, 1);
    delete this.activeLineFilters[item.label];

    const filters: any[] = [
      {
        "Key": "DocEntry",
        "Value": this.getEntryFormDataSource.docEntry?.toString() || "",
        "OperatorType": "contains"
      }
    ];

    for (const col of Object.keys(this.activeLineFilters)) {
      const val = this.activeLineFilters[col];
      if (val.from || val.to) {
        filters.push({
          "Key": col,
          "Value": val.from || "",
          "OperatorType": "startsWith"
        });
        filters.push({
          "Key": col,
          "Value": val.to || "",
          "OperatorType": "endswith"
        });
      }
    }

    this.setRequestDataForFormModeEdit = filters;
    this.getRequestData.RequestData = this.setRequestDataForFormModeEdit;

    this.pageNumber = 1;
    this.hasMoreLines = true;
    this.isLoadingMoreLines = false;
    await this.PopulateEntryForm();
    this.originalDocumentLines = JSON.parse(JSON.stringify(this.getEntryFormDataSource.documentLines || []));
  }

  setDepartmentNameFromList() {
    if (this.getEntryFormDataSource && this.getEntryFormDataSource.department && this.optionsDepartment.length > 0) {
      const deptId = Number(this.getEntryFormDataSource.department);
      const matchedDept = this.optionsDepartment.find((d: any) => Number(d.code) === deptId);
      if (matchedDept) {
        this.getEntryFormDataSource.departmentName = matchedDept.name;
      }
    }
  }

  ForPurchaseRequestEntry() {
    this.setURLForFormModeNew = 'PurchaseRequest/NewPurchaseRequestService';
    this.setURLForFormModeEdit = 'PurchaseRequest/GetPurchaseRequestService';
    this.setURLForFormModeAddSap = 'PurchaseRequests';
    this.setURLForFormModeUpdateSap = `PurchaseRequests(${this.activatedRoute.snapshot.params['id']})`;
    this.setListViewFormRouteTo = '/home/sales/purchaseRequestListView/';
    this.setFormSubTitle = 'Purchase Request';
    this.getCustomerVendorTitle = 'Language.RequesterDetailText';
    this.getCustomerVendorCodeText = 'Language.RequesterCodeText';
    this.getCustomerVendorNameText = 'Language.RequesterNameText';
    this.getPurchaseSalesDetailText = 'Language.PurchaseDetailText';
    this.getNotesText = 'Language.VendorNotesText';
    this.copyToScreens = [
      {
        name: 'Purchase Quotation',
        routeTo: 'purchaseQutationEntryForm',
        listEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsListService',
        getEndPoint: 'PurchaseQuotations/GetPurchaseQuotationsService',
      },
      {
        name: 'Purchase Order',
        routeTo: 'purchaseOrderEntryForm',
        listEndPoint: 'PurchaseOrders/GetPurchaseOrdersListService',
        getEndPoint: 'PurchaseOrders/GetPurchaseOrdersService',
      },
    ];
  }

  async setDraftsData(objType: any) {
    await this.getCodeOfApprovalData();

    //call drafts api
    this.generic
      .GetAPIForSAP(
        GlobalProperties.getApiUrlSap + `Drafts(${this.draftEntry})`
      )
      .then(async (res: any) => {
        if (res != null) {

          //wahrehouse ********
          let msg = 'WarehouseCode eq';
          let filter: string = msg;
          if (res.DocumentLines.length > 1) {
            let array = res.DocumentLines.filter(
              (a: { WarehouseCode: any }, i: any) =>
                res.DocumentLines.findIndex(
                  (s: { WarehouseCode: any }) =>
                    a.WarehouseCode === s.WarehouseCode
                ) === i
            );
            array.map((element: any) => {
              filter =
                filter +
                " '" +
                element.WarehouseCode +
                "'" +
                ' ' +
                'or' +
                ' ' +
                msg;
            });
            filter = filter.substring(0, filter.length - 21);
          } else {
            filter = msg + "'" + res.DocumentLines[0].WarehouseCode;
          }
          if (filter)
            await this.generic
              .GetAPIForSAP(
                GlobalProperties.getApiUrlSap +
                `Warehouses?$filter=${filter}'&$select=WarehouseName,WarehouseCode,EnableBinLocations,Location`
              )
              .then(async (data: any) => {
                if (data['@odata.nextLink']) {
                  this.getWarehouseName(data['@odata.nextLink']);
                }
                data.value.forEach((ele: any) => {
                  res.DocumentLines.map(async (element: any, index: number) => {
                    if (element.WarehouseCode == ele.WarehouseCode) {
                      element.WareHouseName = ele.WarehouseName;
                    }
                    //get wh location name
                    await this.getLocationOfWarehouseFromLocId(
                      element.LocationCode,
                      index
                    );
                    //get wh stock
                    await this.getWhareHouseQuantity(index, element);
                    //get item deta
                    await this.getOtherServiceDetails(
                      element,
                      index,
                      element.DocEntry
                    );
                  });
                });
              });

          //Currency , Payment GroupCode ********
          if (res.CardCode !== "" && res.CardCode !== null && res.CardCode !== undefined) {
            const cPayload = new WrapperStandardRequest();
            cPayload.SortColumn = 'cardCode';
            cPayload.RequestData = res.CardCode;

            await this.generic
              .PostAPI(
                GlobalProperties.getApiUrl +
                `BusinessPartner/GetBusinessPartnerService`,
                cPayload
              )
              .subscribe(async (data: any) => {
                //currency
                if (data.responseData.currencyName !== '##') {
                  this.currencyList.push(data.responseData.currencyName);
                }
                this.getEntryFormDataSource.docCurrencyName =
                  data.responseData.currencyName;
                this.getEntryFormDataSource.paymentGroupCodeName =
                  data.responseData.payTermsGrpCodeName;
              });
          }

          // Convert the PascalCase response to camelCase
          const camelCasedData = this.convertPascalToCamelCase(res);
          console.log(camelCasedData);
          this.setEntryFormDataSource = camelCasedData;

          // Fetch HSN details for each line if hsnEntry exists
          this.getEntryFormDataSource.documentLines.forEach((line: any, idx: number) => {
            if (line.hsnEntry) {
              this.getHSNDetailsByEntry(line.hsnEntry, idx);
            }
            if (line.projectCode) {
              this.getProjectDetailsByCode(line.projectCode, idx);
            }
            if (line.costingCode) {
              this.getDistributionDetailsByCode(line.costingCode, idx);
            }
            if (line.lineVendor) {
              this.getLineVendorDetailsByCode(line.lineVendor, idx);
            }
          });

          //set status
          this.getEntryFormDataSource.documentStatusName = 'Open';
          this.getEntryFormDataSource.gstTranTypName = res.GSTTransactionType;

          if (this.getFormSubTitle == 'Purchase Request') {
            this.getEntryFormDataSource.reqTypeName = res.ReqType == 12 ? "User" : "Employee";
            this.getEntryFormDataSource.email = res.RequesterEmail;
            this.getEntryFormDataSource.department = res.RequesterDepartment;
            this.setDepartmentNameFromList();
            console.log(res, 'test data for department?????')
          }
          //place of supply
          if (res.AddressExtension.PurchasePlaceOfSupply) {
            let url = `States?$filter=Code eq '${res.AddressExtension.PurchasePlaceOfSupply}' `;
            if (res.AddressExtension.ShipToCountry) {
              url =
                url + `and Country eq '${res.AddressExtension.ShipToCountry}'`;
            }
            const result = await this.generic.GetAPIForSAP(
              GlobalProperties.getApiUrlSap + url
            );
            this.getEntryFormDataSource.placeOfSupplyCodeName =
              result.value[0].Name;
          }

          //  this.addLineItemWithCondition();
          this.getAttachmentData();
          this.getOtherDetails(res);
          
          this.calculateTotals();
          this.calculateDiscountAmt();
        }
      });
  }

  async getHSNDetailsByEntry(hsnEntry: any, index: number) {
    if (!hsnEntry) return;
    const payloadHSN = new WrapperStandardRequest();
    payloadHSN.RequestData = [
      {
        Key: "absEntry",
        Value: hsnEntry.toString(),
        OperatorType: ">="
      },
      {
        Key: "absEntry",
        Value: hsnEntry.toString(),
        OperatorType: "<="
      }
    ];
    payloadHSN.IsAcending = true;
    payloadHSN.PageSize = 1;
    payloadHSN.PageRecordCount = 10;
    payloadHSN.SortColumn = 'absEntry';

    try {
      const hsnResponse: any = await lastValueFrom(
        this.generic.PostAPI(
          GlobalProperties.getApiUrl + 'HSN/GetHSNListService',
          payloadHSN
        )
      );
      if (hsnResponse && hsnResponse.responseData && hsnResponse.responseData.length > 0) {
        this.getEntryFormDataSource.documentLines[index].chapterID = hsnResponse.responseData[0].chapterID;
        this.getEntryFormDataSource.documentLines[index].hsnEntry = hsnResponse.responseData[0].absEntry;
      }
    } catch (error) {
      console.error('Error fetching HSN:', error);
    }
  }

  async getProjectDetailsByCode(projectCode: any, index: number) {
    if (!projectCode) return;
    const payloadProject = new WrapperStandardRequest();
    payloadProject.RequestData = [
      {
        Key: "code",
        Value: projectCode.toString(),
        OperatorType: "startswith"
      },
      {
        Key: "code",
        Value: "",
        OperatorType: "endswith"
      }
    ];
    payloadProject.IsAcending = true;
    payloadProject.PageSize = 1;
    payloadProject.PageRecordCount = 10;
    payloadProject.SortColumn = 'code';

    try {
      const projectResponse: any = await lastValueFrom(
        this.generic.PostAPI(
          GlobalProperties.getApiUrl + 'Project/GetProjectListService',
          payloadProject
        )
      );
      if (projectResponse && projectResponse.responseData && projectResponse.responseData.length > 0) {
        this.getEntryFormDataSource.documentLines[index].projectName = projectResponse.responseData[0].name;
      }
    } catch (error) {
      console.error('Error fetching Project Details:', error);
    }
  }

  async getDistributionDetailsByCode(costingCode: any, index: number) {
    if (!costingCode) return;
    const payloadDistribution = new WrapperStandardRequest();
    payloadDistribution.RequestData = [
      {
        Key: "code",
        Value: costingCode.toString(),
        OperatorType: "startswith"
      },
      {
        Key: "code",
        Value: "",
        OperatorType: "endswith"
      }
    ];
    payloadDistribution.IsAcending = true;
    payloadDistribution.PageSize = 1;
    payloadDistribution.PageRecordCount = 10;
    payloadDistribution.SortColumn = 'code';

    try {
      const distResponse: any = await lastValueFrom(
        this.generic.PostAPI(
          GlobalProperties.getApiUrl + 'DistributionRules/GetDistributionRulesListService',
          payloadDistribution
        )
      );
      if (distResponse && distResponse.responseData && distResponse.responseData.length > 0) {
        this.getEntryFormDataSource.documentLines[index].ocrCode = distResponse.responseData[0].code;
        this.getEntryFormDataSource.documentLines[index].ocrName = distResponse.responseData[0].name;

      }
    } catch (error) {
      console.error('Error fetching Distribution Details:', error);
    }
  }

  async getLineVendorDetailsByCode(lineVendor: any, index: number) {
    if (!lineVendor) return;
    try {
      const payload = new WrapperStandardRequest();
      payload.RequestData = [
        {
          Key: 'CardCode',
          Value: lineVendor.toString(),
          OperatorType: 'startswith'
        },
        {
          Key: 'CardCode',
          Value: '',
          OperatorType: 'endswith'
        },
        {
          Key: 'valid',
          Value: 'Y',
          OperatorType: 'contains'
        }
      ];
      payload.IsAcending = true;
      payload.PageSize = 1;
      payload.PageRecordCount = 10;
      payload.SortColumn = 'cardCode';

      const bpResponse: any = await lastValueFrom(
        this.generic.PostAPI(
          GlobalProperties.getApiUrl + 'BusinessPartner/GetBusinessPartnerListService',
          payload
        )
      );

      if (bpResponse && bpResponse.responseData && bpResponse.responseData.list && bpResponse.responseData.list.length > 0) {
        this.getEntryFormDataSource.documentLines[index].lineVendorName = bpResponse.responseData.list[0].cardName;
      } else if (bpResponse && bpResponse.responseData && bpResponse.responseData.length > 0) {
        this.getEntryFormDataSource.documentLines[index].lineVendorName = bpResponse.responseData[0].cardName;
      }
    } catch (error) {
      console.error('Error fetching Vendor Name:', error);
    }
  }

  async getOtherServiceDetails(element: any, index: number, docEntry: any) {
    let itemcode = element.ItemCode;
    const payload = new WrapperStandardRequest();
    payload.SortColumn = 'itemName';
    payload.RequestData = [
      { Key: 'itemCode', Value: `${itemcode}`, OperatorType: 'startswith' },
      { Key: 'itemCode', Value: '', OperatorType: 'endswith' },
      { Key: 'validName', Value: `Yes`, OperatorType: 'contains' },
    ];

    await this.generic
      .PostAPI(GlobalProperties.getApiUrl + `Item/GetItemListService`, payload)
      .subscribe(async (data: any) => {
        console.log('data........', data);
        this.itemData.push(...data['responseData']);
        this.itemData.map((ele: any) => {
          this.getEntryFormDataSource.documentLines.map((ele1: any) => {
            if (ele.itemCode == ele1.itemCode) {
              // Only overwrite chapterID from item master if the line doesn't already have an explicit HSNEntry
              if (!ele1.hsnEntry) {
                ele1.chapterID = ele.chapterName;
              }
            }
          });
        });
      });
  }
  async getLocationOfWarehouseFromLocId(LocationID: number, index: number) {
    await this.generic
      .GetAPIForSAP(
        GlobalProperties.getApiUrlSap + `WarehouseLocations(${LocationID})`
      )
      .then(async (res: any) => {
        this.getEntryFormDataSource.documentLines.map((ele1: any) => {
          if (LocationID == ele1.locationCode) {
            this.getEntryFormDataSource.documentLines[index].locationName =
              res.Name;
          }
        });
      });
  }
  async getWhareHouseQuantity(index: number, element: any) {
    const payload = new WrapperStandardRequest();
    payload.SortColumn = 'warehouseCode';
    payload.RequestData = element.ItemCode;

    await this.snackbarService
      .PostAPI(
        `${GlobalProperties.getApiUrl}Item/GetListSAPItemWarehouse`,
        payload
      )
      .subscribe((resp) => {
        let response = resp.responseData;
        let selected = response.filter((item: any) => {
          if (item.warehouseCode == element.WarehouseCode) {
            return item;
          }
        });

        if (selected.length > 0) {
          this.getEntryFormDataSource.documentLines[index].warehouseQuantity =
            selected[0].inStock;
        }
      });
  }
  async getCodeOfApprovalData() {
    await this.generic
      .GetAPIForSAP(
        GlobalProperties.getApiUrlSap +
        `ApprovalRequests?$select=*&$inlinecount=allpages&$filter=Status eq 'arsPending' and DraftEntry eq ${this.draftEntry}`
      )
      .then(async (res: any) => {
        this.selectedCode = res.value?.[0]?.Code;
        // let selected = res.value.filter((item: any) => {
        //   if (item.DraftEntry == this.draftEntry) {
        //     return item;
        //   }
        // });
        // if (selected.length > 0) {
        //   this.selectedCode = selected[0].Code;
        // }
      });
  }
  getWarehouseName(url: string) {
    this.generic.GetAPIForSAP(url).then(async (res: any) => {
      res.value.forEach((item: any) => {
        this.getEntryFormDataSource.documentLines.map((element: any) => {
          if (element.WarehouseCode == item.WarehouseCode) {
            element.WareHouseName = item.WarehouseName;
          }
        });
      });
      if (res['@odata.nextLink']) {
        this.getWarehouseName(res['@odata.nextLink']);
      }
    });
  }
  async getAttachmentData() {
    await this.genAttachUpload.onAttachmentGetFiles(
      this.getEntryFormDataSource.attachmentEntry
    );
    this.getEntryFormDataSource.Attachments2_Lines =
      this.genAttachUpload.getAttactmentListData;
  }
  async getOtherDetails(item: any) {
    // get sales Employee
    this.activated.url.subscribe(async (data) => {
      if (
        data[0].path == 'purchaseQutationEntryForm' ||
        data[0].path == 'purchaseOrderEntryForm' ||
        data[0].path == 'deliveryChallanEntryForm'
      ) {
        if (this.getFormMode == 1) {
          this.getEntryFormDataSource.salesPersonCodeName =
            item.SalesPersonCode;
        } else {
          if (item.SalesPersonCode != null) {
            await this.generic
              .GetAPIForSAP(
                GlobalProperties.getApiUrlSap +
                `SalesPersons(${item.SalesPersonCode})?$select=SalesEmployeeName`
              )
              .then(async (info: any) => {
                this.getEntryFormDataSource.salesPersonCodeName =
                  info.SalesEmployeeName;
              });
          }
        }
      } else {
        if (item.SalesPersonCode != null) {
          await this.generic
            .GetAPIForSAP(
              GlobalProperties.getApiUrlSap +
              `SalesPersons(${item.SalesPersonCode})?$select=SalesEmployeeName`
            )
            .then(async (info: any) => {
              this.getEntryFormDataSource.salesPersonCodeName =
                info.SalesEmployeeName;
            });
        }
      }
    });
    //branch
    await this.generic
      .GetAPIForSAP(
        GlobalProperties.getApiUrlSap +
        `BusinessPlaces(${item.BPL_IDAssignedToInvoice})`
      )
      .then(async (info: any) => {
        console.log('test');
        console.log(info);
        this.getEntryFormDataSource.branchName = info.BPLName;
        this.getEntryFormDataSource.vatRegNum = info.FederalTaxID;
      });
    //series
    var body = {
      SeriesParams: { Series: item.Series },
    };
    await this.generic
      .PostAPIForSAP(
        GlobalProperties.getApiUrlSap + `SeriesService_GetSeries`,
        body
      )
      .then(async (info: any) => {
        this.getEntryFormDataSource.seriesName = info.Name;
      });
    // get contact person name
    var names: any[] = [];
    if (item.CardCode != "" && item.CardCode != null && item.CardCode != undefined) {
      await this.generic
        .GetAPIForSAP(
          GlobalProperties.getApiUrlSap +
          `BusinessPartners('${item.CardCode}')?$select=ContactEmployees`
        )
        .then(async (info: any) => {
          if (info && info.ContactEmployees) {
            info.ContactEmployees.map((persons: any) => {
              if (persons.InternalCode == item.ContactPersonCode) {
                names.push(persons.Name);
                return;
              }
              this.getEntryFormDataSource.contactPersonCodeName = names[0];
            });
          }
        });
    }
  }
  // Utility function to convert PascalCase to camelCase
  convertPascalToCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.convertPascalToCamelCase(item)); // Recursively convert for arrays
    } else if (obj !== null && typeof obj === 'object') {
      const result: any = {};
      Object.keys(obj).forEach((key) => {
        if (key === 'Attachments2_Lines') {
          // Keep the `Attachments2_Lines` field as is
          result[key] = obj[key];
        } else if (key === 'VATRegNum') {
          result['vatRegNum'] = this.convertPascalToCamelCase(obj[key]);
        } else if (key === 'HSNEntry') {
          result['hsnEntry'] = this.convertPascalToCamelCase(obj[key]);
        } else {
          // Convert PascalCase to camelCase for other fields
          const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
          result[camelKey] = this.convertPascalToCamelCase(obj[key]); // Recursively apply for nested objects
        }
      });
      return result;
    }
    return obj; // If the value is not an object or array, return it as is
  }

  openCommentDialog(action: string, code: any, status: any): void {
    const dialogRef = this.dialog.open(CommentDialogComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        console.log(`${action} Comment:`, result);
        // You can send the comment to the server or handle it as needed
        this.callApproveRejectSAPRequestAPI(code, status, result);
      }
    });
  }

  // ============================================================================
  // ========================= UI EVENTS & APPROVAL WORKFLOW =========================
  // ============================================================================

  // ============================================================================
  // ========================= UI EVENTS & APPROVAL WORKFLOW =========================
  // ============================================================================
  async onApproveClick(event: Event) {
    this.openCommentDialog('Approve', this.selectedCode, 'ardApproved');
  }
  async onRejectClick(event: Event) {
    this.openCommentDialog('Reject', this.selectedCode, 'ardNotApproved');
  }
  async callApproveRejectSAPRequestAPI(code: any, status: any, remarks: any) {
    let body = {
      ApprovalRequestDecisions: [
        {
          Status: status,
          Remarks: remarks, //"Approved - OK"
        },
      ],
    };
    await this.generic
      .PatchAPIForSAP(
        GlobalProperties.getApiUrlSap + `ApprovalRequests(${code})`,
        body
      )
      .then(async (info: any) => {
        if (status === 'ardApproved') {
          try {
            await this.generic.PostApiForSaveDocument(GlobalProperties.getApiUrlSap + `DraftsService_SaveDraftToDocument`, {
              "Document": {
                "DocEntry": this.draftEntry
              }
            });
          } catch (e) {
            console.error('Save Draft to Document failed', e);
          }
          this.snackbarService.showMessage(
            'Request has been approved successfully!',
            'X'
          );
        } else if (status === 'ardNotApproved') {
          this.snackbarService.showMessage(
            'Request has been rejected successfully!',
            'X'
          );
        }
        this.router.navigate([this.getListViewFormRouteTo]);
      });
  }
  // determineModel(): PickListsModel | IMarketingDocument {
  //   if ( this.getFormTitle =="Pick Lists") {
  //     return {} as PickListsModel; // Initialize as type 'a'
  //   } else {
  //     return {} as IMarketingDocument; // Initialize as type 'b'
  //   }
  // }
  // async PopulateEntryForm_V2() {
  //   await this.PopulateEntryForm();
  //   if (this.getFormMode == 0) {
  //     this.getEntryFormDataSource.bpL_IDAssignedToInvoice = Number(localStorage.getItem("BranchId"));
  //     this.getEntryFormDataSource.branchName = String(localStorage.getItem("BranchName"));
  //   }
  //   else {
  //     await this.genAttachUpload.onAttachmentGetFiles(this.getEntryFormDataSource.attachmentEntry);
  //     this.getEntryFormDataSource.Attachments2_Lines = this.genAttachUpload.getAttactmentListData;
  //   }

  override async PopulateEntryForm() {
    const paginatedForms = ['Purchase Quotation', 'Purchase Request', 'Purchase Order', 'Sales Down Payment Request', 'Sales Quotation', 'Sales Order', 'Delivery Challans', 'Sales Invoice', 'Credit Notes', 'Purchase Down Payment Request', 'GRPO', 'Purchase Invoice', 'Debit Notes', 'Outgoing Payment'];
    if (paginatedForms.includes(this.getFormSubTitle)) {
      let aUrl = "";
      if (this.getFormMode == 0) {
        aUrl = this.getURLForFormModeNew;
        this.btnText = 'Language.AddText';
        this.getRequestData.RequestData = this.getRequestDataForFormModeNew;
      } else if (this.getFormMode == 1) {
        aUrl = this.getURLForFormModeEdit;
        this.btnText = 'Language.UpdateText';
        this.getRequestData.RequestData = this.getRequestDataForFormModeEdit;
      }

      if (aUrl.trim().length > 0) {
        // By using PostApiForSaveDocument and passing this.getRequestData DIRECTLY,
        // we ensure SortColumn is preserved and not blanked out!
        let result = this.agenericRepository.PostApiForSaveDocument(aUrl, this.getRequestData);
        return result.then((res: any) => {
          let data = res.responseData;
          if (Array.isArray(data) && data.length > 0) {
            data = data[0];
          }
          if (data) {
            if (!data.documentLines) {
              data.documentLines = [];
            }
            this.setEntryFormDataSource = data;
          }
          this.setRowCount = res.rowCount;
          if (data && data.documentLines) {
            this.rowCount = data.documentLines.length;
          }
          return res;
        });
      }
      return null;
    } else {
      // For all other forms, stick to the standard logic!
      return super.PopulateEntryForm();
    }
  }

  async PopulateEntryForm_V2() {
    if (
      (this.getFormSubTitle == 'Pick Lists' && this.getFormMode == 1) ||
      this.getFormSubTitle != 'Pick Lists'
    ) {
      this.pageNumber = 1;
      this.hasMoreLines = true;
      this.isLoadingMoreLines = false;
      this.getRequestData.SortColumn = "itemDescription";
      await this.PopulateEntryForm();
      this.originalDocumentLines = JSON.parse(JSON.stringify(this.getEntryFormDataSource.documentLines || []));
    }

    if (this.getFormSubTitle == 'Purchase Request' && this.getEntryFormDataSource.department) {
      this.setDepartmentNameFromList();
    }
    console.log(
      'documentadditional',
      this.getEntryFormDataSource.documentAdditionalExpenses
    );
    await this.genAttachUpload.onAttachmentGetFiles(
      this.getEntryFormDataSource.attachmentEntry
    );
    this.getEntryFormDataSource.Attachments2_Lines =
      this.genAttachUpload.getAttactmentListData;

    if (this.getFormSubTitle == 'Sales Invoice' && this.getFormMode == 1) {
      this.eWayTabComp.getEwayBill(this.getEntryFormDataSource.docEntry);
    }

    if (
      (this.getFormSubTitle == 'Sales Invoice' ||
        this.getFormSubTitle == 'Credit Notes') &&
      this.getFormMode == 1
    ) {
      const payload = new WrapperStandardRequest();
      console.log(this.getEntryFormDataSource);
      payload.RequestData = this.getEntryFormDataSource.cardCode;
      const customerResponse = await lastValueFrom(
        this.agenericRepositoryForCfl.PostAPI(
          GlobalProperties.getApiUrl +
          'BusinessPartner/GetBusinessPartnerService',
          payload
        )
      );
      this.checkNonIRNCustomer(customerResponse.responseData);
      this.getEinvoiceData(this.getEntryFormDataSource);
    }

    if (
      this.getEntryFormDataSource.documentStatus == 'C' ||
      (this.getEntryFormDataSource.documentStatus == 'O' &&
        this.getFormMode == 1 &&
        this.getFormSubTitle == 'Sales Invoice') ||
      ((this.getFormSubTitle == 'Delivery Challans' ||
        this.getFormSubTitle == 'GRPO' ||
        this.getFormSubTitle == 'Sales Invoice' ||
        this.getFormSubTitle == 'Purchase Invoice' ||
        this.getFormSubTitle == 'Credit Notes' ||
        this.getFormSubTitle == 'Debit Notes') &&
        this.getFormMode == 1)
    ) {
      this.date.disable();
    }

    if (this.getFormSubTitle == 'Pick Lists' && this.getFormMode == 1) {
      const documentLines: DocumentLinesModel[] = [];
      this.getEntryFormDataSource.pickListsLines.forEach((item: any) => {
        this.getEntryFormDataSource.cardCode = item.cardCode;
        this.getEntryFormDataSource.cardName = item.cardName;
        const documentLineItem = new DocumentLinesModel();
        documentLineItem.shipDate = new Date(
          this.getEntryFormDataSource.docDueDate
        );
        documentLineItem.itemCode = item.itemCode;
        documentLineItem.itemDescription = item.itemDescription;
        documentLineItem.quantity = item.pickedQuantity;
        documentLineItem.docNum = item.docNum;
        documentLineItem.unitPrice = item.unitPrice;
        //   documentLineItem.docEntry = item.docEntry;
        documentLineItem.warehouseCode = item.warehouseCode;
        documentLineItem.wareHouseName = item.warehouseName;
        documentLineItem.uoMEntry = item.uoMEntry;
        documentLineItem.uoMCode = item.uomCode;
        documentLineItem.taxCode = item.taxCode;
        documentLines.push(documentLineItem);
      });
      this.getEntryFormDataSource.documentLines = [...documentLines];
      this.getEntryFormDataSource.docNum =
        this.getEntryFormDataSource.absoluteentry;
      this.getEntryFormDataSource.docDate =
        this.getEntryFormDataSource.pickDate;
    }
    // this.prepareDocumentForChanges()
    if (
      this.getFormSubTitle == 'Sales Order' ||
      this.getFormSubTitle == 'Debit Notes' ||
      this.getFormSubTitle == 'Delivery Challans' ||
      this.getFormSubTitle == 'Sales Invoice' ||
      this.getFormSubTitle == 'Pick Lists' ||
      this.getFormSubTitle == 'Delivery Challans'
    ) {
      this.getEntryFormDataSource.documentLines.forEach((el, i) => {
        if (el.batchNumbers && el.batchNumbers.filter((el) => el).length > 0) {
          (el as any)['manageBatchNumbers'] = 'Y';
        }
        if (
          el.serialNumbers &&
          el.serialNumbers.filter((el) => el).length > 0
        ) {
          (el as any)['manageSerialNumbers'] = 'Y';
        }

        if (el.batchNumbers && el.batchNumbers.filter((el) => el).length == 0) {
          (el.batchNumbers as any) = null;
        }
        if (
          el.serialNumbers &&
          el.serialNumbers.filter((el) => el).length == 0
        ) {
          (el.serialNumbers as any) = null;
        }
        el.lineTotal = el.quantity * (el.price as any);
      });
    } else {
      this.getEntryFormDataSource.documentLines.forEach((el, i) => {
        if (el.batchNumbers && el.batchNumbers.filter((el) => el).length > 0) {
          el['manageBatchNumbers'] = 'Y';
          el.batchNumbers.forEach((el: any) => {
            el.quantity = Math.abs(el.quantity);
          });
        }
        if (
          el.serialNumbers &&
          el.serialNumbers.filter((el) => el).length > 0
        ) {
          el['manageSerialNumbers'] = 'Y';
          el.serialNumbers.forEach((el: any) => {
            el.quantity = Math.abs(el.quantity);
          });
        }

        if (el.batchNumbers && el.batchNumbers.filter((el) => el).length == 0) {
          (el.batchNumbers as any) = null;
        }
        if (
          el.serialNumbers &&
          el.serialNumbers.filter((el) => el).length == 0
        ) {
          (el.serialNumbers as any) = null;
        }
      });
    }

    if (this.getFormMode == 0) {
      this.getEntryFormDataSource.rounding = 'false';

      const copyToScreenState = history.state;
      console.log('copyToscreenstate', copyToScreenState);
      if (copyToScreenState.copyFromEndPoint) {
        const docEntry = copyToScreenState.docEntry;
        this.setURLForFormModeEdit = copyToScreenState.copyFromEndPoint;
        const paginatedForms = ['Purchase Quotation', 'Purchase Request', 'Purchase Order', 'Sales Down Payment Request', 'Sales Quotation', 'Sales Order', 'Delivery Challans', 'Sales Invoice', 'Credit Notes', 'Purchase Down Payment Request', 'GRPO', 'Purchase Invoice', 'Debit Notes', 'Outgoing Payment'];
        if (paginatedForms.includes(this.getFormSubTitle)) {
          this.setRequestDataForFormModeEdit = [
            { Key: "DocEntry", Value: docEntry.toString(), OperatorType: "contains" },
            { Key: "ItemCode", Value: this.itemCode ? this.itemCode.toString() : "", OperatorType: "startsWith" },
            { Key: "ItemCode", Value: "", OperatorType: "endswith" }
          ];
          this.getRequestData.SortColumn = "ItemDescription";
          this.getRequestData.PageSize = 1;
          this.getRequestData.PageRecordCount = 10;
        } else {
          this.setRequestDataForFormModeEdit = docEntry.toString();
        }
        this.setFormMode = enumFormModes.ModeEdit;
        await this.PopulateEntryForm();
        // this.preapreDocumentForCopy();
        console.log('geteNTY', this.getEntryFormDataSource);
        let docnum = this.getEntryFormDataSource.docNum;
        let objectType = this.getEntryFormDataSource.objType;
        this.setFormMode = enumFormModes.ModeNew;
        this.btnText = 'Language.AddText';
        this.setFormDisable = false;
        for (
          let i = 0;
          i < this.getEntryFormDataSource.documentLines.length;
          i++
        ) {
          //  this.onOpenDropDown('taxCode',i)
          this.getEntryFormDataSource.documentLines[i].baseRef = docnum;
          this.getEntryFormDataSource.documentLines[i].baseType = objectType;
          this.getEntryFormDataSource.documentLines[i].baseLine =
            this.getEntryFormDataSource.documentLines[i].lineNum;
          this.getEntryFormDataSource.documentLines[i].baseEntry =
            this.getEntryFormDataSource.documentLines[i].docEntry;
          this.getEntryFormDataSource.documentLines[i].openQty =
            this.getEntryFormDataSource.documentLines[i].openQty;
          this.getEntryFormDataSource.documentLines[i].quantity =
            this.getEntryFormDataSource.documentLines[i].openQty;
          if (this.getEntryFormDataSource.documentLines[i].openCreQty == 0) {
            // this.getEntryFormDataSource.documentStatus="C";
          }
          this.addtex(this.getEntryFormDataSource.documentLines[i]);
          if (this.getEntryFormDataSource.documentLines[i].openQty == 0) {
            this.getEntryFormDataSource.documentLines.splice(i, 1);
            i--;
          }
          // this.changeQuantityByItem(this.getEntryFormDataSource.documentLines[i],this.getEntryFormDataSource.documentLines[i],i,this.getEntryFormDataSource.documentLines[i].quantity,true)
        }
        this.getEntryFormDataSource.comments = copyToScreenState.docInfo;

        // Do not map or populate the source Doc. Series in the target document
        delete (this.getEntryFormDataSource as any).series;
        delete (this.getEntryFormDataSource as any).seriesName;
      } else {
        for (
          let i = 0;
          i < this.getEntryFormDataSource.documentLines.length;
          i++
        ) {
          delete this.getEntryFormDataSource.documentLines[i].baseRef;
          delete this.getEntryFormDataSource.documentLines[i].baseType;
          delete this.getEntryFormDataSource.documentLines[i].baseLine;
          delete this.getEntryFormDataSource.documentLines[i].baseEntry;
        }
      }

      this.getEntryFormDataSource.docDate = new Date();
      this.getEntryFormDataSource.docDueDate = new Date();
      this.getEntryFormDataSource.taxDate = new Date();
      this.getEntryFormDataSource.originalRefDate = new Date();
      this.getEntryFormDataSource.requriedDate = new Date();

      const requestBody = new WrapperStandardRequest();
      requestBody.SortColumn = 'branchName';
      const branchListResponse = await lastValueFrom(
        this.agenericRepositoryForCfl.PostAPI(
          GlobalProperties.getApiUrl + 'Branch/GetBranchListService',
          requestBody
        )
      );
      // console.log('branchess-----------',branchListResponse.responseData)
      this.branchList = branchListResponse.responseData;
      this.getBranchAndSeries();
    }
    if (this.getFormMode == 1) {
      // this.getEntryFormDataSource.bpL_IDAssignedToInvoice = Number(localStorage.getItem("BranchId"));
      // this.getEntryFormDataSource.branchName = String(localStorage.getItem("BranchName"));

      const copyToScreenState = history.state;
      // console.log("copyToscreenstate",copyToScreenState);
      if (copyToScreenState.copyFromEndPoint) {
        const docEntry = copyToScreenState.docEntry;
        this.setURLForFormModeEdit = copyToScreenState.copyFromEndPoint;
        const paginatedForms = ['Purchase Quotation', 'Purchase Request', 'Purchase Order', 'Sales Down Payment Request', 'Sales Quotation', 'Sales Order', 'Delivery Challans', 'Sales Invoice', 'Credit Notes', 'Purchase Down Payment Request', 'GRPO', 'Purchase Invoice', 'Debit Notes', 'Outgoing Payment'];
        if (paginatedForms.includes(this.getFormSubTitle)) {
          this.setRequestDataForFormModeEdit = [
            { Key: "DocEntry", Value: docEntry.toString(), OperatorType: "contains" },
            { Key: "ItemCode", Value: this.itemCode ? this.itemCode.toString() : "", OperatorType: "startsWith" },
            { Key: "ItemCode", Value: "", OperatorType: "endswith" }
          ];
          this.getRequestData.SortColumn = "ItemDescription";
          this.getRequestData.PageSize = 1;
          this.getRequestData.PageRecordCount = 10;
        } else {
          this.setRequestDataForFormModeEdit = docEntry.toString();
        }
        this.setFormMode = enumFormModes.ModeEdit;
        await this.PopulateEntryForm();
        // this.preapreDocumentForCopy();
        this.setFormMode = enumFormModes.ModeNew;
        this.btnText = 'Language.AddText';
        let docnum = this.getEntryFormDataSource.docNum;
        let objectType = this.getEntryFormDataSource.objType;
        this.setFormDisable = true;

        // Auto-fill vendor for Purchase Order from Purchase Request
        if (!this.getEntryFormDataSource.cardCode && this.getFormSubTitle === 'Purchase Order' && copyToScreenState.copyFromEndPoint?.includes('PurchaseRequest') && this.getEntryFormDataSource.documentLines && this.getEntryFormDataSource.documentLines.length > 0) {
          const vendorCode = this.getEntryFormDataSource.documentLines[0].lineVendor;
          if (vendorCode) {
            await this.autoPopulateVendor(vendorCode);
          }
        }

        for (
          let i = 0;
          i < this.getEntryFormDataSource.documentLines.length;
          i++
        ) {
          // this.onOpenDropDown('taxCode',i)
          this.getEntryFormDataSource.documentLines[i].baseRef = docnum;
          this.getEntryFormDataSource.documentLines[i].baseType = objectType;
          this.getEntryFormDataSource.documentLines[i].baseLine =
            this.getEntryFormDataSource.documentLines[i].lineNum;
          this.getEntryFormDataSource.documentLines[i].baseEntry =
            this.getEntryFormDataSource.documentLines[i].docEntry;
          this.getEntryFormDataSource.documentLines[i].openQty =
            this.getEntryFormDataSource.documentLines[i].openQty;
          this.addtex(this.getEntryFormDataSource.documentLines[i]);
          this.getEntryFormDataSource.documentLines[i].quantity =
            this.getEntryFormDataSource.documentLines[i].openQty;
          if (this.getEntryFormDataSource.documentLines[i].openCreQty == 0) {
            // this.getEntryFormDataSource.documentStatus="C";
          }
          if (this.getEntryFormDataSource.documentLines[i].openQty == 0) {
            this.getEntryFormDataSource.documentLines.splice(i, 1);
            i--;
          }
          // this.changeQuantityByItem(this.getEntryFormDataSource.documentLines[i],this.getEntryFormDataSource.documentLines[i],i,this.getEntryFormDataSource.documentLines[i].quantity,true)
        }
      } else {
        if (this.getFormSubTitle != 'Sales Invoice') {
          for (
            let i = 0;
            i < this.getEntryFormDataSource.documentLines.length;
            i++
          ) {
            delete this.getEntryFormDataSource.documentLines[i].baseRef;
            //  delete this.getEntryFormDataSource.documentLines[i].baseType;
            delete this.getEntryFormDataSource.documentLines[i].baseLine;
            delete this.getEntryFormDataSource.documentLines[i].baseEntry;
          }
        }
      }
      if (this.getEntryFormDataSource.rounding == 'Y') {
        this.getEntryFormDataSource.rounding = 'true';
      } else {
        this.getEntryFormDataSource.rounding = 'false';
      }
      //  this.getBranchAndSeries()
    }

    if (this.getFormMode == 0 && this.getEntryFormDataSource.documentLines && this.getEntryFormDataSource.documentLines.length > 0) {
      (this.getEntryFormDataSource.documentLines[0] as any).requiredDate = new Date();
      this.getEntryFormDataSource.documentLines = [...this.getEntryFormDataSource.documentLines];
    }
  }

  // ngOninit(){
  //   if (enumMarketingDocumentEntryForm.GRPOEntryForm) {
  //     this.vendorOrCustomer = 'Vendor';
  //   } else {
  //     this.vendorOrCustomer = 'Customer';
  //   }
  // }
  onValidate(): boolean {
    let lreturn: boolean = true;
    let value = [];
    let data: any = this.getEntryFormDataSource;
    if (this.getFormSubTitle != 'Purchase Request') {
      !data.cardCode || data.cardCode.length == 0
        ? value.push(enumErrorMessageText.cardCodeStatus)
        : null;
    } else {
      !data.requester ? value.push(enumErrorMessageText.requesterStatus) : null;
    }
    !data.seriesName || data.seriesName.length == 0
      ? value.push(enumErrorMessageText.seriesNameStatus)
      : null;

    // data.branchName == 0 || data.branchName == null
    //   ? value.push(enumErrorMessageText.bplNameStatus)
    //   : null;
    if (this.getFormSubTitle != 'Purchase Request') {
      !data.paymentGroupCodeName
        ? value.push(enumErrorMessageText.paymentTermsStatus)
        : null;
      data.cardName == 0 || data.cardName == null
        ? value.push(enumErrorMessageText.cardNameStatus)
        : null;
    }
    data.docDate == 0 || data.docDate == null
      ? value.push(enumErrorMessageText.docDateStatus)
      : null;
    data.docDueDate == 0 || data.docDueDate == null
      ? value.push(enumErrorMessageText.docDueDateStatus)
      : null;
    data.taxDate == 0 || data.taxDate == null
      ? value.push(enumErrorMessageText.taxDateStatus)
      : null;
    data.documentLines.forEach((element: any, index: number) => {
      // element.itemDescription == null || element.itemDescription == ''
      //   ? value.push(
      //     enumErrorMessageText.itemNameStatus + ' Row ' + (index + 1)
      //   )
      //   : null;
      element.itemCode == null || element.itemCode == ''
        ? value.push(
          enumErrorMessageText.itemCodeStatus + ' Row ' + (index + 1)
        )
        : null;
      element.quantity == 0 || element.quantity == null
        ? value.push(
          enumErrorMessageText.quantityStatus + ' Row ' + (index + 1)
        )
        : null;
      ((this.getFormSubTitle == 'Purchase Request' ? element.requiredDate : element.shipDate) == 0 || (this.getFormSubTitle == 'Purchase Request' ? element.requiredDate : element.shipDate) == null)
        ? value.push(
          (this.getFormSubTitle == 'Purchase Request' ? 'Required Date is empty' : enumErrorMessageText.deliveryDateStatus) + ' Row ' + (index + 1)
        )
        : null;
      if (element.itemCode != '') {
        element.wareHouseName == '' || element.wareHouseName == null
          ? value.push(
            enumErrorMessageText.warehouseCodeStatus +
            ' Row ' +
            (index + 1) +
            ' For Item ' +
            element.itemCode
          )
          : null;
        // element.taxCode == null || element.taxCode == ''
        //   ? value.push(
        //     enumErrorMessageText.taxCodeStatus +
        //     ' Row ' +
        //     (index + 1) +
        //     ' For Item ' +
        //     element.itemCode
        //   )
        //   : null;
      }
    });
    this.showValidationArr = value;
    this.title = this.getFormSubTitle;
    this.showValidationArr = value;
    if (this.showValidationArr.length != 0) {
      lreturn = false;
    }
    return lreturn;
  }

  showEwayBillAlert(message: any, event: string) {
    const dialogRef = this.dialog.open(EWayAlertPopupComponent, {
      // width: '640px',
      disableClose: true,
      data: {
        title: 'E-Way Bill Generation',
        message: message,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        if (result == true) {
          this.isBoolGenerateewayBill = true;
          if (this.eWayTabComp.transportCode == '') {
            this.snackbarService.showMessage(
              'Please fill E-WayBill data in Electronics Document tab.',
              'X'
            );
          } else {
            this.onSave(event);
          }
        } else if (result == false) {
          this.isBoolGenerateewayBill = false;
          this.onSave(event);
        }
      }
    });
  }

  onBeforeSave(aEvent: any) {

    if (
      this.getFormSubTitle == 'Sales Invoice' &&
      (this.eWayTabComp.setTransportCode() == null ||
        this.eWayTabComp.setTransportCode() ==
        '') /*this.eWayTabComp.transportCode == ""*/
    ) {
      this.showEwayBillAlert(
        'Do you want to generate E-WayBill now or later?',
        aEvent
      );
    } else {
      //(this.ordersDetails['EWayBillDetails']['EWayBillNo']!=""&&this.ordersDetails['EWayBillDetails']['EWayBillNo']!=null)  &&
      if (
        this.getFormSubTitle == 'Sales Invoice' &&
        this.eWayTabComp.setTransportCode() != null &&
        this.eWayTabComp.setTransportCode() !=
        '' /*this.eWayTabComp.transportCode != ""*/
      ) {
        this.isBoolGenerateewayBill = true;
      }
      this.onSave(aEvent);
    }
  }


  // ============================================================================
  // ========================= DATA SAVING & VALIDATION =========================
  // ============================================================================

  // ============================================================================
  // ========================= DATA SAVING & VALIDATION =========================
  // ============================================================================
  async onSave(aEvent: any) {

    // debugger;
    let data: any = sessionStorage.getItem('currentUser');
    let curretUserInfo = JSON.parse(data);
    delete this.getEntryFormDataSource.docTotal;
    this.getEntryFormDataSource.U_B1User = curretUserInfo.UserName


    if (
      this.getFormMode == 1 &&
      (this.getFormSubTitle == 'Sales Invoice' ||
        this.getFormSubTitle == 'Credit Notes' ||
        this.getFormSubTitle == 'Delivery Challans' ||
        this.getFormSubTitle == 'Purchase Invoice' ||
        this.getFormSubTitle == 'Debit Notes')
    ) {
      this.getEntryFormDataSource.documentLines = [];
      if (
        this.getFormSubTitle == 'Credit Notes' ||
        this.getFormSubTitle == 'Purchase Invoice' ||
        this.getFormSubTitle == 'Debit Notes'
      ) {
        delete this.getEntryFormDataSource.series;
      }
    }
    if (this.getFormSubTitle == 'Purchase Order') {
      this.getEntryFormDataSource.taxExtension = '';
    }

    if (this.btnText == 'Language.OkText') {
      this.routerForCfl.navigate([this.getListViewFormRouteTo]);
    } else {
      if (
        this.getFormSubTitle != 'Pick Lists' &&
        this.getFormSubTitle != 'Purchase Request' &&
        this.getFormSubTitle != 'Purchase Down Payment Request' &&
        this.getFormSubTitle != 'Sales Down Payment Request'
      ) {
        if (this.onValidate()) {
          var pipe = new DatePipe('en-US');
          createMap(
            mapper,
            BatchNumbersModel,
            BatchNumbersModelSAP,
            forMember(
              (dest) => dest.BatchNumber,
              mapFrom((src) => src.batchNumber)
            ),
            forMember(
              (dest) => dest.Quantity,
              mapFrom((src) => src.quantity)
            ),
            forMember(
              (dest) => dest.ItemCode,
              mapFrom((src) => src.itemCode) // Handling case difference
            ),
            forMember(
              (destination) => destination.BatchNumberProperty,
              mapFrom((source) => source.batchNumberProperty)
            ),
            forMember(
              (destination) => destination.ManufacturingDate,
              mapFrom((source) => source.manufacturingDate)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),
            forMember(
              (destination) => destination.AddmisionDate,
              mapFrom((source) => source.addmisionDate)
            ),
            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            )
          );

          createMap(
            mapper,
            SerialNumbersModel,
            SerialNumbersModelSAP,
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            ),
            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),
            forMember(
              (destination) => destination.ManufactureDate,
              mapFrom((source) => source.manufactureDate)
            ),
            forMember(
              (destination) => destination.ReceptionDate,
              mapFrom((source) => source.receptionDate)
            ),
            forMember(
              (destination) => destination.BaseLineNumber,
              mapFrom((source) => source.baseLineNumber)
            ),
            // forMember(
            //   (destination) => (destination.SystemSerialNumber),
            //   mapFrom((source) => (source.systemSerialNumber))
            // ),
            forMember(
              (destination) => destination.Quantity,
              mapFrom((source) => source.quantity)
            ),
            forMember(
              (destination) => destination.ItemCode,
              mapFrom((source) => source.itemCode)
            ),
            forMember(
              (destination) => destination.WareHouseCode,
              mapFrom((source) => source.wareHouseCode)
            ),
            forMember(
              (destination) => destination.WareHouseName,
              mapFrom((source) => source.wareHouseName)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),

            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            )
          );
          createMap(
            mapper,
            MarketingDocument,
            MarketingDocumentSAP,
            forMember(
              (destination) => destination.DownPaymentType,
              mapFrom((source) => source.downPaymentType)
            )
          );
          console.log(
            'this.getEntryFormDataSource',
            this.getEntryFormDataSource
          );
          if (this.checkIfEway()) {
            this.setElectronicProtocolData(this.getEntryFormDataSource);
          }
          let dto = mapper.map(
            this.getEntryFormDataSource,
            MarketingDocument,
            MarketingDocumentSAP
          );

          dto.U_TIBuyDt = pipe.transform(dto.U_TIBuyDt, 'y-MM-d');
          dto.U_SODATE = pipe.transform(dto.U_SODATE, 'y-MM-d');
          dto.U_TIShipDt = pipe.transform(dto.U_TIShipDt, 'y-MM-d');

          if (dto.DocumentLines?.length) {
            dto.DocumentLines.forEach((el: any, i: number) => {
              // dto.DocumentLines![i].AccountCode = "130000",
              //dto.DocumentLines[i].ShipDate = pipe.transform(dto.DocDueDate, 'y-MM-d'),
              (dto.DocumentLines![i].ShipDate = pipe.transform(
                dto.DocumentLines![i].ShipDate,
                'y-MM-d'
              )),

                (dto.DocumentLines![i].RemainingOpenQuantity =
                  dto.DocumentLines![i].Quantity);
            });
          }
          if (this.getFormSubTitle == 'Purchase Quotation') {
            dto.RequriedDate = pipe.transform(dto.DocDueDate, 'y-MM-d');
          }
          let objectType = '';
          // if (this.getFormSubTitle == "Purchase Order") {
          //   objectType = "22";
          // }
          if (this.getFormSubTitle == 'Purchase Down Payment Request') {
            delete dto.TaxExtension;
            objectType = '204';
          } else if (this.getFormSubTitle == 'Debit Notes') {
            delete dto.TaxExtension;
            objectType = '19';
          }
          if (this.getFormSubTitle == 'Sales Order') {
            objectType = '17';


            // dto = {
            //   ...dto,
            //   ...this.myForm.value
            // };

            // dto.DocumentLines?.forEach((res,index)=>{

            //    if (dto.DocumentLines && dto.DocumentLines[index]) {
            //      Object.assign(dto.DocumentLines[index], this.lineLevelFormGroupArray[index].value);
            //    }

            //   })



          } else if (this.getFormSubTitle == 'Sales Invoice') {
            objectType = '13';
          } else if (this.getFormSubTitle == 'Sales Quotation') {
            objectType = '23';
          } else if (this.getFormSubTitle == 'Purchase Order') {
            delete dto.TaxExtension;
            objectType = '22';
          } else if (this.getFormSubTitle == 'Purchase Quotation') {
            delete dto.TaxExtension;
            objectType = '540000006';
          } else if (this.getFormSubTitle == 'Purchase Invoice') {
            delete dto.TaxExtension;
            delete dto.DocumentAdditionalExpenses;
            objectType = '18';
            delete dto.RequriedDate;
          } else if (this.getFormSubTitle == 'GRPO') {
            delete dto.TaxExtension;
            objectType = '20';
          } else if (this.getFormSubTitle == 'Purchase Request') {
            delete dto.TaxExtension;
            objectType = '1470000113';
          } else if (this.getFormSubTitle == 'Delivery Challans') {
            objectType = '15';
          } else if (this.getFormSubTitle == 'Credit Notes') {
            objectType = '14';
          } else if (this.getFormSubTitle == 'Sales Down Payment Request') {
            objectType = '203';
          }
          dto.ObjectType = objectType;
          dto.DownPaymentType = 'dptRequest';
          (dto.TaxDate = pipe.transform(dto.TaxDate, 'y-MM-d')),
            (dto.DocDate = pipe.transform(dto.DocDate, 'y-MM-d')),
            (dto.DocDueDate = pipe.transform(dto.DocDueDate, 'y-MM-d')),
            (dto.OriginalRefDate = pipe.transform(
              dto.OriginalRefDate,
              'y-MM-d'
            )),
            (dto.AttachmentEntry = localStorage.getItem('Absolute'));
          // this.setEntryFormDataSourceSAP = dto;
          dto.DocType = 'dDocument_Items';
          dto.DocumentStatus = 'bost_Open';
          dto.Rounding = dto.Rounding == 'true' ? 'tYES' : 'tNO';
          dto.RoundingDiffAmount =
            dto.Rounding == 'tYES' ? dto.RoundingDiffAmount : 0;
          if (dto.TaxExtension)
            (dto.TaxExtension as any) =
              dto?.TaxExtension!.ImportOrExport == 'N'
                ? null
                : dto?.TaxExtension;
          //  dto.DocumentLines!.forEach((el, i) => delete dto.DocumentLines![i]!.WareHouseName)
          delete dto.DownPaymentType;
          if (
            this.getFormSubTitle == 'Sales Invoice' ||
            this.getFormSubTitle == 'Credit Notes'
          ) {
            delete dto.Address2;
            delete dto.Address;
          }
          // if(this.getFormSubTitle == 'Sales Invoice')  {
          //   dto.U_UTL_CARES = this.eWayTabComp.docData.U_UTL_CARES;
          //   dto.U_UTL_ST_CANRMK = this.eWayTabComp.docData.U_UTL_ST_CANRMK;
          //   dto.U_UTL_ST_EWBSts = this.eWayTabComp.docData.U_UTL_ST_EWBSts;
          //   dto.U_UTL_ST_EWayUpDt = this.eWayTabComp.docData.U_UTL_ST_EWayUpDt;
          //   dto.U_UTL_ST_UPRESR = this.eWayTabComp.docData.U_UTL_ST_UPRESR;
          //   dto.U_UTL_ST_URMK = this.eWayTabComp.docData.U_UTL_ST_URMK;
          // }
          if (this.getEntryFormDataSource.documentStatus === 'C' && dto.DocumentLines?.length) {
            dto.DocumentLines.forEach((line: any) => {
              delete line.LocationCode;
              delete line.UoMEntry;
              delete line.TaxTotal;
            });
          }

          if (dto.DocumentLines) {
            const result = this.filterDirtyDocumentLines(dto.DocumentLines);
            dto.DocumentLines = result.dirtyLines;
          }

          this.setEntryFormDataSourceSAP = this.filterObject(dto);
          this.SaveEntryForm();
          this.formSubmittedObs
            .pipe(debounceTime(500))
            .subscribe((res: any) => {
              if (res) {
                if (
                  (this.getFormSubTitle == 'Sales Invoice' ||
                    this.getFormSubTitle == 'Credit Notes') &&
                  this.getFormMode == 0
                ) {
                  if (this.showEInvoice) {
                    //Generate IRN and eway bill - B2C
                    this.einvoiceBtnComp.isBoolGenerateewayBill =
                      this.isBoolGenerateewayBill;
                    this.einvoiceBtnComp.breadcrumbTitle =
                      this.getFormSubTitle == 'Sales Invoice'
                        ? 'Sales Invoice'
                        : 'Credit Notes';
                    this.einvoiceBtnComp.docEntry = res.DocEntry;
                    this.einvoiceBtnComp.objectType =
                      this.getFormSubTitle == 'Sales Invoice' ? '13' : '14';
                    this.einvoiceBtnComp.eWayBillNo =
                      res['EWayBillDetails']['EWayBillNo'];
                    this.einvoiceBtnComp.StockTransferEwayDocEntry =
                      res['EWayBillDetails']['DocEntry'];
                    this.eInvoiceComp.docData = res;
                    this.eInvoiceComp.screenName = this.getFormSubTitle;
                    console.log(
                      '--marketing-document',
                      this.getListViewFormRouteTo
                    );
                    this.einvoiceBtnComp.selectEInvoice(
                      'GenerateIRN',
                      this.getListViewFormRouteTo
                    );
                  } else {
                    if (
                      this.getFormSubTitle == 'Sales Invoice' &&
                      this.isBoolGenerateewayBill
                    ) {
                      this.eWayBill.docEntry = res.DocEntry;
                      this.eWayBill.objectType = '13';
                      this.einvoiceBtnComp.objectType =
                        this.getFormSubTitle == 'Sales Invoice' ? '13' : '14';
                      this.eWayBill.eWayBillNo =
                        res['EWayBillDetails']['EWayBillNo'];
                      this.eWayBill.StockTransferEwayDocEntry =
                        res['EWayBillDetails']['DocEntry'];
                      this.eWayBill.selectEWay(
                        'GenerateEwayBillNonIRN',
                        this.getListViewFormRouteTo
                      );
                    }
                  }
                }
              }
            });
        } else {
          this.openDialog();
        }
      } else if (
        this.getFormSubTitle == 'Purchase Down Payment Request' ||
        this.getFormSubTitle == 'Sales Down Payment Request'
      ) {
        //     alert('2')
        if (this.onValidate()) {
          var pipe = new DatePipe('en-US');
          createMap(
            mapper,
            BatchNumbersModel,
            BatchNumbersModelSAP,
            forMember(
              (dest) => dest.BatchNumber,
              mapFrom((src) => src.batchNumber)
            ),
            forMember(
              (dest) => dest.Quantity,
              mapFrom((src) => src.quantity)
            ),
            forMember(
              (dest) => dest.ItemCode,
              mapFrom((src) => src.itemCode) // Handling case difference
            ),
            forMember(
              (destination) => destination.BatchNumberProperty,
              mapFrom((source) => source.batchNumberProperty)
            ),
            forMember(
              (destination) => destination.ManufacturingDate,
              mapFrom((source) => source.manufacturingDate)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),
            forMember(
              (destination) => destination.AddmisionDate,
              mapFrom((source) => source.addmisionDate)
            ),
            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            )
          );

          createMap(
            mapper,
            SerialNumbersModel,
            SerialNumbersModelSAP,
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            ),
            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),
            forMember(
              (destination) => destination.ManufactureDate,
              mapFrom((source) => source.manufactureDate)
            ),
            forMember(
              (destination) => destination.ReceptionDate,
              mapFrom((source) => source.receptionDate)
            ),
            forMember(
              (destination) => destination.BaseLineNumber,
              mapFrom((source) => source.baseLineNumber)
            ),
            // forMember(
            //   (destination) => (destination.SystemSerialNumber),
            //   mapFrom((source) => (source.systemSerialNumber))
            // ),
            forMember(
              (destination) => destination.Quantity,
              mapFrom((source) => source.quantity)
            ),
            forMember(
              (destination) => destination.ItemCode,
              mapFrom((source) => source.itemCode)
            ),
            forMember(
              (destination) => destination.WareHouseCode,
              mapFrom((source) => source.wareHouseCode)
            ),
            forMember(
              (destination) => destination.WareHouseName,
              mapFrom((source) => source.wareHouseName)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),

            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            )
          );
          createMap(
            mapper,
            MarketingDocument,
            MarketingDocumentSAP,
            forMember(
              (destination) => destination.DownPaymentType,
              mapFrom((source) => source.downPaymentType)
            )
          );
          let dto = mapper.map(
            this.getEntryFormDataSource,
            MarketingDocument,
            MarketingDocumentSAP
          );
          if (dto.DocumentLines?.length) {
            dto.DocumentLines.forEach((el: any, i: number) => {
              //  dto.DocumentLines![i].AccountCode = "400000",
              //dto.DocumentLines[i].ShipDate = pipe.transform(dto.DocDueDate, 'y-MM-d'),
              (dto.DocumentLines![i].ShipDate = pipe.transform(
                dto.DocumentLines![i].ShipDate,
                'y-MM-d'
              )),

                (dto.DocumentLines![i].RemainingOpenQuantity =
                  dto.DocumentLines![i].Quantity);
            });
          }
          // if(this.getFormSubTitle=="Purchase Quotation"){
          //   dto.requriedDate =dto.RequriedDate;
          // }
          let objectType = '';

          if (this.getFormSubTitle == 'Purchase Down Payment Request') {
            objectType = '204';
            delete dto.TaxExtension;
          } else if (this.getFormSubTitle == 'Sales Down Payment Request') {
            objectType = '203';
          }

          dto.ObjectType = objectType;
          dto.DownPaymentType = 'dptRequest';
          (dto.TaxDate = pipe.transform(dto.TaxDate, 'y-MM-d')),
            (dto.DocDate = pipe.transform(dto.DocDate, 'y-MM-d')),
            (dto.DocDueDate = pipe.transform(dto.DocDueDate, 'y-MM-d')),
            (dto.AttachmentEntry = localStorage.getItem('Absolute'));
          // this.setEntryFormDataSourceSAP = dto;
          dto.DocType = 'dDocument_Items';
          dto.DocumentStatus = 'bost_Open';
          dto.Rounding = dto.Rounding == 'true' ? 'tYES' : 'tNO';
          dto.RoundingDiffAmount =
            dto.Rounding == 'tYES' ? dto.RoundingDiffAmount : 0;
          (dto.TaxExtension as any) =
            dto.TaxExtension!?.ImportOrExport == 'N' ? null : dto?.TaxExtension;
          //  dto.DocumentLines!.forEach((el, i) => delete dto.DocumentLines![i]!.WareHouseName)

          if (this.getEntryFormDataSource.documentStatus === 'C' && dto.DocumentLines?.length) {
            dto.DocumentLines.forEach((line: any) => {
              delete line.LocationCode;
              delete line.UoMEntry;
              delete line.TaxTotal;
            });
          }

          if (dto.DocumentLines) {
            const result = this.filterDirtyDocumentLines(dto.DocumentLines);
            dto.DocumentLines = result.dirtyLines;
          }

          this.setEntryFormDataSourceSAP = this.filterObject(dto);
          this.SaveEntryForm();
        } else {
          this.openDialog();
        }
      } else if (this.getFormSubTitle == 'Purchase Request') {
        if (this.onValidate()) {
          var pipe = new DatePipe('en-US');
          createMap(
            mapper,
            BatchNumbersModel,
            BatchNumbersModelSAP,
            forMember(
              (dest) => dest.BatchNumber,
              mapFrom((src) => src.batchNumber)
            ),
            forMember(
              (dest) => dest.Quantity,
              mapFrom((src) => src.quantity)
            ),
            forMember(
              (dest) => dest.ItemCode,
              mapFrom((src) => src.itemCode) // Handling case difference
            ),
            forMember(
              (destination) => destination.BatchNumberProperty,
              mapFrom((source) => source.batchNumberProperty)
            ),
            forMember(
              (destination) => destination.ManufacturingDate,
              mapFrom((source) => source.manufacturingDate)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),
            forMember(
              (destination) => destination.AddmisionDate,
              mapFrom((source) => source.addmisionDate)
            ),
            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            )
          );

          createMap(
            mapper,
            SerialNumbersModel,
            SerialNumbersModelSAP,
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            ),
            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),
            forMember(
              (destination) => destination.ManufactureDate,
              mapFrom((source) => source.manufactureDate)
            ),
            forMember(
              (destination) => destination.ReceptionDate,
              mapFrom((source) => source.receptionDate)
            ),
            forMember(
              (destination) => destination.BaseLineNumber,
              mapFrom((source) => source.baseLineNumber)
            ),
            // forMember(
            //   (destination) => (destination.SystemSerialNumber),
            //   mapFrom((source) => (source.systemSerialNumber))
            // ),
            forMember(
              (destination) => destination.Quantity,
              mapFrom((source) => source.quantity)
            ),
            forMember(
              (destination) => destination.ItemCode,
              mapFrom((source) => source.itemCode)
            ),
            forMember(
              (destination) => destination.WareHouseCode,
              mapFrom((source) => source.wareHouseCode)
            ),
            forMember(
              (destination) => destination.WareHouseName,
              mapFrom((source) => source.wareHouseName)
            ),
            forMember(
              (destination) => destination.ExpiryDate,
              mapFrom((source) => source.expiryDate)
            ),

            forMember(
              (destination) => destination.InternalSerialNumber,
              mapFrom((source) => source.internalSerialNumber)
            ),
            forMember(
              (destination) => destination.ManufacturerSerialNumber,
              mapFrom((source) => source.manufacturerSerialNumber)
            )
          );
          let dto = mapper.map(
            this.getEntryFormDataSource,
            MarketingDocument,
            MarketingDocumentSAP
          );
          if (dto.DocumentLines?.length) {
            dto.DocumentLines.forEach((el: any, i: number) => {
              //  dto.DocumentLines![i].AccountCode = "400000",
              //dto.DocumentLines[i].ShipDate = pipe.transform(dto.DocDueDate, 'y-MM-d'),
              (dto.DocumentLines![i].ShipDate = pipe.transform(
                dto.DocumentLines![i].ShipDate,
                'y-MM-d'
              )),

                (dto.DocumentLines![i].RemainingOpenQuantity =
                  dto.DocumentLines![i].Quantity);
            });
          }
          delete dto.CardCode;
          delete dto.DownPaymentType;
          //delete dto.CardName;
          // if(this.getFormSubTitle=="Purchase Quotation"){
          //   dto.requriedDate =dto.RequriedDate;
          // }
          let objectType = '1470000113';

          dto.ObjectType = objectType;
          (dto.TaxDate = pipe.transform(dto.TaxDate, 'y-MM-d')),
            (dto.DocDate = pipe.transform(dto.DocDate, 'y-MM-d')),
            (dto.DocDueDate = pipe.transform(dto.DocDueDate, 'y-MM-d')),
            (dto.RequriedDate = pipe.transform(dto.RequriedDate, 'y-MM-d'));
          dto.AttachmentEntry = localStorage.getItem('Absolute');
          // this.setEntryFormDataSourceSAP = dto;
          dto.DocType = 'dDocument_Items';
          dto.DocumentStatus = 'bost_Open';
          dto.Rounding = dto.Rounding ? 'tYES' : 'tNO';
          dto.RoundingDiffAmount =
            dto.Rounding == 'tYES' ? dto.RoundingDiffAmount : 0;
          (dto.TaxExtension as any) =
            dto.TaxExtension!.ImportOrExport == 'N' ? null : dto.TaxExtension;
          //  dto.DocumentLines!.forEach((el, i) => delete dto.DocumentLines![i]!.WareHouseName)
          //dto.RequriedDate = pipe.transform(dto.RequriedDate, 'y-MM-d');
          if (this.getEntryFormDataSource.documentStatus === 'C' && dto.DocumentLines?.length) {
            dto.DocumentLines.forEach((line: any) => {
              delete line.LocationCode;
              delete line.UoMEntry;
              delete line.TaxTotal;
            });
          }

          if (dto.DocumentLines) {
            const result = this.filterDirtyDocumentLines(dto.DocumentLines);
            dto.DocumentLines = result.dirtyLines;
          }

          this.setEntryFormDataSourceSAP = this.filterObject(dto);
          this.SaveEntryForm();
        } else {
          this.openDialog();
        }
      } else {
        this.getEntryFormDataSource.pickListsLines = [];
        this.getEntryFormDataSource.documentLines.forEach((item) => {
          let i = new PickListsLinesModel();
          i.orderEntry = item.docEntry;
          i.pickedQuantity = item.quantity;

          this.getEntryFormDataSource.pickListsLines.push(i);
        });
        createMap(
          mapper,
          BatchNumbersModel,
          BatchNumbersModelSAP,
          forMember(
            (dest) => dest.BatchNumber,
            mapFrom((src) => src.batchNumber)
          ),
          forMember(
            (dest) => dest.Quantity,
            mapFrom((src) => src.quantity)
          ),
          forMember(
            (dest) => dest.ItemCode,
            mapFrom((src) => src.itemCode) // Handling case difference
          ),
          forMember(
            (destination) => destination.BatchNumberProperty,
            mapFrom((source) => source.batchNumberProperty)
          ),
          forMember(
            (destination) => destination.ManufacturingDate,
            mapFrom((source) => source.manufacturingDate)
          ),
          forMember(
            (destination) => destination.ExpiryDate,
            mapFrom((source) => source.expiryDate)
          ),
          forMember(
            (destination) => destination.AddmisionDate,
            mapFrom((source) => source.addmisionDate)
          ),
          forMember(
            (destination) => destination.InternalSerialNumber,
            mapFrom((source) => source.internalSerialNumber)
          ),
          forMember(
            (destination) => destination.ManufacturerSerialNumber,
            mapFrom((source) => source.manufacturerSerialNumber)
          )
        );

        createMap(
          mapper,
          SerialNumbersModel,
          SerialNumbersModelSAP,
          forMember(
            (destination) => destination.ManufacturerSerialNumber,
            mapFrom((source) => source.manufacturerSerialNumber)
          ),
          forMember(
            (destination) => destination.InternalSerialNumber,
            mapFrom((source) => source.internalSerialNumber)
          ),
          forMember(
            (destination) => destination.ExpiryDate,
            mapFrom((source) => source.expiryDate)
          ),
          forMember(
            (destination) => destination.ManufactureDate,
            mapFrom((source) => source.manufactureDate)
          ),
          forMember(
            (destination) => destination.ReceptionDate,
            mapFrom((source) => source.receptionDate)
          ),
          forMember(
            (destination) => destination.BaseLineNumber,
            mapFrom((source) => source.baseLineNumber)
          ),
          // forMember(
          //   (destination) => (destination.SystemSerialNumber),
          //   mapFrom((source) => (source.systemSerialNumber))
          // ),
          forMember(
            (destination) => destination.Quantity,
            mapFrom((source) => source.quantity)
          ),
          forMember(
            (destination) => destination.ItemCode,
            mapFrom((source) => source.itemCode)
          ),
          forMember(
            (destination) => destination.WareHouseCode,
            mapFrom((source) => source.wareHouseCode)
          ),
          forMember(
            (destination) => destination.WareHouseName,
            mapFrom((source) => source.wareHouseName)
          ),
          forMember(
            (destination) => destination.ExpiryDate,
            mapFrom((source) => source.expiryDate)
          ),

          forMember(
            (destination) => destination.InternalSerialNumber,
            mapFrom((source) => source.internalSerialNumber)
          ),
          forMember(
            (destination) => destination.ManufacturerSerialNumber,
            mapFrom((source) => source.manufacturerSerialNumber)
          )
        );
        createMap(
          mapper,
          PickListsLinesModel,
          PickListsLinesModelSAP,
          forMember(
            (destination) => destination.OrderEntry,
            mapFrom((source) => source.orderEntry)
          )
        );

        let dto = mapper.map(
          this.getEntryFormDataSource,
          MarketingDocument,
          MarketingDocumentSAP
        );
        dto.Status = 'Picked';
        delete dto.DocumentLines;
        delete dto.RequriedDate;
        delete dto.DocEntry;
        delete dto.DocNum;
        delete dto.DocType;
        delete dto.DocDate;
        delete dto.DocumentStatus;
        delete dto.ObjType;
        delete dto.DocDueDate;
        delete dto.CardCode;

        delete dto.Address;
        delete dto.NumAtCard;
        delete dto.VatSum;
        delete dto.DiscountPercent;
        delete dto.TotalDiscount;
        delete dto.DocRate;
        delete dto.DocTotal;
        delete dto.DocCurrency;

        delete dto.Comments;
        delete dto.PaymentGroupCode;
        delete dto.PaymentGroupCodeName;
        delete dto.SalesPersonCode;
        delete dto.ShipPlace;

        delete dto.ContactPersonCode;

        delete dto.Series;

        delete dto.TaxDate;
        delete dto.TotalExpns;
        delete dto.Address2;

        delete dto.WtAmount;
        delete dto.Project;

        delete dto.BaseAmount;
        delete dto.BPL_IDAssignedToInvoice;

        delete dto.Rounding;
        delete dto.RoundingDiffAmount;
        delete dto.TotalBeforeDiscount;
        delete dto.PlaceOfSupplyCode;

        delete dto.AttachmentEntry;
        delete dto.DocumentLines;
        delete dto.DocumentAdditionalExpenses;
        delete dto.TaxExtension;


        this.setEntryFormDataSourceSAP = dto;
        this.SaveEntryForm();
      }
    }
  }

  setElectronicProtocolData(item: IMarketingDocument) {
    item.electronicProtocols = new Array();
    let electronicProtocolModel: ElectronicProtocol = new ElectronicProtocol();
    electronicProtocolModel.GenerationType =
      this.eWayTabComp.ElectronicProtocolsData.GenerationType;
    electronicProtocolModel.MappingID =
      this.eWayTabComp.ElectronicProtocolsData.MappingID;
    electronicProtocolModel.ProtocolCode = 'edpc_EWB';
    item.electronicProtocols.push(electronicProtocolModel);
    item.eWayBillDetails = this.eWayTabComp.EwayBillSaveData;
    return item;
  }

  getEwayBillData(type: string, info: IMarketingDocument) {
    if (this.getFormSubTitle == 'Sales Invoice') {
      this.eWayTabComp.screenType = this.getFormMode;
      switch (type) {
        case 'dropdown':
          this.eWayTabComp.callAllDropDownApis();
          this.eWayTabComp.objectType =
            this.getFormSubTitle == 'Sales Invoice' ? '13' : '14';
          break;
        case 'callApi':
          this.eWayTabComp.ElectronicProtocolsData =
            info.electronicProtocols!.length > 0
              ? (info.electronicProtocols![0] as ElectronicProtocol)
              : new ElectronicProtocol();
          this.eWayTabComp.EwayBillGetData = info.eWayBillDetails!;
          this.eWayTabComp.docEntry = info.docEntry.toString();
          break;
      }
    }
  }

  filterObject(obj: any): any {
    if (Array.isArray(obj)) {
      return obj
        .map((item) => this.filterObject(item)) // Recursively filter each element
        .filter(
          (item) =>
            item !== null &&
            item !== undefined &&
            item !== false &&
            item !== '' &&
            !(typeof item === 'object' && Object.keys(item).length === 0)
        ); // Remove falsy elements
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj)
          .map(([key, value]) => [key, this.filterObject(value)]) // Recursively filter nested objects
          .filter(
            ([_, value]) =>
              value !== null &&
              value !== undefined &&
              value !== false &&
              value !== '' &&
              !(
                Array.isArray(value) &&
                value.length === 1 &&
                typeof value[0] === 'object' &&
                Object.keys(value[0]).length === 0
              )
          ) // Remove falsy properties
      );
    }
    return obj; // Return primitives as is
  }

  // callGetAllSeriesListAPI() {
  //   let documentNo = '17';
  //   if (this.setURLForFormModeAddSap == 'Orders') {
  //     documentNo = '17';
  //   }
  //   else if (this.apiString == 'Invoices') {
  //     documentNo = '13';

  //   }
  //   let body = {
  //     DocumentTypeParams: {
  //       Document: documentNo,
  //     }
  //   }
  //   this.service.getAllSeries(body).subscribe((info: any) => {
  //     if (info && info.value) {
  //       this.seriesList = info.value.filter((item: any) => {
  //         if (item.Locked == "tNO") {
  //           return item
  //         }
  //       });
  //     }
  //     // this.seriesList = info.value;
  //   });
  // }

  selectedData: any;
  onOpenDropDown(value: any, index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    // debugger;
    // if(this.getFormDisable)
    //   return;

    if (value == 'BudgetCategory' && !this.getEntryFormDataSource.documentLines[index].ocrCode) {
      this.snackbarService.showMessage('Please select the distribution', 'X');
      return;
    }
    if (
      !this.getEntryFormDataSource.cardCode &&
      value == 'itemCode' &&
      this.getFormSubTitle != 'Purchase Request'
    ) {
      this.snackbarService.showMessage('Please select the customer', 'X');
      return;
    } else if (
      !this.getEntryFormDataSource.requester &&
      value == 'itemCode' &&
      this.getFormSubTitle == 'Purchase Request'
    ) {
      this.snackbarService.showMessage('Please select the requester', 'X');
      return;
    }
    this.setObjectType = this.activated.snapshot.data['ObjType'];
    let genCFL = new GenericCflViewComponent<IMarketingDocument>(
      this.agenericRepositoryForCfl,
      this.routerForCfl,
      this.matDialogforCfl,
      this.matDialogRefForCfl,
      this.data,
      this.dbService
    );
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    if (value == 'Branch') {
      genCFL.setCflTitle = 'Branches';
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
      genCFL.setCflDisplayedColumnsNamesList = ['branchName'];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.bpL_IDAssignedToInvoice;
      genCFL.setSortColumn = 'branchName';
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N';
      genCFL.setCflFilterArray = filter;

    }
    if (value == 'Transaction') {
      console.log('getEntryFromData', this.getEntryFormDataSource);
      genCFL.setCflTitle = 'Transaction Type';
      genCFL.setCflViewDataSourceURL = 'Invoices/GetTransTypeList';
      genCFL.setCflDisplayedColumnsNamesList = ['code'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.gstTranTyp;

      // genCFL.setSortColumn = "branchName";
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N';
      // genCFL.setCflFilterArray = '';
    }
    if (value == 'Department') {
      genCFL.setCflTitle = 'Department';
      genCFL.setCflViewDataSourceURL = 'Department/GetDepartmentListService';
      genCFL.setCflDisplayedColumnsNamesList = ['name', 'description'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.department;
      genCFL.setSortColumn = 'name';
    }

    if (value == 'UOM') {
      genCFL.setCflTitle = "UOM";
      genCFL.setCflViewDataSourceURL = 'UnitOfMeasurement/GetUnitOfMeasurementListService';
      genCFL.setCflDisplayedColumnsNamesList = ['absEntry', 'uomCode', 'uomName'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "uomName";

    }
    if (value == 'Distribution') {
      genCFL.setCflTitle = "Distribution";
      genCFL.setCflViewDataSourceURL = 'DistributionRules/GetDistributionRulesListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "code";

    }
    if (value == 'BudgetCategory') {
      genCFL.setCflTitle = 'Budget Category';
      genCFL.setCflViewDataSourceURL = this.getFormSubTitle == 'Purchase Request' ? 'PurchaseRequest/GetPRBudgetCategory' : 'PurchaseOrders/GetPoBudgetCategory';
      genCFL.setCflDisplayedColumnsNamesList = ['u_BudgetCategory', 'u_Type'];
      // genCFL.setCflSelectedData = null /* this.getEntryFormDataSource.documentLines[index] /* removed */ */;
      genCFL.setSortColumn = 'u_BudgetCategory';

      filter.Key = 'U_CostCentre';
      filter.Value = this.getEntryFormDataSource.documentLines[index].ocrCode;
      filter.OperatorType = 'contains';
      genCFL.setCflFilterArray = filter;

      let filter2: WrapperStandardFilter = new WrapperStandardFilter();
      filter2.Key = 'CODE';
      filter2.Value = '2627';
      filter2.OperatorType = 'contains';
      genCFL.setCflFilterArray = filter2;
    }
    if (value == 'Project') {
      genCFL.setCflTitle = "Project";
      genCFL.setCflViewDataSourceURL = 'Project/GetProjectListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "code";

    }

    if (value == 'sequence') {
      genCFL.setCflTitle = 'sequence';
      genCFL.setCflViewDataSourceURL = 'Sequence/GetSequenceListService';
      genCFL.setCflDisplayedColumnsNamesList = ['seqName', 'nextNum'];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.placeOfSupplyCodeName;
      genCFL.setSortColumn = 'seqName';

    }
    if (value == 'Owner') {
      // if (this.getEntryFormDataSource.reqTypeName == 'Employee') {
      genCFL.setCflTitle = 'Employee';
      genCFL.setCflViewDataSourceURL = 'Employee/GetEmployeeListService';
      genCFL.setCflDisplayedColumnsNamesList = [
        'employeeID',
        'firstName',
        'departmentName',
        'genderName',
        'email',
      ];
      genCFL.setSortColumn = 'employeeID';
      genCFL.setCflSelectedData = this.getEntryFormDataSource.requester;
      // } 
      // else if (this.getEntryFormDataSource.reqTypeName == 'User') {
      //   genCFL.setCflTitle = 'User';
      //   genCFL.setCflViewDataSourceURL = 'SAPUser/GetSAPUserListService';
      //   genCFL.setCflDisplayedColumnsNamesList = [
      //     'userCode',
      //     'userName',
      //     'mobilePhoneNumber',
      //     'departmentName',
      //     'superuser',
      //   ];
      //   genCFL.setSortColumn = 'userid';
      //   genCFL.setCflSelectedData = this.getEntryFormDataSource.requester;
      // }
    }

    if (value == 'configuration') {
      genCFL.setCflTitle = "Configuration";
      genCFL.setCflViewDataSourceURL = 'PurchaseOrders/GetPolineconfigutaion';
      genCFL.setCflDisplayedColumnsNamesList = ['fldValue', 'descr'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "descr";
    }

    if (value == 'Customer') {
      if (
        this.getObjectType == enumMarketingDocumentType.GRPO ||
        this.getObjectType == enumMarketingDocumentType.PurchaseQutation ||
        this.getObjectType == enumMarketingDocumentType.PurchaseInvoice ||
        this.getObjectType == enumMarketingDocumentType.PurchaseOrder ||
        this.getObjectType == enumMarketingDocumentType.APDownPaymentRequest ||
        this.getObjectType == enumMarketingDocumentType.DebitNotes ||
        this.getObjectType == enumMarketingDocumentType.PurchaseRequest
      ) {
        genCFL.setCflTitle = 'Vendor';
      } else {
        genCFL.setCflTitle = 'Customer';
      }
      genCFL.setCflViewDataSourceURL =
        'BusinessPartner/GetBusinessPartnerListService';
      genCFL.setCflDisplayedColumnsNamesList = [
        'cardCode',
        'cardName',
        'groupName',
      ];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.cardCode;
      genCFL.setSortColumn = 'cardCode';
      filter.Key = 'CardType';
      filter.OperatorType = 'contains';
      if (
        this.getObjectType == enumMarketingDocumentType.GRPO ||
        this.getObjectType == enumMarketingDocumentType.PurchaseQutation ||
        this.getObjectType == enumMarketingDocumentType.PurchaseInvoice ||
        this.getObjectType == enumMarketingDocumentType.PurchaseOrder ||
        this.getObjectType == enumMarketingDocumentType.APDownPaymentRequest ||
        this.getObjectType == enumMarketingDocumentType.DebitNotes ||
        this.getObjectType == enumMarketingDocumentType.PurchaseRequest
      ) {
        filter.Value = 'S';
      } else {
        filter.Value = 'C';
      }

      genCFL.setCflFilterArray = filter;

      var filter1: WrapperStandardFilter = new WrapperStandardFilter();
      filter1.Key = 'valid';
      filter1.OperatorType = 'contains';
      filter1.Value = 'Y';
      genCFL.setCflFilterArray = filter1;
    }
    if (value == 'Requester') {
      if (this.getEntryFormDataSource.reqTypeName == 'Employee') {
        genCFL.setCflTitle = 'Employee';
        genCFL.setCflViewDataSourceURL = 'Employee/GetEmployeeListService';
        genCFL.setCflDisplayedColumnsNamesList = [
          'employeeID',
          'firstName',
          "middleName",
          "lastName",
          'departmentName',
          'genderName',
          'empCode',
        ];
        genCFL.setSortColumn = 'employeeID';

        var filterActive: WrapperStandardFilter = new WrapperStandardFilter();
        filterActive.Key = 'active';
        filterActive.OperatorType = 'contains';
        filterActive.Value = 'Y';
        genCFL.setCflFilterArray = filterActive;

        genCFL.setCflSelectedData = this.getEntryFormDataSource.requester;
      } else if (this.getEntryFormDataSource.reqTypeName == 'User') {
        genCFL.setCflTitle = 'User';
        genCFL.setCflViewDataSourceURL = 'SAPUser/GetSAPUserListService';
        genCFL.setCflDisplayedColumnsNamesList = [
          'userCode',
          'userName',
          'mobilePhoneNumber',
          'departmentName',
          'superuser',
        ];
        genCFL.setSortColumn = 'userid';

        var filterLocked: WrapperStandardFilter = new WrapperStandardFilter();
        filterLocked.Key = 'locked';
        filterLocked.OperatorType = 'contains';
        filterLocked.Value = 'N';
        genCFL.setCflFilterArray = filterLocked;

        genCFL.setCflSelectedData = this.getEntryFormDataSource.requester;
      }

      // filter.Key = 'CardType';
      // filter.OperatorType = "contains";
      // if (this.getObjectType == enumMarketingDocumentType.GRPO || this.getObjectType == enumMarketingDocumentType.PurchaseQutation || this.getObjectType == enumMarketingDocumentType.PurchaseInvoice || this.getObjectType == enumMarketingDocumentType.PurchaseOrder
      //   || this.getObjectType == enumMarketingDocumentType.APDownPaymentRequest || this.getObjectType == enumMarketingDocumentType.DebitNotes
      // ) {
      //   filter.Value = "S";
      // }
      // else {
      //   filter.Value = "C";
      // }

      // genCFL.setCflFilterArray = filter;
    }
    if (value == 'contactPerson') {
      genCFL.setCflTitle = 'Contact Details';
      genCFL.setCflViewDataSourceURL =
        'ContactPerson/GetContactPersonListService';
      genCFL.setCflDisplayedColumnsNamesList = [
        'name',
        'firstName',
        'lastName',
        'active',
      ];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.contactPersonCode;
      genCFL.setSortColumn = 'cardCode';

      filter.Key = 'cardCode';
      filter.OperatorType = 'startsWith';
      filter.Value = this.getEntryFormDataSource.cardCode;
      genCFL.setCflFilterArray = filter;
      let filter2: WrapperStandardFilter = new WrapperStandardFilter();
      filter2.Key = 'cardCode';
      filter2.OperatorType = 'endsWith';
      filter2.Value = this.getEntryFormDataSource.cardCode;
      genCFL.setCflFilterArray = filter2;
    }
    if (value == 'state') {
      genCFL.setCflTitle = 'State';
      genCFL.setCflViewDataSourceURL = 'State/GetStateListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.placeOfSupplyCodeName;
      genCFL.setSortColumn = 'name';
      filter.Key = 'country';
      filter.OperatorType = 'contains';
      filter.Value = 'IN';
      genCFL.setCflFilterArray = filter;
    }
    if (value == 'incoterms') {
      genCFL.setCflTitle = 'Incoterms';
      genCFL.setCflViewDataSourceURL = 'PurchaseOrders/GetPoIncoterms';
      genCFL.setCflDisplayedColumnsNamesList = ['fldValue', 'descr'];
      // genCFL.setCflSelectedData = this.getEntryFormDataSource /* removed */;
      genCFL.setSortColumn = 'descr';
    }
    if (value == 'payment') {
      genCFL.setCflTitle = 'Payment Terms';
      genCFL.setCflViewDataSourceURL =
        'PaymentTerms/GetPaymentTermsListService';
      genCFL.setCflDisplayedColumnsNamesList = [
        'paymentTermsGroupName',
        'groupNumber',
      ];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.paymentGroupCodeName;
      genCFL.setSortColumn = 'paymentTermsGroupName';
    }

    if (value == 'taxCode') {
      genCFL.setCflTitle = 'Tax Code';
      genCFL.setCflViewDataSourceURL = 'SalesTaxCodes/GetSalesTaxCodesListService';
      //   genCFL.setCflViewDataSourceURL = 'SalesTaxCodes/GetSalesTaxCodeList';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name', 'rate'];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.documentLines[index].taxCode;
      // genCFL.setSortColumn = "name";
      genCFL.setSortColumn = 'code';

      filter.Key = 'inactive';
      filter.OperatorType = 'contains';
      filter.Value = 'N';
      genCFL.setCflFilterArray = filter;

      // if(this.selectedLineItems[index].gstRelevnt == 'Y') {
      //   filter.Key = 'code';
      //   filter.OperatorType = "contains";
      //   filter.Value = 'GST';
      //   genCFL.setCflFilterArray = filter;
      // }
      // let  data:WrapperStandardRequest<any> =new WrapperStandardRequest<any>();
      // data.RequestData=this.selectedLineItems[index].gstRelevnt;

      // genCFL.setCFLRequestDataWithCode =
      // this.getEntryFormDataSource.documentLines[index].gstRelevnt;
    }
    if (value == 'frightTaxCode') {
      genCFL.setCflTitle = 'Tax Code';
      genCFL.setCflViewDataSourceURL =
        'SalesTaxCodes/GetSalesTaxCodesListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.documentAdditionalExpenses[index].taxCode;
      genCFL.setSortColumn = 'name';

      let filter2: WrapperStandardFilter = new WrapperStandardFilter();
      filter2.Key = 'inactive';
      filter2.OperatorType = 'contains';
      filter2.Value = 'N';
      genCFL.setCflFilterArray = filter2;
    }
    if (value == 'itemCode') {
      genCFL.setCflTitle = 'Items';
      genCFL.setCflViewDataSourceURL = 'Item/GetItemListService';
      genCFL.setCflDisplayedColumnsNamesList = [
        'itemCode',
        'itemName',
        'itemGroupName',
        'inventoryUOM',
      ];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.documentLines[index].itemCode;
      genCFL.setSortColumn = 'itemName';

      let filterItem: WrapperStandardFilter = new WrapperStandardFilter();
      filterItem.Key = 'validName';
      filterItem.OperatorType = 'contains';
      filterItem.Value = 'Yes';
      genCFL.setCflFilterArray = filterItem;
    }
    if (value == 'warehouse') {
      genCFL.setCflTitle = 'Warehouses';
      genCFL.setCflViewDataSourceURL = 'Warehouse/GetWarehouseListService';
      genCFL.setCflDisplayedColumnsNamesList = [
        'warehouseCode',
        'warehouseName',
        'businessPlaceName',
      ];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.documentLines[index].warehouseCode;
      genCFL.setSortColumn = 'warehouseName';
    }
    if (value == 'salesPerson') {
      genCFL.setCflViewDataSourceURL =
        'SalesEmployee/GetSalesEmployeeListService';
      if (
        this.getFormSubTitle != 'Purchase Order' &&
        this.getFormSubTitle != 'Purchase Request' &&
        this.getFormSubTitle != 'GRPO' &&
        this.getFormSubTitle != 'Purchase Down Payment Request' &&
        this.getFormSubTitle != 'Purchase Quotation' &&
        this.getFormSubTitle != 'Debit Notes'
      ) {
        genCFL.setCflDisplayedColumnsNamesList = [
          'salesEmployeeCode',
          'salesEmployeeName',
        ];
        genCFL.setCflTitle = 'Sales Employee';
      } else {
        genCFL.setCflDisplayedColumnsNamesList = [
          'salesEmployeeCode',
          'salesEmployeeName',
        ];
        genCFL.setCflTitle = 'Buyer';
      }
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.salesPersonCodeName;
      genCFL.setSortColumn = 'salesEmployeeName';
    }
    if (value == 'shippingType') {
      genCFL.setCflTitle = 'Shipping Preference';
      genCFL.setCflViewDataSourceURL =
        'ShppingTypes/GetShippingTypesListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.shipPlaceName;
      genCFL.setSortColumn = 'name';
    }
    if (value == 'importOrExportType') {
      genCFL.setCflTitle = 'Document Type';
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'SalesOrder';
      genCFL.setCflEnumDataToStoreInDB = this.getEntryFormDataSource.enumData;
      genCFL.setCflEnumObjectNameToDisplay = 'importOrExportType';
      genCFL.setCflDisplayedColumnsNamesList = ['description'];
      genCFL.setSortColumn = 'value';
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.taxExtension?.importOrExportType;
    }
    if (value == 'seriesName') {
      genCFL.setCflTitle = 'Document Series';
      genCFL.setCflViewDataSourceURL =
        'DocumentNumberingSetup/GetDocumentNumberingSetupListService';
      genCFL.setCflDisplayedColumnsNamesList = ['series', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.series;
      genCFL.setSortColumn = 'name';

      filter.Key = 'document';
      filter.OperatorType = null;
      if (this.getFormSubTitle == 'Sales Order') {
        filter.Value = '17';
      } else if (this.getFormSubTitle == 'Sales Invoice') {
        filter.Value = '13';
      } else if (this.getFormSubTitle == 'Purchase Down Payment Request') {
        filter.Value = '204';
      } else if (this.getFormSubTitle == 'Sales Quotation') {
        filter.Value = '23';
      } else if (this.getFormSubTitle == 'Purchase Order') {
        filter.Value = '22';
      } else if (this.getFormSubTitle == 'Debit Notes') {
        filter.Value = '19';
      } else if (this.getFormSubTitle == 'Purchase Quotation') {
        filter.Value = '540000006';
      } else if (this.getFormSubTitle == 'Purchase Invoice') {
        filter.Value = '18';
      } else if (this.getFormSubTitle == 'GRPO') {
        filter.Value = '20';
      } else if (this.getFormSubTitle == 'Purchase Request') {
        filter.Value = '1470000113';
      } else if (this.getFormSubTitle == 'Delivery Challans') {
        filter.Value = '15';
      } else if (this.getFormSubTitle == 'Credit Notes') {
        filter.Value = '14';
      } else if (this.getFormSubTitle == 'Sales Down Payment Request') {
        filter.Value = '203';
      }
      genCFL.setCflFilterArray = filter;

      var filter1: WrapperStandardFilter = new WrapperStandardFilter();
      filter1.Key = 'locked';
      filter1.OperatorType = 'contains';
      filter1.Value = 'N';
      genCFL.setCflFilterArray = filter1;
      var filter2: WrapperStandardFilter = new WrapperStandardFilter();
      filter2.Key = 'disabled';
      filter2.OperatorType = 'contains';
      filter2.Value = 'N';
      genCFL.setCflFilterArray = filter2;
    }
    if (value == 'hsnNum') {
      genCFL.setCflTitle = 'HSN Number';
      genCFL.setCflViewDataSourceURL = 'HSN/GetHSNListService';
      genCFL.setCflDisplayedColumnsNamesList = ['chapterID', 'description'];
      genCFL.setCflSelectedData =
        this.getEntryFormDataSource.documentLines[index].hsnEntry;
      genCFL.setSortColumn = 'chapter';
    }

    genCFL
      .openCFL(GenericCflViewComponent, {})
      .afterClosed()
      .subscribe((res) => {

        // debugger;

        if (res != undefined && res.isClear == true) {
          this.clearCflData(value, index);
          return;
        }

        if (res != undefined && res.event != undefined) {
          this.selectedData = res.event;
          if (this.btnText == 'Language.OkText') {
            this.btnText = 'Language.UpdateText';
          }
          if (value == 'Department') {
            this.getEntryFormDataSource.department = res.event.code;
            this.getEntryFormDataSource.departmentName = res.event.name;
          }
          if (value == 'Transaction') {
            this.getEntryFormDataSource.gstTranTyp = res.event.code;
            this.getEntryFormDataSource.gstTranTypName = res.event.code;
            (async () => {
              const payload = new WrapperStandardRequest();
              let objectType = '';
              if (this.getFormSubTitle == 'Sales Invoice') {
                objectType = '13';
              } else if (this.getFormSubTitle == 'Credit Notes') {
                objectType = '14';
              } else if (this.getFormSubTitle == 'Purchase Invoice') {
                objectType = '18';
              } else if (this.getFormSubTitle == 'Debit Notes') {
                objectType = '19';
              }
              payload.RequestData = {
                docSubType: res.event.value,
                objectCode: objectType,
                bplId: this.getEntryFormDataSource.bpL_IDAssignedToInvoice || localStorage.getItem('BranchId'),
              };
              const seriesResponse = await lastValueFrom(
                this.agenericRepositoryForCfl.PostAPI(
                  GlobalProperties.getApiUrl + 'Invoices/GetSeriesNameList',
                  payload
                )
              );
              res.event = seriesResponse.responseData;
              console.log('seriesResponse', seriesResponse);
              //   this.getEntryFormDataSource.bpL_IDAssignedToInvoice = res.event.bplid;
              //  this.getEntryFormDataSource.branchName = res.event.branchName;
              //  let currentSeries = this.seriesList.find((el: any) => el.bplid == res.event.bplid);
              let currentSeries = res.event[0];
              this.getEntryFormDataSource.series = currentSeries?.series;
              this.getEntryFormDataSource.seriesName = currentSeries?.name;
            })();
          }
          if (value == 'Branch') {
            this.getEntryFormDataSource.bpL_IDAssignedToInvoice =
              res.event.bplid;
            this.getEntryFormDataSource.branchName = res.event.branchName;

            // Set Branch Reg Name -- Durgesh
            this.getEntryFormDataSource.vatRegNum = res.event.federalTaxID;

            // let currentSeries = this.seriesList.find(
            //   (el: any) => el.bplid == res.event.bplid
            // );
            // this.getEntryFormDataSource.series = currentSeries?.series;
            // this.getEntryFormDataSource.seriesName = currentSeries?.name;
          }
          if (value == 'seriesName') {
            this.getEntryFormDataSource.series = res.event.series;
            this.getEntryFormDataSource.seriesName = res.event.name;
          }
          if (value == 'Requester') {
            if (this.getEntryFormDataSource.reqTypeName == 'Employee') {
              this.getEntryFormDataSource.reqType = 171;
              this.getEntryFormDataSource.requester =
                res.event.employeeID.toString();
              this.getEntryFormDataSource.requesterName =
                res.event.lastName + ', ' + res.event.firstName;
              this.getEntryFormDataSource.email = res.event.email;

              const dept = res.event.department;
              const deptName = res.event.departmentName;
              if (dept && dept !== 0 && dept !== '0' && deptName && deptName.trim() !== '') {
                this.getEntryFormDataSource.department = dept.toString();
                this.getEntryFormDataSource.departmentName = deptName;
              }
            } else if (this.getEntryFormDataSource.reqTypeName == 'User') {
              this.getEntryFormDataSource.reqType = 12;
              this.getEntryFormDataSource.requester = res.event.userCode;
              this.getEntryFormDataSource.requesterName = res.event.userName;
              this.getEntryFormDataSource.email = res.event.eMail;

              const dept = res.event.department;
              const deptName = res.event.departmentName;
              if (dept && dept !== 0 && dept !== '0' && deptName && deptName.trim() !== '') {
                this.getEntryFormDataSource.department = dept.toString();
                this.getEntryFormDataSource.departmentName = deptName;
              }
            }
          }
          if (value == 'Customer') {
            if (this.getFormSubTitle != 'Purchase Request') {
              (async () => {
                console.log('in asyn in customer');
                const payload = new WrapperStandardRequest();
                payload.RequestData = res.event.cardCode;
                const customerResponse = await lastValueFrom(
                  this.agenericRepositoryForCfl.PostAPI(
                    GlobalProperties.getApiUrl +
                    'BusinessPartner/GetBusinessPartnerService',
                    payload
                  )
                );
                res.event = customerResponse.responseData;
                this.getEntryFormDataSource.cardCode = res.event.cardCode;
                this.getEntryFormDataSource.cardName = res.event.cardName;
                this.getEntryFormDataSource.contactPersonCodeName =
                  res.event.contactPerson;
                this.getEntryFormDataSource.salesPersonCode = res.event.slpCode;
                this.getEntryFormDataSource.docCurrency = res.event.currency;
                this.getEntryFormDataSource.docCurrencyName =
                  res.event.currencyName;
                this.getEntryFormDataSource.salesPersonCodeName =
                  res.event.slpName;
                this.getEntryFormDataSource.paymentGroupCode =
                  res.event.payTermsGrpCode;
                this.getEntryFormDataSource.paymentGroupCodeName =
                  res.event.payTermsGrpCodeName;
                this.billToAddress = [];
                this.shipToAddress = [];
                this.currencyList = [];
                this.getEntryFormDataSource.address = '';
                this.getEntryFormDataSource.address2 = '';
                // this.getEntryFormDataSource.payToCode = '';
                // this.getEntryFormDataSource.shipToCode = res.event.rowNum;
                if (
                  this.getFormSubTitle == 'Sales Invoice' ||
                  this.getFormSubTitle == 'Credit Notes'
                ) {
                  this.getEntryFormDataSource.payToCode =
                    res.event.billtoDefault;
                  this.getEntryFormDataSource.shipToCode =
                    res.event.shipToDefault;
                }
                if (res.event.currencyName !== '##') {
                  this.currencyList.push(res.event.currencyName);
                }
                if (res.event.bpAddresses) {
                  res.event.bpAddresses.forEach((ele: any) => {
                    if (ele.addressType == 'bo_BillTo') {
                      this.billToAddress.push(ele);
                    } else if (ele.addressType == 'bo_ShipTo') {
                      this.shipToAddress.push(ele);
                    }
                  });
                }

                this.selectAddress(
                  this.billToAddress.find((res) => res.isDefaultAddress)
                );
                this.selectAddress(
                  this.shipToAddress.find((res) => res.isDefaultAddress)
                );
                if (this.getFormSubTitle == 'Sales Invoice') {
                  this.eWayTabComp.docData = this.getEntryFormDataSource;
                  this.eWayTabComp.screenName = this.getFormSubTitle;
                  this.eWayTabComp.shipToData = {
                    shipList: this.shipToAddress,
                    value: this.getEntryFormDataSource.shipToCode,
                  };
                }
                //check for NonIRN Customer when add
                if (
                  this.getFormSubTitle == 'Sales Invoice' ||
                  this.getFormSubTitle == 'Credit Notes'
                ) {
                  this.checkNonIRNCustomer(customerResponse.responseData);
                }
              })();
            }
            if (this.getFormSubTitle == 'Purchase Request') {
              this.getEntryFormDataSource.documentLines[index].lineVendorName =
                res.event.cardName;
              this.getEntryFormDataSource.documentLines[index].lineVendor =
                res.event.cardCode;
            }
            if (
              this.getEntryFormDataSource.cardCode &&
              this.getEntryFormDataSource.documentLines.length > 0
            ) {
              for (
                let index = 0;
                index < this.getEntryFormDataSource.documentLines.length;
                index++
              ) {
                (async () => {
                  const payload = new WrapperStandardRequest();
                  payload.RequestData = {
                    itemCode:
                      this.getEntryFormDataSource.documentLines[index].itemCode,
                    cardCode:
                      this.getFormSubTitle == 'Purchase Request'
                        ? this.getEntryFormDataSource.documentLines[index]
                          .lineVendor
                        : this.getEntryFormDataSource.cardCode,
                    itemName:
                      this.getEntryFormDataSource.documentLines[index]
                        .itemDescription,
                  };

                  const customerResponse = await lastValueFrom(
                    this.agenericRepositoryForCfl.PostAPI(
                      GlobalProperties.getApiUrl + 'Item/FetchItemPrice',
                      payload
                    )
                  );

                  // console.log('customerResponse',customerResponse.responseData.price)
                  try {
                    let curItemCode = (res.event.itemCode || (this.getEntryFormDataSource.documentLines[index] && this.getEntryFormDataSource.documentLines[index].itemCode)) || '';
                    if (curItemCode) {
                      const fetchUDF = async (endpoint: string, overrideReqData?: any) => {
                        const payload = new WrapperStandardRequest();
                        payload.RequestData = overrideReqData !== undefined ? overrideReqData : curItemCode;
                        payload.PageSize = 1;
                        payload.PageRecordCount = 10;
                        payload.SortColumn = "";
                        payload.IsAcending = true;
                        try {
                          const resp = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + endpoint, payload));
                          if (resp) {
                            if (resp.responseData !== undefined) {
                              return resp.responseData.list ? resp.responseData.list[0] : (Array.isArray(resp.responseData) ? resp.responseData[0] : resp.responseData);
                            } else if (Array.isArray(resp)) {
                              return resp[0];
                            }
                            return resp;
                          }
                        } catch (err) { console.error(endpoint, err); }
                        return null;
                      };

                      const docLine = this.getEntryFormDataSource.documentLines[index];
                      const reqPOPR = {
                        DocEntry: Number(docLine.baseEntry ? docLine.baseEntry : (docLine.docEntry || 0)),
                        LineNum: Number(docLine.baseLine ?? docLine.lineNum ?? 0)
                      };

                      const [] = await Promise.all([
                      ]);

                      console.log('Fetched UDFs RAW:', {});

                      const extractVal = (obj: any, keys: string[]) => {
                        if (obj === null || obj === undefined) return '';
                        if (typeof obj !== 'object') return obj;
                        for (let k of keys) {
                          if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
                        }
                        return obj.fldValue || obj.descr || obj.value || obj.Value || obj.name || obj.Name || obj.code || obj.Code || '';
                      };

                      if (this.getEntryFormDataSource.documentLines[index]) {
                        // removed assignment to u_BasePrice
                        // removed assignment to u_MinPP
                        // removed assignment to u_MaxPP
                        // removed assignment to u_LPP
                        // removed assignment to u_LPVndr
                        // removed assignment to u_MPIN
                        // removed assignment to u_CurYear
                        // removed assignment to u_LstYear
                        // removed assignment to u_BaseQty
                      }
                    }
                  } catch (e) { console.error('Get UDFs failed', e); }
                  if (customerResponse.responseData) {
                    this.getEntryFormDataSource.documentLines[index].unitPrice =
                      customerResponse.responseData.price;

                    this.getEntryFormDataSource.documentLines[
                      index
                    ].discountPercent = 0;
                    this.getEntryFormDataSource.documentLines[index].taxCode =
                      '';
                    this.getEntryFormDataSource.documentLines[index].price =
                      this.getEntryFormDataSource.documentLines[index]
                        .unitPrice -
                      (this.getEntryFormDataSource.documentLines[index]
                        .unitPrice *
                        this.getEntryFormDataSource.documentLines[index]
                          .discountPercent) /
                      100;
                    this.getEntryFormDataSource.documentLines[index].lineTotal =
                      this.getEntryFormDataSource.documentLines[index].price *
                      this.getEntryFormDataSource.documentLines[index].quantity;
                    this.getEntryFormDataSource.totalBeforeDiscount =
                      this.getEntryFormDataSource.documentLines[index].price *
                      this.getEntryFormDataSource.documentLines[index].quantity;
                    this.calculateTotals();
                    this.calculateDiscountAmt();
                  }
                })();
              }
            }

            if (this.getFormSubTitle == 'Purchase Request') {
              if (this.getEntryFormDataSource.documentLines.length > 0) {
                for (
                  let index = 0;
                  index < this.getEntryFormDataSource.documentLines.length;
                  index++
                ) {
                  (async () => {
                    const payload = new WrapperStandardRequest();
                    payload.RequestData = {
                      itemCode:
                        this.getEntryFormDataSource.documentLines[index]
                          .itemCode,
                      cardCode:
                        this.getFormSubTitle == 'Purchase Request'
                          ? this.getEntryFormDataSource.documentLines[index]
                            .lineVendor
                          : this.getEntryFormDataSource.cardCode,
                      itemName:
                        this.getEntryFormDataSource.documentLines[index]
                          .itemDescription,
                    };

                    const customerResponse = await lastValueFrom(
                      this.agenericRepositoryForCfl.PostAPI(
                        GlobalProperties.getApiUrl + 'Item/FetchItemPrice',
                        payload
                      )
                    );

                    // console.log('customerResponse',customerResponse.responseData.price)
                    try {
                      let curItemCode = (res.event.itemCode || (this.getEntryFormDataSource.documentLines[index] && this.getEntryFormDataSource.documentLines[index].itemCode)) || '';
                      if (curItemCode) {
                        const fetchUDF = async (endpoint: string, overrideReqData?: any) => {
                          const payload = new WrapperStandardRequest();
                          payload.RequestData = overrideReqData !== undefined ? overrideReqData : curItemCode;
                          payload.PageSize = 1;
                          payload.PageRecordCount = 10;
                          payload.SortColumn = "";
                          payload.IsAcending = true;
                          try {
                            const resp = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + endpoint, payload));
                            if (resp) {
                              if (resp.responseData !== undefined) {
                                return resp.responseData.list ? resp.responseData.list[0] : (Array.isArray(resp.responseData) ? resp.responseData[0] : resp.responseData);
                              } else if (Array.isArray(resp)) {
                                return resp[0];
                              }
                              return resp;
                            }
                          } catch (err) { console.error(endpoint, err); }
                          return null;
                        };

                        const docLine = this.getEntryFormDataSource.documentLines[index];
                        const reqPOPR = {
                          DocEntry: Number(docLine.baseEntry ? docLine.baseEntry : (docLine.docEntry || 0)),
                          LineNum: Number(docLine.baseLine ?? docLine.lineNum ?? 0)
                        };

                        const [] = await Promise.all([
                        ]);

                        console.log('Fetched UDFs RAW:', {});

                        const extractVal = (obj: any, keys: string[]) => {
                          if (obj === null || obj === undefined) return '';
                          if (typeof obj !== 'object') return obj;
                          for (let k of keys) {
                            if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
                          }
                          return obj.fldValue || obj.descr || obj.value || obj.Value || obj.name || obj.Name || obj.code || obj.Code || '';
                        };

                        if (this.getEntryFormDataSource.documentLines[index]) {
                          // removed assignment to u_BasePrice
                          // removed assignment to u_MinPP
                          // removed assignment to u_MaxPP
                          // removed assignment to u_LPP
                          // removed assignment to u_LPVndr
                          // removed assignment to u_MPIN
                          // removed assignment to u_CurYear
                          // removed assignment to u_LstYear
                          // removed assignment to u_BaseQty
                        }
                      }
                    } catch (e) { console.error('Get UDFs failed', e); }
                    if (customerResponse.responseData) {
                      this.getEntryFormDataSource.documentLines[
                        index
                      ].unitPrice = customerResponse.responseData.price;

                      this.getEntryFormDataSource.documentLines[
                        index
                      ].discountPercent = 0;
                      this.getEntryFormDataSource.documentLines[index].taxCode =
                        '';
                      this.getEntryFormDataSource.documentLines[index].price =
                        this.getEntryFormDataSource.documentLines[index]
                          .unitPrice -
                        (this.getEntryFormDataSource.documentLines[index]
                          .unitPrice *
                          this.getEntryFormDataSource.documentLines[index]
                            .discountPercent) /
                        100;
                      this.getEntryFormDataSource.documentLines[
                        index
                      ].lineTotal =
                        this.getEntryFormDataSource.documentLines[index].price *
                        this.getEntryFormDataSource.documentLines[index]
                          .quantity;
                      this.getEntryFormDataSource.totalBeforeDiscount =
                        this.getEntryFormDataSource.documentLines[index].price *
                        this.getEntryFormDataSource.documentLines[index]
                          .quantity;
                      this.calculateTotals();
                      this.calculateDiscountAmt();
                    }
                  })();
                }
              }
            }
          }
          if (value == 'contactPerson') {
            this.getEntryFormDataSource.contactPersonCodeName = res.event.name;
            this.getEntryFormDataSource.contactPersonCode =
              res.event.contactPersonCode;
          }
          if (value == 'state') {
            this.getEntryFormDataSource.placeOfSupplyCode = res.event.code;
            this.getEntryFormDataSource.placeOfSupplyCodeName = res.event.name;
            //this.getEntryFormDataSource.state = res.event.name;
          }
          if (value == 'incoterms') {
            // removed assignment to u_InCoTerm
            // removed assignment to u_InCoTermName
          }
          if (value == 'payment') {
            this.getEntryFormDataSource.paymentGroupCode =
              res.event.groupNumber;
            this.getEntryFormDataSource.paymentGroupCodeName =
              res.event.paymentTermsGroupName;
          }
          if (value == 'taxCode') {
            this.getEntryFormDataSource.documentLines[index].taxCode =
              res.event.code;
            this.getEntryFormDataSource.documentLines[index].taxName =
              res.event.name;
            this.getEntryFormDataSource.documentLines[index].taxRate = res.event.rate;

            this.getEntryFormDataSource.documentLines[index].taxTotal =
              (res.event.rate *
                this.getEntryFormDataSource.documentLines[index].price *
                this.getEntryFormDataSource.documentLines[index].quantity) /
              100;
            this.getEntryFormDataSource.documentLines[index].lineTotal =
              this.getEntryFormDataSource.documentLines[index].taxTotal +
              this.getEntryFormDataSource.documentLines[index].price *
              this.getEntryFormDataSource.documentLines[index].quantity;
            this.calculateTotals();
            this.calculateDiscountAmt();
          }
          if (value == 'frightTaxCode') {
            this.getEntryFormDataSource.documentAdditionalExpenses[
              index
            ].taxCode = res.event.code;
          }

          if (value == 'itemCode') {
            console.log('res.evenitemt', res.event);

            this.getEntryFormDataSource.documentLines[index].itemCode =
              res.event.itemCode;
            this.getEntryFormDataSource.documentLines[index].itemDescription =
              res.event.itemName;
            this.getEntryFormDataSource.documentLines[index].uoMCode =
              res.event.inventoryUOM;
            this.getEntryFormDataSource.documentLines[index].uoMEntry =
              res.event.uomEntry;
            this.getEntryFormDataSource.documentLines[index].hsnEntry =
              res.event.chapterID;
            this.getEntryFormDataSource.documentLines[index].chapterID =
              res.event.chapterID;

            if (this.getFormSubTitle == 'Purchase Request') {
              if (res.event.cardCode) {
                this.getEntryFormDataSource.documentLines[index].lineVendor = res.event.cardCode;
                (async () => {
                  try {
                    const payload = new WrapperStandardRequest();
                    payload.RequestData = [
                      {
                        Key: 'CardCode',
                        Value: res.event.cardCode,
                        OperatorType: 'contains'
                      },
                      {
                        Key: 'valid',
                        Value: 'Y',
                        OperatorType: 'contains'
                      }
                    ];
                    payload.IsAcending = true;
                    payload.PageSize = 1;
                    payload.PageRecordCount = 10;
                    payload.SortColumn = 'cardCode';

                    const bpResponse: any = await lastValueFrom(
                      this.agenericRepositoryForCfl.PostAPI(
                        GlobalProperties.getApiUrl + 'BusinessPartner/GetBusinessPartnerListService',
                        payload
                      )
                    );

                    if (bpResponse && bpResponse.responseData && bpResponse.responseData.list && bpResponse.responseData.list.length > 0) {
                      this.getEntryFormDataSource.documentLines[index].lineVendorName = bpResponse.responseData.list[0].cardName;
                    } else if (bpResponse && bpResponse.responseData && bpResponse.responseData.length > 0) {
                      this.getEntryFormDataSource.documentLines[index].lineVendorName = bpResponse.responseData[0].cardName;
                    }
                  } catch (error) {
                    console.error('Error fetching Vendor Name:', error);
                  }
                })();
              } else {
                this.getEntryFormDataSource.documentLines[index].lineVendor = '';
                this.getEntryFormDataSource.documentLines[index].lineVendorName = '';
              }
            }

            if (res.event.chapterID) {
              (async () => {
                const payloadHSN = new WrapperStandardRequest();
                payloadHSN.RequestData = [
                  {
                    Key: "absEntry",
                    Value: res.event.chapterID.toString(),
                    OperatorType: ">="
                  },
                  {
                    Key: "absEntry",
                    Value: res.event.chapterID.toString(),
                    OperatorType: "<="
                  }
                ];
                payloadHSN.IsAcending = true;
                payloadHSN.PageSize = 1;
                payloadHSN.PageRecordCount = 10;
                payloadHSN.SortColumn = 'absEntry';

                try {
                  const hsnResponse: any = await lastValueFrom(
                    this.agenericRepositoryForCfl.PostAPI(
                      GlobalProperties.getApiUrl + 'HSN/GetHSNListService',
                      payloadHSN
                    )
                  );
                  if (hsnResponse && hsnResponse.responseData && hsnResponse.responseData.length > 0) {
                    this.getEntryFormDataSource.documentLines[index].chapterID = hsnResponse.responseData[0].chapterID;
                    this.getEntryFormDataSource.documentLines[index].hsnEntry = hsnResponse.responseData[0].absEntry;
                  }
                } catch (error) {
                  console.error('Error fetching HSN:', error);
                }
              })();
            }
            this.getEntryFormDataSource.documentLines[index].gstRelevnt =
              res.event.gstRelevnt;
            this.getEntryFormDataSource.documentLines[index].quantity = 1;
            this.getEntryFormDataSource.documentLines[index].price = 0;
            this.getEntryFormDataSource.documentLines[index].unitPrice = 0;
            this.getEntryFormDataSource.documentLines[index].openCreQty = 1;
            this.getEntryFormDataSource.documentLines[
              index
            ].manageBatchNumbers = res.event.manageBatchNumbers;
            this.getEntryFormDataSource.documentLines[
              index
            ].manageSerialNumbers = res.event.manageSerialNumbers;
            this.getEntryFormDataSource.documentLines[index].serialNumbers = [];
            this.getEntryFormDataSource.documentLines[index].batchNumbers = [];

            (async () => {
              const payload = new WrapperStandardRequest();
              payload.RequestData = {
                itemCode: res.event.itemCode,
                cardCode:
                  this.getFormSubTitle == 'Purchase Request'
                    ? this.getEntryFormDataSource.documentLines[index]
                      .lineVendor
                    : this.getEntryFormDataSource.cardCode,
                itemName: res.event.itemName,
              };

              const customerResponse = await lastValueFrom(
                this.agenericRepositoryForCfl.PostAPI(
                  GlobalProperties.getApiUrl + 'Item/FetchItemPrice',
                  payload
                )
              );

              // console.log('customerResponse',customerResponse.responseData.price)
              try {
                let curItemCode = (res.event.itemCode || (this.getEntryFormDataSource.documentLines[index] && this.getEntryFormDataSource.documentLines[index].itemCode)) || '';
                if (curItemCode) {
                  const fetchUDF = async (endpoint: string, overrideReqData?: any) => {
                    const payload = new WrapperStandardRequest();
                    payload.RequestData = overrideReqData !== undefined ? overrideReqData : curItemCode;
                    payload.PageSize = 1;
                    payload.PageRecordCount = 10;
                    payload.SortColumn = "";
                    payload.IsAcending = true;
                    try {
                      const resp = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + endpoint, payload));
                      if (resp) {
                        if (resp.responseData !== undefined) {
                          return resp.responseData.list ? resp.responseData.list[0] : (Array.isArray(resp.responseData) ? resp.responseData[0] : resp.responseData);
                        } else if (Array.isArray(resp)) {
                          return resp[0];
                        }
                        return resp;
                      }
                    } catch (err) { console.error(endpoint, err); }
                    return null;
                  };

                  const docLine = this.getEntryFormDataSource.documentLines[index];
                  const reqPOPR = {
                    DocEntry: Number(docLine.baseEntry ? docLine.baseEntry : (docLine.docEntry || 0)),
                    LineNum: Number(docLine.baseLine ?? docLine.lineNum ?? 0)
                  };

                  const [] = await Promise.all([
                  ]);

                  console.log('Fetched UDFs RAW:', {});

                  const extractVal = (obj: any, keys: string[]) => {
                    if (obj === null || obj === undefined) return '';
                    if (typeof obj !== 'object') return obj;
                    for (let k of keys) {
                      if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
                    }
                    return obj.fldValue || obj.descr || obj.value || obj.Value || obj.name || obj.Name || obj.code || obj.Code || '';
                  };

                  if (this.getEntryFormDataSource.documentLines[index]) {
                    // removed assignment to u_BasePrice
                    // removed assignment to u_MinPP
                    // removed assignment to u_MaxPP
                    // removed assignment to u_LPP
                    // removed assignment to u_LPVndr
                    // removed assignment to u_MPIN
                    // removed assignment to u_CurYear
                    // removed assignment to u_LstYear
                    // removed assignment to u_BaseQty
                  }
                }
              } catch (e) { console.error('Get UDFs failed', e); }
              this.getEntryFormDataSource.documentLines[index].unitPrice =
                customerResponse.responseData.price;
              if (res.event.sapItemWarehouse_Child) {
                for (
                  let i = 0;
                  i < res.event.sapItemWarehouse_Child.length;
                  i++
                ) {
                  this.allItem.push(res.event.sapItemWarehouse_Child[i]);
                }
              }
              // if (this.selectedLineItems[index]) {
              //   this.selectedLineItems[index] = res.event;
              // } else {
              //   this.selectedLineItems.push(res.event);
              // }

              this.getEntryFormDataSource.documentLines[
                index
              ].discountPercent = 0;
              this.getEntryFormDataSource.documentLines[index].taxCode = '';
              this.getEntryFormDataSource.documentLines[index].price =
                this.getEntryFormDataSource.documentLines[index].unitPrice -
                (this.getEntryFormDataSource.documentLines[index].unitPrice *
                  this.getEntryFormDataSource.documentLines[index]
                    .discountPercent) /
                100;
              this.getEntryFormDataSource.documentLines[index].lineTotal =
                this.getEntryFormDataSource.documentLines[index].price *
                this.getEntryFormDataSource.documentLines[index].quantity;
              this.getEntryFormDataSource.totalBeforeDiscount =
                this.getEntryFormDataSource.documentLines[index].price *
                this.getEntryFormDataSource.documentLines[index].quantity;
              this.calculateTotals();
              this.calculateDiscountAmt();
            })();

            if (this.selectedLineItems[index]) {
              this.selectedLineItems[index] = res.event;
            } else {
              this.selectedLineItems.push(res.event);
            }
          }
          if (value == 'warehouse') {
            let requestdata = {
              userId: '0',
              userGuid: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
              companyCode: GlobalProperties._compnayCode,
              requestData:
                this.getEntryFormDataSource.documentLines[index].itemCode,
              pageRecordCount: 0,
              pageSize: 0,
              isAcending: true,
              sortColumn: 'ItemCode',
            };

            this.snackbarService
              .PostAPI(
                `${GlobalProperties.getApiUrl}Item/GetListSAPItemWarehouse`,
                requestdata
              )
              .subscribe((resp) => {
                let response = resp.responseData;
                for (let i = 0; i < response.length; i++) {
                  if (response[i].warehouseCode == res.event.warehouseCode) {
                    this.getEntryFormDataSource.documentLines[
                      index
                    ].warehouseQuantity = response[i].inStock;
                  }
                }
                // for (var i = 0; i < this.allItem.length; i++) {
                //   if (this.allItem[i].warehouseCode == res.event.warehouseCode) {
                //     this.getEntryFormDataSource.documentLines[index].warehouseQuantity = this.allItem[i].inStock;
                //   }
                // }
              });
            //  console.log(this.getEntryFormDataSource.documentLines[index].warehouseQuantity)
            this.getEntryFormDataSource.documentLines[index].warehouseCode =
              res.event.warehouseCode;
            this.getEntryFormDataSource.documentLines[index].wareHouseName =
              res.event.warehouseName;
            this.getEntryFormDataSource.documentLines[index].locationCode =
              res.event.location;
            this.getEntryFormDataSource.documentLines[index].locationName =
              res.event.locationName;
          }
          if (value == 'salesPerson') {
            this.getEntryFormDataSource.salesPersonCode =
              res.event.salesEmployeeCode;
            this.getEntryFormDataSource.salesPersonCodeName =
              res.event.salesEmployeeName;
          }
          if (value == 'shippingType') {
            this.getEntryFormDataSource.shipPlace = res.event.code;
            this.getEntryFormDataSource.shipPlaceName = res.event.name;
          }
          if (value == 'importOrExportType') {
            this.getEntryFormDataSource.taxExtension.importOrExportType =
              res.event.value;
            this.getEntryFormDataSource.taxExtension.importOrExportTypeName =
              res.event.description;
          }
          if (value == 'seriesName') {
            this.getEntryFormDataSource.series = res.event.series;
            this.getEntryFormDataSource.seriesName = res.event.name;
          }
          if (value == 'hsnNum') {
            this.getEntryFormDataSource.documentLines[index].hsnEntry =
              res.event.absEntry;
            this.getEntryFormDataSource.documentLines[index].chapterID =
              res.event.chapterID;
          }
          if (value == 'UOM') {
            this.getEntryFormDataSource.documentLines[index].uoMCode =
              res.event.uomCode;
            this.getEntryFormDataSource.documentLines[index].uoMEntry =
              res.event.absEntry;
          }
          if (value == 'Distribution') {
            this.getEntryFormDataSource.documentLines[index].ocrCode =
              res.event.code;
            this.getEntryFormDataSource.documentLines[index].ocrName =
              res.event.name;

            // Clear budget fields when Distribution changes
            // removed assignment to u_Category
            // removed assignment to u_BudAmt
            // removed assignment to u_UtiBud
            // removed assignment to u_ComBud
            // removed assignment to u_REmBudg
          }

          if (value == 'Project') {
            this.getEntryFormDataSource.documentLines[index].projectCode =
              res.event.code;
            this.getEntryFormDataSource.documentLines[index].projectName =
              res.event.name;
          }
          if (value == 'sequence') {
            this.getEntryFormDataSource.seqCode = res.event.seqCode;
            this.getEntryFormDataSource.seqName = res.event.seqName;
            this.getEntryFormDataSource.nextNum = res.event.nextNum;
          }
          if (value == 'Owner') {
            // if (this.getEntryFormDataSource.reqTypeName == 'Employee') {
            this.getEntryFormDataSource.reqType = 171;
            this.getEntryFormDataSource.requester =
              res.event.employeeID.toString();
            this.getEntryFormDataSource.requesterName =
              res.event.lastName + ', ' + res.event.firstName;
            // this.getEntryFormDataSource.email = res.event.email;
            // } else if (this.getEntryFormDataSource.reqTypeName == 'User') {
            //   this.getEntryFormDataSource.reqType = 12;
            //   this.getEntryFormDataSource.requester = res.event.userCode;
            //   this.getEntryFormDataSource.requesterName = res.event.userName;
            //  // this.getEntryFormDataSource.email = res.event.eMail;
            // }

            const dept = res.event.department;
            const deptName = res.event.departmentName;
            if (dept && dept !== 0 && dept !== '0' && deptName && deptName.trim() !== '') {
              this.getEntryFormDataSource.department = dept.toString();
              this.getEntryFormDataSource.departmentName = deptName;
            }
          }
          if (value == 'configuration') {
            // removed assignment to u_Configuration
            res.event.fldValue;
          }
        }
      });
  }
  onReqTypeChange(): void {
    this.getEntryFormDataSource.requester = '';
    this.getEntryFormDataSource.requesterName = '';
  }
  openConfirmDialog(): void {
    this.dialog.open(ConfirmComponent, {
      // width: '250px'
    });
  }
  openEmailDialog(): void {
    this.dialog.open(AddEmailComponent, {
      // width: '250px',
    });
  }
  selectDate(event: any) {
    this.setEntryFormDataSource.documentLines.forEach((ele: any) => {
      event.docDueDate = ele.docDueDate;
    });
  }
  addRow() {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    let formControlsLineLevel: any = {};

    this.allResultsLIneLevel.forEach(res => {

      formControlsLineLevel['U_' + res.Name] = new FormControl(res.DefaultValue || '',);

    })

    this.lineLevelFormGroupArray.push(new FormGroup(formControlsLineLevel));



    let lineItem = new DocumentLinesModel();
    if (this.getFormSubTitle === 'Purchase Request') {
      (lineItem as any).requiredDate = this.getEntryFormDataSource.docDueDate;
    } else {
      lineItem.shipDate = this.getEntryFormDataSource.docDueDate;
    }

    // lineItem.shipDate = this.getEntryFormDataSource.docDueDate;
    // lineItem.requriedDate = this.getEntryFormDataSource.requriedDate;

    this.getEntryFormDataSource.documentLines.push(lineItem);

    this.getEntryFormDataSource.documentLines = [
      ...this.getEntryFormDataSource.documentLines,
    ];
    this.getRowCountEntry();


  }

  deleteRow(index: number) {
    this.lineLevelFormGroupArray.splice(index, 1)

    this.getEntryFormDataSource.documentLines.splice(index, 1);
    this.getEntryFormDataSource.documentLines = [
      ...this.getEntryFormDataSource.documentLines,
    ];
    this.calculateTotals();
    this.calculateDiscountAmt();
    this.removeRowCount();
  }

  changeQuantity(
    itemRow: any,
    event: any,
    i: number,
    value?: number | any,
    notClearTexCode?: Boolean
  ) {
    let calQty: any;

    if ((event?.target?.value != 0 && event?.target?.value != '') || value) {
      calQty = event.value;
      itemRow.openCreQty = event?.target?.value;
      this.getEntryFormDataSource.documentLines[i].unitPrice =
        itemRow.unitPrice;
      if (!notClearTexCode) {
        this.getEntryFormDataSource.documentLines[i].discountPercent = 0;
        this.getEntryFormDataSource.documentLines[i].taxCode = '';
      }

      this.getEntryFormDataSource.documentLines[i].price =
        itemRow.unitPrice - (itemRow.unitPrice * itemRow.discountPercent) / 100;
      this.getEntryFormDataSource.documentLines[i].lineTotal =
        itemRow.price * itemRow.quantity;
      this.getEntryFormDataSource.totalBeforeDiscount =
        itemRow.price * itemRow.quantity;

      // if (itemRow.quantity > this.getEntryFormDataSource.documentLines[i].openCreQty) {
      //   this.getEntryFormDataSource.documentLines[i].openCreQty = (itemRow.quantity - this.getEntryFormDataSource.documentLines[i].openCreQty) + 1;
      // }
      // else{
      //   this.getEntryFormDataSource.documentLines[i].openCreQty = (itemRow.quantity - this.getEntryFormDataSource.documentLines[i].openCreQty) - 1;
      // }

      if (notClearTexCode) {
        this.addtex(this.getEntryFormDataSource.documentLines[i]);
      } else {
        this.calculateTotals();
        this.calculateDiscountAmt();
      }
    }
    else {
      //       const input = document.getElementById("quantityInput") as HTMLInputElement | null;

      // input?.addEventListener("blur", () => {
      //     if (input.value.trim() === "") {
      //         input.value = "1";
      //     }
      // });

      //         itemRow.openCreQty=1;

    }
  }

  changeUnitPrice(
    itemRow: any,
    event: any,
    i: number,
    value?: any,
    notClearTexCode?: Boolean
  ) {
    if ((event?.target?.value != 0 && event?.target?.value != '') || value) {
      this.getEntryFormDataSource.documentLines[i].unitPrice =
        itemRow.unitPrice;
      if (!notClearTexCode) {
        this.getEntryFormDataSource.documentLines[i].discountPercent = 0;
        this.getEntryFormDataSource.documentLines[i].taxCode = '';
      }

      this.getEntryFormDataSource.documentLines[i].price =
        itemRow.unitPrice - (itemRow.unitPrice * itemRow.discountPercent) / 100;
      this.getEntryFormDataSource.documentLines[i].lineTotal =
        itemRow.price * itemRow.quantity;
      this.getEntryFormDataSource.totalBeforeDiscount =
        itemRow.price * itemRow.quantity;

      if (notClearTexCode) {
        this.addtex(this.getEntryFormDataSource.documentLines[i]);
      } else {
        this.calculateTotals();
        this.calculateDiscountAmt();
      }
    }
  }

  changeQuantityByItem(
    itemRow: any,
    event: any,
    i: number,
    value?: number,
    notClearTexCode?: Boolean
  ) {
    let calQty: any;
    if ((event?.target?.value != 0 && event?.target?.value != '') || value) {
      calQty = event.value;

      this.getEntryFormDataSource.documentLines[i].unitPrice =
        itemRow.unitPrice;
      if (!notClearTexCode) {
        this.getEntryFormDataSource.documentLines[i].discountPercent = 0;
        this.getEntryFormDataSource.documentLines[i].taxCode = '';
      }

      this.getEntryFormDataSource.documentLines[i].price =
        itemRow.unitPrice - (itemRow.unitPrice * itemRow.discountPercent) / 100;
      this.getEntryFormDataSource.documentLines[i].lineTotal =
        itemRow.price * itemRow.quantity;
      this.getEntryFormDataSource.totalBeforeDiscount =
        itemRow.price * itemRow.quantity;

      // if (itemRow.quantity > this.getEntryFormDataSource.documentLines[i].openCreQty) {
      //   this.getEntryFormDataSource.documentLines[i].openCreQty = (itemRow.quantity - this.getEntryFormDataSource.documentLines[i].openCreQty) + 1;
      // }
      // else{
      //   this.getEntryFormDataSource.documentLines[i].openCreQty = (itemRow.quantity - this.getEntryFormDataSource.documentLines[i].openCreQty) - 1;
      // }

      if (notClearTexCode) {
        this.addtex(this.getEntryFormDataSource.documentLines[i]);
      }

      // this.calculateTotals();
      this.calculateTotalsEdit();
      this.calculateDiscountAmtEdit();
    }
  }

  changeDiscountPercent(
    itemRow: any,
    event: any,
    i: number,
    value?: any,
    notClearTexCode?: Boolean
  ) {
    let val = event?.target?.value || value || 0;

    if (val > 100) {
      val = 0;
      if (event && event.target) {
        event.target.value = 0;
      }
      this.getEntryFormDataSource.documentLines[i].discountPercent = 0;
      this.snackbarService.showMessage('Discount cannot be greater than 100%', 'X');
    }

    if (val > 0) {
      let discountAmount =
        (this.getEntryFormDataSource.documentLines[i].unitPrice * val) /
        100;

      if (
        discountAmount <= this.getEntryFormDataSource.documentLines[i].unitPrice
      ) {
        this.getEntryFormDataSource.documentLines[i].price =
          this.getEntryFormDataSource.documentLines[i].unitPrice -
          discountAmount;
      } else {
        this.getEntryFormDataSource.documentLines[i].price = 0;
        this.getEntryFormDataSource.documentLines[i].discountPercent = 0;
      }
    } else {
      this.getEntryFormDataSource.totalBeforeDiscount =
        itemRow.price * itemRow.quantity;
      this.getEntryFormDataSource.documentLines[i].price =
        this.getEntryFormDataSource.documentLines[i].unitPrice;
    }

    if (!notClearTexCode) {
      this.getEntryFormDataSource.documentLines[i].taxCode = '';
      this.getEntryFormDataSource.documentLines[i].taxTotal = 0;
    }

    this.getEntryFormDataSource.documentLines[i].lineTotal =
      itemRow.price * itemRow.quantity;
    this.getEntryFormDataSource.totalBeforeDiscount =
      itemRow.price * itemRow.quantity;

    if (notClearTexCode) {
      this.addtex(this.getEntryFormDataSource.documentLines[i]);
    } else {
      this.calculateTotals();
      this.calculateDiscountAmt();
    }
  }

  calculateTotals(event?: any) {
    let docTotal = 0;
    let totalTaxAmount = 0;
    let totalBeforeDis = 0;
    let freightTaxSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.taxSum,
        0
      );
    let freightNetSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.lineTotal,
        0
      );
    let roundingOffAmt =
      this.getEntryFormDataSource.rounding == 'true' ||
        this.getEntryFormDataSource.rounding == 'Y'
        ? (Number(this.getEntryFormDataSource.roundingDiffAmount) || 0)
        : 0;
    this.getEntryFormDataSource.documentLines.map((item: any) => {
      totalTaxAmount = totalTaxAmount + (item.taxTotal ?? 0);
      docTotal = docTotal + item.lineTotal;
      totalBeforeDis = totalBeforeDis + item.price * item.quantity;
    });

    totalTaxAmount += -(
      totalTaxAmount *
      (Number(
        this.getEntryFormDataSource.discountPercent
          ? this.getEntryFormDataSource.discountPercent
          : 0
      ) /
        100)
    );
    totalTaxAmount += +freightTaxSum;
    docTotal += +freightNetSum + freightTaxSum + roundingOffAmt;
    this.getEntryFormDataSource.totalBeforeDiscount = totalBeforeDis;
    this.getEntryFormDataSource.vatSum = totalTaxAmount;
    this.getEntryFormDataSource.docTotal = docTotal;
  }

  calculateTotalsEdit(event?: any) {
    let docTotal = 0;
    let totalTaxAmount = 0;
    let totalBeforeDis = 0;
    let freightTaxSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.taxSum,
        0
      );
    let freightNetSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.lineTotal,
        0
      );
    let roundingOffAmt =
      this.getEntryFormDataSource.rounding == 'true' ||
        this.getEntryFormDataSource.rounding == 'Y'
        ? (Number(this.getEntryFormDataSource.roundingDiffAmount) || 0)
        : 0;
    this.getEntryFormDataSource.documentLines.map((item: any) => {
      totalTaxAmount = totalTaxAmount + (item.taxTotal ?? 0);
      docTotal = docTotal + item.lineTotal;
      totalBeforeDis = totalBeforeDis + item.price * item.quantity;
    });

    // totalTaxAmount += - (totalTaxAmount * (Number(this.getEntryFormDataSource.discountPercent ? this.getEntryFormDataSource.discountPercent : 0) / 100))
    totalTaxAmount += +freightTaxSum;
    docTotal += +freightNetSum + freightTaxSum + roundingOffAmt;
    this.getEntryFormDataSource.totalBeforeDiscount = totalBeforeDis;
    this.getEntryFormDataSource.vatSum = totalTaxAmount;
    this.getEntryFormDataSource.docTotal = docTotal;
  }

  calculateDiscountAmt(event?: any) {
    if (this.getEntryFormDataSource.discountPercent > 100) {
      this.getEntryFormDataSource.discountPercent = 0;
      if (event && event.target) {
        event.target.value = 0;
      }
      this.snackbarService.showMessage('Discount cannot be greater than 100%', 'X');
    }
    if (event) {
      event.checked
        ? (this.getEntryFormDataSource.rounding = 'true')
        : (this.getEntryFormDataSource.rounding = 'false');
    }

    this.calculateTotals();

    this.getEntryFormDataSource.totalDiscount = 0;
    let freightTaxSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.taxSum,
        0
      );
    let freightNetSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.lineTotal,
        0
      );
    let roundingOffAmt =
      this.getEntryFormDataSource.rounding == 'true' ||
        this.getEntryFormDataSource.rounding == 'Y'
        ? (Number(this.getEntryFormDataSource.roundingDiffAmount) || 0)
        : 0;
    this.getEntryFormDataSource.totalDiscount =
      this.getEntryFormDataSource.totalBeforeDiscount *
      (Number(
        this.getEntryFormDataSource.discountPercent
          ? this.getEntryFormDataSource.discountPercent
          : 0
      ) /
        100);
    this.getEntryFormDataSource.docTotal =
      this.getEntryFormDataSource.totalBeforeDiscount -
      this.getEntryFormDataSource.totalDiscount +
      freightNetSum +
      roundingOffAmt;

    this.getEntryFormDataSource.docTotal += this.getEntryFormDataSource.vatSum;
  }

  calculateDiscountAmtEdit(event?: any) {
    if (this.getEntryFormDataSource.discountPercent > 100) {
      this.getEntryFormDataSource.discountPercent = 0;
      if (event && event.target) {
        event.target.value = 0;
      }
      this.snackbarService.showMessage('Discount cannot be greater than 100%', 'X');
    }
    if (event) {
      event.checked
        ? (this.getEntryFormDataSource.rounding = 'true')
        : (this.getEntryFormDataSource.rounding = 'false');
    }

    this.calculateTotalsEdit();

    this.getEntryFormDataSource.totalDiscount = 0;
    let freightTaxSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.taxSum,
        0
      );
    let freightNetSum =
      this.getEntryFormDataSource.documentAdditionalExpenses.reduce(
        (sum: number, item: any) => sum + +item.lineTotal,
        0
      );
    let roundingOffAmt =
      this.getEntryFormDataSource.rounding == 'true' ||
        this.getEntryFormDataSource.rounding == 'Y'
        ? (Number(this.getEntryFormDataSource.roundingDiffAmount) || 0)
        : 0;
    this.getEntryFormDataSource.totalDiscount =
      this.getEntryFormDataSource.totalBeforeDiscount *
      (Number(
        this.getEntryFormDataSource.discountPercent
          ? this.getEntryFormDataSource.discountPercent
          : 0
      ) /
        100);
    this.getEntryFormDataSource.docTotal =
      this.getEntryFormDataSource.totalBeforeDiscount -
      this.getEntryFormDataSource.totalDiscount +
      freightNetSum +
      roundingOffAmt;

    this.getEntryFormDataSource.docTotal += this.getEntryFormDataSource.vatSum;
  }

  openDialog1() {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    let filterDialogRef = this.dialog.open(FreightDetailComponent, {
      width: '1000px',
      data: {
        frieghtDetails: this.getEntryFormDataSource.documentAdditionalExpenses,
        formMode: {
          formModeType: this.getFormMode,
          formTitle: this.getFormSubTitle,
          documentStatus: isViewOnly ? 'C' : this.getEntryFormDataSource.documentStatus,
          navFrom: this.navFrom,
        },
      },
    });
    filterDialogRef.afterClosed().subscribe((res: any) => {
      this.getEntryFormDataSource.documentAdditionalExpenses =
        res.value.frieghtDetails;
      this.getEntryFormDataSource.totalExpns = res.value.freightSum;
      this.getEntryFormDataSource.vatSum += +res.value.freightTaxSum;
      //   this.calculateTotals();
      this.calculateDiscountAmt();
    });
  }
  onSelectedFiles(event: any) {
    this.genAttachUpload.setSelectedFileList = event;
    this.selectedFile.push(...Array.from(event.target.files));
    for (let i = 0; i < this.selectedFile.length; i++) {
      var _files = new Attachments2_LinesModel();
      _files.FileName = event.target.files[i].name;
      _files.FileExtension =
        event.target.files[i].name.split('.')[
        event.target.files[i].name.split('.').length - 1
        ];
      this.getEntryFormDataSource.Attachments2_Lines.push(_files);
    }
    this.genAttachUpload.onSelectedFiles();
  }
  onUpload() {
    if (this.validateFileSize()) {
      this.genAttachUpload.onUploadFiles(
        this.getEntryFormDataSource.attachmentEntry
      );
    } else {
      this.openDialog();
    }
  }

  validateFileSize() {
    const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes
    const files = this.selectedFile;
    let errors: string[] = [];

    if (files.length > 10) {
      errors.push('You can only upload a maximum of 10 files.');
    } else {
      files.forEach((el, i): any => {
        let file: any = files[i];
        if (file.size > maxFileSize) {
          errors.push(`File "${file.name}" exceeds the 5 MB size limit.`);
        }
      });
    }

    if (errors.length > 0) {
      this.showValidationArr = errors;
      return false;
    } else {
      return true;
    }
  }

  onAttachmentDelete(val: number) {
    this.selectedFile.splice(val, 1);
    this.getEntryFormDataSource.Attachments2_Lines.splice(val, 1);
    this.getEntryFormDataSource.Attachments2_Lines = [
      ...this.getEntryFormDataSource.Attachments2_Lines,
    ];
    if (
      this.getEntryFormDataSource.attachmentEntry != null &&
      this.getEntryFormDataSource.attachmentEntry != '' &&
      this.getEntryFormDataSource.attachmentEntry != undefined
    ) {
      this.genAttachUpload.onAttachmentDeleteFiles(
        this.getEntryFormDataSource.attachmentEntry,
        this.getEntryFormDataSource.Attachments2_Lines
      );
    }
  }

  viewImage(attachmentEntry: number, filePath = '') {
    //  window.open(`${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})/$value`, "_blank");
    this.ngxUiLoaderService.start();
    const url = `${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})/$value`;
    const companyID: any = sessionStorage.getItem('companyID');
    const token: any = sessionStorage.getItem('sapToken');
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
        'x-b1-companyid': encodeURIComponent(companyID),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch attachment');
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        this.ngxUiLoaderService.stop();
        // Optional: clean up the blob URL after some time
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
      })
      .catch((error) => {
        console.error('Download error:', error);
      });
  }

  // viewClick(i: any) {
  //   const imgExt = ['jpg', 'jpeg', 'gif', 'png'];
  //   let imgSrc
  //   let type;
  //   let extensionOfFile: any = this.getEntryFormDataSource.Attachments2_Lines[i].FileExtension;
  //   if (imgExt.includes(extensionOfFile)) {
  //     imgSrc = 'data:image/png;base64,' + this.getEntryFormDataSource.Attachments2_Lines[i].FileName;
  //     type = 'img'
  //   }
  //   else {
  //     let src = 'data:application/pdf;base64,' + this.getEntryFormDataSource.Attachments2_Lines[i].FileName;
  //     imgSrc = src
  //     type = 'pdf'
  //   }

  //   const dialogRef = this.dialog.open(AttachmentViewComponent, {
  //     width: '1000px',//'1028px',
  //     panelClass: ['custom-style', 'custom-style1'],
  //     disableClose: true,
  //     data: {
  //       title: '',
  //       src: imgSrc,
  //       fileType: type,
  //       screenName: 'add'
  //     },
  //   });
  // }

  openDialog2(): void {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    this.dialog.open(AddBatchComponent, {
      // width: '250px'
    });
  }
  openDialog3(): void {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    this.dialog.open(AddSerialComponent, {
      // width: '250px'
    });
  }
  openDialog4(): void {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    this.dialog.open(TdsPopupComponent, {
      // width: '250px'
    });
  }
  openDialog6(itemRow: any, event: any, i: number): void {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    if (!itemRow.taxCode) {
      this.snackbarService.showMessage('Please select Tax Code first', 'OK');
      return;
    }
    this.dialog.open(TaxAmountPopupComponent, {
      data: {
        taxCode: itemRow.taxCode,
        taxName: itemRow.taxName,
        baseAmount: itemRow.price * itemRow.quantity
      },
    });
  }

  async autoPopulateVendor(vendorCode: string) {
    try {
      const payload = new WrapperStandardRequest();
      payload.RequestData = [
        { Key: 'cardCode', Value: vendorCode, OperatorType: 'startswith' },
        { Key: 'cardCode', Value: '', OperatorType: 'endswith' },
        { Key: 'valid', Value: 'Y', OperatorType: 'contains' }
      ];
      payload.SortColumn = '';
      payload.IsAcending = true;
      payload.PageSize = 1;
      payload.PageRecordCount = 10;

      const bpResponse: any = await lastValueFrom(
        this.agenericRepositoryForCfl.PostAPI(
          GlobalProperties.getApiUrl + 'BusinessPartner/GetBusinessPartnerListService',
          payload
        )
      );

      if (bpResponse && bpResponse.responseData && bpResponse.responseData.length > 0) {
        const vendor = bpResponse.responseData[0];
        this.getEntryFormDataSource.cardCode = vendor.cardCode;
        this.getEntryFormDataSource.cardName = vendor.cardName;

        // Also call the main service to fill out the rest of the form (addresses, currency, etc)
        const detailPayload = new WrapperStandardRequest();
        detailPayload.RequestData = vendor.cardCode;
        const customerResponse: any = await lastValueFrom(
          this.agenericRepositoryForCfl.PostAPI(
            GlobalProperties.getApiUrl + 'BusinessPartner/GetBusinessPartnerService',
            detailPayload
          )
        );
        if (customerResponse && customerResponse.responseData) {
          const bp = customerResponse.responseData;
          this.getEntryFormDataSource.contactPersonCodeName = bp.contactPerson;
          this.getEntryFormDataSource.contactPersonCode = bp.contactPersonCode;
          this.getEntryFormDataSource.salesPersonCode = bp.slpCode;
          this.getEntryFormDataSource.docCurrency = bp.currency;
          this.getEntryFormDataSource.docCurrencyName = bp.currencyName;
          this.getEntryFormDataSource.salesPersonCodeName = bp.slpName;
          this.getEntryFormDataSource.paymentGroupCode = bp.payTermsGrpCode;
          this.getEntryFormDataSource.paymentGroupCodeName = bp.payTermsGrpCodeName;
          this.getEntryFormDataSource.address = '';
          this.getEntryFormDataSource.address2 = '';
          this.getEntryFormDataSource.payToCode = bp.billtoDefault;
          this.getEntryFormDataSource.shipToCode = bp.shipToDefault;

          // Map UDF address fields if they exist
          const ds: any = this.getEntryFormDataSource;
          ds.tIAddress1 = bp.tiAddress1;
          ds.tIAddress2 = bp.tiAddress2;
          ds.tIAddress3 = bp.tiAddress3;
          ds.u_TIAdCity = bp.u_TIAdCity;
          ds.u_TIAdSate = bp.u_TIAdSate;
          ds.u_TIAdSateN = bp.u_TIAdSateN;
          ds.u_TIAdCntN = bp.u_TIAdCntN;
          ds.u_TIAdZip = bp.u_TIAdZip;
          ds.u_TICntNme = bp.u_TICntNme;
          ds.u_TICntNmeN = bp.u_TICntNmeN;
        }
      }
    } catch (error) {
      console.error('Error fetching Business Partner details for auto-populate', error);
    }
  }

  async copyFromDialog(screen: {
    name: string;
    listEndPoint: string;
    getEndPoint: string;
  }) {
    this.getEntryFormDataSource.documentLines = [];
    const docEntryResponse: any = await lastValueFrom(
      this.dialog
        .open(CopyFromPopupComponent, {
          data: {
            docEntry:
              screen.name != 'Purchase Request'
                ? this.getEntryFormDataSource.cardCode
                : this.getEntryFormDataSource.requester,
            endPoint: screen.listEndPoint,
            name: screen.name,
          },
        })
        .afterClosed()
    );
    this.getEntryFormDataSource.documentLines = [];
    this.documentLinesData = [];
    let docNums = [];
    const docEntry = docEntryResponse?.value;

    if (docEntry) {
      this.ngxUiLoaderService.start();

      const dsAny: any = this.getEntryFormDataSource;
      const existingHeaderDetails = {
        cardCode: dsAny.cardCode,
        cardName: dsAny.cardName,
        contactPersonCode: dsAny.contactPersonCode,
        contactPersonCodeName: dsAny.contactPersonCodeName,
        salesPersonCode: dsAny.salesPersonCode,
        salesPersonCodeName: dsAny.salesPersonCodeName,
        docCurrency: dsAny.docCurrency,
        docCurrencyName: dsAny.docCurrencyName,
        paymentGroupCode: dsAny.paymentGroupCode,
        paymentGroupCodeName: dsAny.paymentGroupCodeName,
        address: dsAny.address,
        address2: dsAny.address2,
        payToCode: dsAny.payToCode,
        shipToCode: dsAny.shipToCode,
        vatRegNum: dsAny.vatRegNum,
        // removed assignment to u_InCoTerm
        tIAddress1: dsAny.tIAddress1,
        tIAddress2: dsAny.tIAddress2,
        tIAddress3: dsAny.tIAddress3,
        u_TIAdCity: dsAny.u_TIAdCity,
        u_TIAdSate: dsAny.u_TIAdSate,
        u_TIAdSateN: dsAny.u_TIAdSateN,
        u_TIAdCntN: dsAny.u_TIAdCntN,
        u_TIAdZip: dsAny.u_TIAdZip,
        u_TICntNme: dsAny.u_TICntNme,
        u_TICntNmeN: dsAny.u_TICntNmeN,
        seqCode: dsAny.seqCode,
        seqName: dsAny.seqName,
        nextNum: dsAny.nextNum,
        bpL_IDAssignedToInvoice: dsAny.bpL_IDAssignedToInvoice,
        branchName: dsAny.branchName,
        department: dsAny.department,
        departmentName: dsAny.departmentName,
        ownerCode: dsAny.ownerCode,
        ownerCodeName: dsAny.ownerCodeName,
        requester: dsAny.requester,
        requesterName: dsAny.requesterName,
        gstTranTyp: dsAny.gstTranTyp,
        gstTranTypName: dsAny.gstTranTypName,
        placeOfSupplyCode: dsAny.placeOfSupplyCode,
        placeOfSupplyCodeName: dsAny.placeOfSupplyCodeName
      };

      for (const i of docEntry) {
        this.setURLForFormModeEdit = screen.getEndPoint;
        this.setRequestDataForFormModeEdit = [
          {
            Key: 'DocEntry',
            Value: i.docEntry.toString(),
            OperatorType: 'contains'
          },
          {
            Key: 'ItemCode',
            Value: '',
            OperatorType: 'startsWith'
          },
          {
            Key: 'ItemCode',
            Value: '',
            OperatorType: 'endswith'
          }
        ];
        this.setFormMode = enumFormModes.ModeEdit;
        await this.PopulateEntryForm_V2();
        //  this.onOpenDropDown('')
        this.preapreDocumentForCopy();
        docNums.push(i.docNum);
      }

      const currentDsAny: any = this.getEntryFormDataSource;
      Object.keys(existingHeaderDetails).forEach((key) => {
        const val = (existingHeaderDetails as any)[key];
        if (val !== undefined && val !== null && val !== '' && val !== 0) {
          currentDsAny[key] = val;
        }
      });

      this.getEntryFormDataSource.comments =
        'Based on ' + screen.name + ' ' + docNums.join(', ');

      this.getEntryFormDataSource.docDate = new Date().toISOString();
      this.getEntryFormDataSource.docDueDate = new Date().toISOString();
      this.getEntryFormDataSource.originalRefDate = new Date().toISOString();
      this.getEntryFormDataSource.requriedDate = new Date().toISOString();

      // Do not map or populate the source Doc. Series in the target document
      delete (this.getEntryFormDataSource as any).series;
      delete (this.getEntryFormDataSource as any).seriesName;

      this.setFormMode = enumFormModes.ModeNew;
      this.btnText = 'Language.AddText';
      this.setFormDisable = false;

      this.getBranchAndSeries();

      let baseRequest = new WrapperStandardRequest();
      let docEntriesString = docEntry.map((d: any) => d.docEntry).join(',');

      baseRequest.RequestData = [
        {
          Key: 'DocEntry',
          Value: docEntriesString,
          OperatorType: 'contains'
        }
      ];

      this.ngxUiLoaderService.stop();

      const response: any = await lastValueFrom(
        this.dialog
          .open(ItemComponent, {
            data: {
              name: screen.name,
              lines: this.documentLinesData,
              url: this.getURLForFormModeEdit,
              requestData: baseRequest,
              docEntry: docEntriesString
            },
          })
          .afterClosed()
      );

      const copiedLines = response?.value || [];
      console.log('response.value', copiedLines);

      if (copiedLines.length > 0) {
        this.ngxUiLoaderService.start();
      }

      // Temporarily hide lines from Angular to prevent Change Detection from freezing the UI during processing
      this.getEntryFormDataSource.documentLines = [];

      if (!this.getEntryFormDataSource.cardCode && screen.name === 'Purchase Request' && copiedLines.length > 0) {
        const vendorCode = copiedLines[0].lineVendor;
        if (vendorCode) {
          await this.autoPopulateVendor(vendorCode);
        }
      }

      // Chunk the synchronous math calculations to keep the main thread unblocked
      const totalMathLines = copiedLines.length;
      for (let i = 0; i < totalMathLines; i += 50) {
        const batch = copiedLines.slice(i, i + 50);
        batch.forEach((el: any) => {
          if (el.taxRate !== undefined && el.taxRate !== null && el.taxRate !== '') {
            el.taxTotal = (el.taxRate * (el.price || 0) * (el.quantity || 0)) / 100;
          } else {
            el.taxTotal = el.taxTotal || 0;
          }
          el.lineTotal = el.taxTotal + ((el.price || 0) * (el.quantity || 0));

          if (screen.name === 'Purchase Request') {
            el.shipDate = this.getEntryFormDataSource.docDueDate;
          }
        });
        await new Promise(resolve => setTimeout(resolve, 0)); // Yield to event loop
      }

      // await this.fetchUDFsForCopiedLines();

      if (this.getFormSubTitle === 'Purchase Order') {
        await this.fetchPurchaseOrderCopyFromAPIs(copiedLines);
      } else {
        // Progressively render lines if not using the PO API to avoid DOM freeze
        const renderBatchSize = 20;
        for (let i = 0; i < copiedLines.length; i += renderBatchSize) {
          const batch = copiedLines.slice(i, i + renderBatchSize);
          this.getEntryFormDataSource.documentLines = [
            ...this.getEntryFormDataSource.documentLines,
            ...batch
          ];

          const currentEnd = Math.min(i + renderBatchSize, copiedLines.length);
          const percentage = Math.round((currentEnd / copiedLines.length) * 100);
          this.copyProgressMessage = `Rendering Line ${currentEnd} of ${copiedLines.length} (${percentage}%)`;
          await new Promise(resolve => setTimeout(resolve, 10)); // Yield to paint
        }
        this.copyProgressMessage = '';
      }

      this.calculateTotals();
      this.calculateDiscountAmt();

      setTimeout(() => {
        this.ngxUiLoaderService.stop();
      }, 500);
    }
  }

  async fetchUDFsForCopiedLines() {
    if (!this.getEntryFormDataSource.documentLines || this.getEntryFormDataSource.documentLines.length === 0) return;
    for (let index = 0; index < this.getEntryFormDataSource.documentLines.length; index++) {
      let curItemCode = this.getEntryFormDataSource.documentLines[index].itemCode || '';
      if (curItemCode) {
        const fetchUDF = async (endpoint: string, overrideReqData?: any) => {
          if (overrideReqData === null) return null; // Skip call if explicitly null
          const payload = new WrapperStandardRequest();
          payload.RequestData = overrideReqData !== undefined ? overrideReqData : curItemCode;
          payload.PageSize = 1;
          payload.PageRecordCount = 10;
          payload.SortColumn = "";
          payload.IsAcending = true;
          try {
            const resp = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + endpoint, payload));
            if (resp) {
              if (resp.responseData !== undefined) {
                return resp.responseData.list ? resp.responseData.list[0] : (Array.isArray(resp.responseData) ? resp.responseData[0] : resp.responseData);
              } else if (Array.isArray(resp)) {
                return resp[0];
              }
              return resp;
            }
          } catch (err) { console.error(endpoint, err); }
          return null;
        };

        const docLine = this.getEntryFormDataSource.documentLines[index];
        const reqPOPR = {
          DocEntry: Number(docLine.baseEntry || docLine.docEntry || 0),
          LineNum: Number(docLine.baseLine ?? docLine.lineNum ?? 0)
        };




        try {
          const [
            // budgetAmt,
            // utilizeCommBud,
            // commitBud
          ] = await Promise.all([
            //
            //
            //
            //
            //
            //
            //
            //
            //
            // fetchUDF('PurchaseOrders/GetPoBudgetAmount', reqBudgetAmt),
            // fetchUDF('PurchaseOrders/GetPOUtilizeBudgetcommited', reqUtilizeBud),
            // fetchUDF('PurchaseOrders/GetPOCommetedBudget', reqCommitBud)
          ]);

          const extractVal = (obj: any, keys: string[]) => {
            if (obj === null || obj === undefined) return '';
            if (typeof obj !== 'object') return obj;
            for (let k of keys) {
              if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
            }
            return obj.fldValue || obj.descr || obj.value || obj.Value || obj.name || obj.Name || obj.code || obj.Code || '';
          };

          if (this.getEntryFormDataSource.documentLines[index]) {
            // removed assignment to u_BasePrice
            // removed assignment to u_MinPP
            // removed assignment to u_MaxPP
            // removed assignment to u_LPP
            // removed assignment to u_LPVndr
            // removed assignment to u_MPIN
            // removed assignment to u_CurYear
            // removed assignment to u_LstYear
            // removed assignment to u_BaseQty
            // removed assignment to u_BudAmt
            // removed assignment to u_UtiBud
            // removed assignment to u_ComBud
          }
        } catch (e) { console.error('Get UDFs failed', e); }
      }
    }
  }


  // ============================================================================
  // ========================= COPY TO/FROM LOGIC =========================
  // ============================================================================

  // ============================================================================
  // ========================= COPY TO/FROM LOGIC =========================
  // ============================================================================
  async fetchPurchaseOrderCopyFromAPIs(linesToProcess: any[] = this.getEntryFormDataSource.documentLines) {
    if (!linesToProcess || linesToProcess.length === 0) return;

    this.ngxUiLoaderService.start();


    const lines = linesToProcess;
    const totalLines = lines.length;
    const batchSize = 500;

    for (let i = 0; i < totalLines; i += batchSize) {
      const batch = lines.slice(i, i + batchSize);

      const currentEnd = Math.min(i + batchSize, totalLines);
      const percentage = Math.round((currentEnd / totalLines) * 100);
      this.copyProgressMessage = `Processing Line ${currentEnd} of ${totalLines} (${percentage}%)`;
      console.log(this.copyProgressMessage);

      const batchPromises = batch.map(async (docLine: any, batchIndex: number) => {
        // UDF API fetches have been removed
      });

      await Promise.all(batchPromises);

      // Progressively append processed batch to the table
      this.getEntryFormDataSource.documentLines = [
        ...this.getEntryFormDataSource.documentLines,
        ...batch
      ];

      await new Promise(resolve => setTimeout(resolve, 10)); // Yield to UI thread to paint the DOM chunks
    }

    this.copyProgressMessage = '';
  }

  initCopyTo(screen: { name: string; routeTo: string }) {
    console.log(
      'this.getEntryFormDataSource.docEntry',
      this.getEntryFormDataSource
    );
    this.routerForCfl.navigate([`home/sales/${screen.routeTo}/0`], {
      state: {
        copyFromEndPoint: this.getURLForFormModeEdit.slice(
          this.getURLForFormModeEdit.lastIndexOf('v1.0') + 5
        ),
        docEntry: this.getEntryFormDataSource.docEntry,
        docInfo:
          'Based on ' +
          this.getFormSubTitle +
          ' ' +
          this.getEntryFormDataSource.docNum,
      },
    });
  }

  prepareDocumentForChanges() {
    const documentLines: DocumentLinesModel[] = [];
    this.getEntryFormDataSource.documentLines.forEach((el) => {
      const documentLineItem = new DocumentLinesModel();
      documentLineItem.shipDate = new Date(
        this.getEntryFormDataSource.docDueDate
      );
      documentLineItem.itemCode = el.itemCode;
      documentLineItem.itemDescription = el.itemDescription;
      documentLineItem.quantity = el.quantity;
      documentLineItem.docNum = this.getEntryFormDataSource.docNum;
      documentLineItem.docEntry = this.getEntryFormDataSource.docEntry;
      documentLines.push(documentLineItem);
    });
    this.getEntryFormDataSource.documentLines = [...documentLines];

    this.documentLinesData.push(...documentLines);
  }

  preapreDocumentForCopy() {
    let docnum = this.getEntryFormDataSource.docNum;
    let objectType = this.getEntryFormDataSource.objType;
    (this.getEntryFormDataSource.docEntry as any) = null;
    (this.getEntryFormDataSource.docNum as any) = null;
    this.getEntryFormDataSource.documentStatus = 'bost_Open';
    this.getEntryFormDataSource.documentStatusName = 'Open';
    const documentLines: DocumentLinesModel[] = [];
    console.log(
      ' this.getEntryFormDataSource.documentLines',
      this.getEntryFormDataSource.documentLines
    );
    this.getEntryFormDataSource.documentLines.forEach((el, i) => {
      const documentLineItem = new DocumentLinesModel();
      documentLineItem.accountCode = el.accountCode;
      documentLineItem.itemCode = el.itemCode;
      documentLineItem.itemDescription = el.itemDescription;

      documentLineItem.docNum = docnum;
      documentLineItem.openCreQty = el.openCreQty || (el as any).remainingOpenQuantity;
      documentLineItem.openQty = el.openQty || (el as any).remainingOpenQuantity;
      documentLineItem.quantity = el.openQty || el.openCreQty || (el as any).remainingOpenQuantity;
      documentLineItem.warehouseCode = el.warehouseCode;
      documentLineItem.wareHouseName = el.wareHouseName;
      documentLineItem.warehouseQuantity = el.warehouseQuantity;
      documentLineItem.manageBatchNumbers = el.manageBatchNumbers;
      documentLineItem.manageSerialNumbers = el.manageSerialNumbers;
      documentLineItem.serialNumbers = el.serialNumbers;
      documentLineItem.batchNumbers = el.batchNumbers;
      documentLineItem.price = el.price;
      documentLineItem.unitPrice = el.unitPrice;
      documentLineItem.discountPercent = el.discountPercent;
      documentLineItem.locationCode = el.locationCode;
      documentLineItem.taxTotal = el.taxTotal;
      documentLineItem.taxCode = el.taxCode;
      documentLineItem.lineTotal = el.lineTotal;
      documentLineItem.lineNum = el.lineNum;
      documentLineItem.chapterID = el.chapterID;
      documentLineItem.locationName = el.locationName;
      documentLineItem.lineStatus = el.lineStatus;
      (documentLineItem.taxRate = el.taxRate),
        (documentLineItem.baseRef = docnum);
      documentLineItem.baseType = objectType;
      documentLineItem.baseLine = el.lineNum;
      documentLineItem.baseEntry = el.docEntry;
      documentLineItem.gstRelevnt = el.gstRelevnt;
      documentLineItem.shipDate = new Date().toISOString();
      // removed assignment to u_MPIN
      // removed assignment to u_Category
      // removed assignment to u_BudAmt
      // removed assignment to u_UtiBud
      // removed assignment to u_REmBudg
      // removed assignment to u_ComBud
      // removed assignment to u_Configuration
      // removed assignment to u_ETADate
      // removed assignment to u_LineRemark
      // removed assignment to u_LeadTime
      // removed assignment to u_BasePrice
      // removed assignment to u_MinPP
      // removed assignment to u_MaxPP
      // removed assignment to u_LPP
      // removed assignment to u_LPVndr
      // removed assignment to u_CurYear
      // removed assignment to u_LstYear
      // removed assignment to u_BaseQty

      documentLineItem.lineVendor = el.lineVendor;
      documentLineItem.lineVendorName = el.lineVendorName;
      documentLineItem.uoMEntry = el.uoMEntry;
      documentLineItem.sacEntry = el.sacEntry;
      documentLineItem.hsnEntry = el.hsnEntry;
      (documentLineItem as any).requriedDate = (el as any).requriedDate || (el as any).requiredDate;
      (documentLineItem as any).remainingOpenQuantity = (el as any).remainingOpenQuantity;
      documentLineItem.projectCode = el.projectCode;
      documentLineItem.projectName = el.projectName;
      documentLineItem.accountName = el.accountName;
      documentLineItem.uoMCode = (el as any).uomCode || el.uoMCode;
      documentLineItem.ocrCode = el.ocrCode;
      (documentLineItem as any).documentAdditionalExpenses = (el as any).documentAdditionalExpenses;
      documentLineItem.documentAdditionalExpenses_DocLine = (el as any).documentAdditionalExpenses_DocLine;

      documentLines.push(documentLineItem);
    });
    this.getEntryFormDataSource.documentLines = [...documentLines];
    this.documentLinesData.push(...documentLines);
    console.log('this.documentLinesData', this.documentLinesData);
  }

  getRowCountEntry() {
    if (this.getFormMode == 1) {
      this.rowCount;
    }
    this.rowCount++;
  }

  removeRowCount() {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    this.rowCount--;
  }

  selectAddress(item: any) {
    if (item?.addressType == 'bo_BillTo') {
      let address: string = '';
      if (item.addressName2 && item.addressName2 != null) {
        address = address + item.addressName2 + ', ';
      }
      if (item.addressName3 && item.addressName3 != null) {
        address = address + item.addressName3 + ', ';
      }
      if (item.block && item.block != null) {
        address = address + item.block + ', ';
      }
      if (item.buildingFloorRoom && item.buildingFloorRoom != null) {
        address = address + item.buildingFloorRoom + ', ';
      }
      if (item.city && item.city != null) {
        address = address + item.city + ', ';
      }
      if (item.country && item.addressName2 != null) {
        address = address + item.country + ', ';
      }
      if (item.stateName && item.stateName != null) {
        address = address + item.stateName + ', ';
      }
      if (item.street && item.street != null) {
        address = address + item.street + ', ';
      }
      if (item.streetNo && item.streetNo != null) {
        address = address + item.streetNo + ', ';
      }
      if (item.zipCode && item.zipCode != null) {
        address = address + item.zipCode + ', ';
      }
      if (item.countryName && item.countryName != null) {
        address = address + item.countryName;
      }

      this.getEntryFormDataSource.address = address;
    } else if (item?.addressType == 'bo_ShipTo') {
      let address: string = '';
      if (item.addressName2 && item.addressName2 != null) {
        address = address + item.addressName2 + ', ';
      }
      if (item.addressName3 && item.addressName3 != null) {
        address = address + item.addressName3 + ', ';
      }
      if (item.block && item.block != null) {
        address = address + item.block + ', ';
      }
      if (item.buildingFloorRoom && item.buildingFloorRoom != null) {
        address = address + item.buildingFloorRoom + ', ';
      }
      if (item.city && item.city != null) {
        address = address + item.city + ', ';
      }
      if (item.country && item.addressName2 != null) {
        address = address + item.country + ', ';
      }
      if (item.stateName && item.stateName != null) {
        address = address + item.stateName + ', ';
      }
      if (item.street && item.street != null) {
        address = address + item.street + ', ';
      }
      if (item.streetNo && item.streetNo != null) {
        address = address + item.streetNo + ', ';
      }
      if (item.zipCode && item.zipCode != null) {
        address = address + item.zipCode + ', ';
      }
      if (item.countryName && item.countryName != null) {
        address = address + item.countryName;
      }
      this.getEntryFormDataSource.address2 = address;
      this.getEntryFormDataSource.shipToCode = item.addressName;
      this.getEntryFormDataSource.placeOfSupplyCodeName = item.stateName;
      this.getEntryFormDataSource.placeOfSupplyCode = item.state;
    }
  }

  onChangeDeliveryDate(event: any) {
    this.getEntryFormDataSource.documentLines.forEach(
      (el) => (el.shipDate = event.value)
    );
  }

  openDialog12(): void {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    this.dialog.open(ExchangeRateEntryFormComponent, {
      width: '650px',
    });
  }

  onDateChange() { }

  adjustTotalAmt() { }

  showBatchSerialAddPopup(
    itemRow: any,
    i: number,
    isSerialed: boolean,
    isBatched: boolean
  ) {
    if (this.getFormDisable) {
      itemRow.isViewMode = this.getFormDisable;
    }
    itemRow = { ...itemRow, warehouseName: itemRow.wareHouseName };
    if (+this.getEntryFormDataSource.documentLines[i].quantity) {
      if (itemRow.manageSerialNumbers == 'Y') {
        if (isSerialed) {
          itemRow['isSerialed'] = true;
          itemRow.serialNumbers =
            this.getEntryFormDataSource.documentLines[i].serialNumbers;
        }
        this.dialog
          .open(BatchSerialAddPopupComponent, { data: itemRow })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              itemRow['isSerialed'] = this.isSerialed(i);
              this.getEntryFormDataSource.documentLines[i].serialNumbers = [];
              this.getEntryFormDataSource.documentLines[i].serialNumbers.push(
                ...res.value
              );
            }
          });
      } else if (itemRow.manageBatchNumbers == 'Y') {
        if (isBatched) {
          itemRow['isBatched'] = true;
          console.log(
            'this.getEntryFormDataSource.documentLines[i].batchNumbers',
            this.getEntryFormDataSource.documentLines[i].batchNumbers
          );
          itemRow.batchNumbers =
            this.getEntryFormDataSource.documentLines[i].batchNumbers;
        }
        this.dialog
          .open(BatchSerialAddPopupComponent, { data: itemRow })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              itemRow['isBatched'] = this.isBatched(i);
              this.getEntryFormDataSource.documentLines[i].batchNumbers = [];
              // this.getEntryFormDataSource.documentLines[i].batchNumbers.push(...res.value);
              const transformedBatchNumbers = res.value.map(
                ({ batchNumberProperty, ...rest }: any) => ({
                  ...rest,
                  batchNumber: batchNumberProperty,
                  // Rename property
                  batchNumberProperty: batchNumberProperty, // Rename property
                })
              );
              this.getEntryFormDataSource.documentLines[i].batchNumbers.push(
                ...transformedBatchNumbers
              );
            }
          });
      }
    } else {
      this.snackbarService.showMessage('Please enter required quantity', 'X');
    }
  }

  showBatchSerialPopup(
    itemRow: any,
    i: number,
    isSerialed: boolean,
    isBatched: boolean
  ) {
    if (this.getFormDisable) {
      itemRow.isViewMode = this.getFormDisable;
    }
    if (+this.getEntryFormDataSource.documentLines[i].quantity) {
      let itemRowData = { ...itemRow, warehouseName: itemRow.wareHouseName };
      // itemRowData.itemCode = this.productionOrderResponseList[i].itemNo;
      if (itemRowData.manageSerialNumbers == 'Y') {
        if (isSerialed) {
          itemRowData['isSerialed'] = isSerialed;
          itemRowData.serialNumbers =
            this.getEntryFormDataSource.documentLines[i].serialNumbers;
          itemRowData.batchNumbers = null;
        }
        this.dialog
          .open(BatchSerialPopupComponent, { data: itemRowData })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.getEntryFormDataSource.documentLines[i].serialNumbers = [];
              this.getEntryFormDataSource.documentLines[i].serialNumbers.push(
                ...res.value
              );
            }
          });
      } else if (itemRowData.manageBatchNumbers == 'Y') {
        if (isBatched) {
          itemRowData['isBatched'] = isBatched;
          itemRowData.batchNumbers =
            this.getEntryFormDataSource.documentLines[i].batchNumbers;
          itemRowData.serialNumbers = null;
          console.log(' itemRowData.batchNumbers', itemRowData.batchNumbers);
        }
        this.dialog
          .open(BatchSerialPopupComponent, { data: itemRowData })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.getEntryFormDataSource.documentLines[i].batchNumbers = [];
              this.getEntryFormDataSource.documentLines[i].batchNumbers.push(
                ...res.value
              );
            }
          });
      }
    } else {
      this.snackbarService.showMessage('Please enter required quantity', 'X');
    }
  }

  isSerialed(i: number): any {
    if (this.getEntryFormDataSource.documentLines[i].serialNumbers) {
      return (
        this.getEntryFormDataSource.documentLines[i].quantity ==
        this.getEntryFormDataSource.documentLines[i].serialNumbers.reduce(
          (sum, item) => sum + item.quantity,
          0
        )
      );
    }
  }

  isBatched(i: number): any {
    if (this.getEntryFormDataSource.documentLines[i].batchNumbers) {
      return (
        this.getEntryFormDataSource.documentLines[i].quantity ==
        this.getEntryFormDataSource.documentLines[i].batchNumbers.reduce(
          (sum, item) => sum + item.quantity,
          0
        )
      );
    }
  }

  roundOff(value: any) {
    return Math.round(value * 100) / 100;
  }

  checkNonIRNCustomer(cusData: any) {
    let item = cusData?.bpAddresses?.filter(
      (el: any) => el.addressName == cusData.billtoDefault
    )[0];
    let isGSTIN = item?.gstin ? true : false;
    if (this.getFormSubTitle == 'Sales Invoice') {
      this.eWayTabComp.withIRN = isGSTIN;
    }
    this.showEInvoice = isGSTIN;
  }

  async getBranchAndSeries() {
    let objectType = '';
    if (this.getFormSubTitle == 'Purchase Order') {
      objectType = '22';
    } else if (this.getFormSubTitle == 'Debit Notes') {
      objectType = '19';
    } else if (this.getFormSubTitle == 'Purchase Down Payment Request') {
      objectType = '204';
    }
    if (this.getFormSubTitle == 'Sales Order') {
      objectType = '17';
    } else if (this.getFormSubTitle == 'Sales Invoice') {
      objectType = '13';
    } else if (this.getFormSubTitle == 'Sales Quotation') {
      objectType = '23';
    } else if (this.getFormSubTitle == 'Purchase Order') {
      objectType = '22';
    } else if (this.getFormSubTitle == 'Purchase Quotation') {
      objectType = '540000006';
    } else if (this.getFormSubTitle == 'Purchase Invoice') {
      objectType = '18';
    } else if (this.getFormSubTitle == 'GRPO') {
      objectType = '20';
    } else if (this.getFormSubTitle == 'Purchase Request') {
      objectType = '1470000113';
    } else if (this.getFormSubTitle == 'Delivery Challans') {
      objectType = '15';
    } else if (this.getFormSubTitle == 'Credit Notes') {
      objectType = '14';
    } else if (this.getFormSubTitle == 'Sales Down Payment Request') {
      objectType = '203';
    }
    const seriesRequestBody = new WrapperStandardRequest();
    seriesRequestBody.RequestData = [
      {
        Key: 'document',
        Value: objectType,
        OperatorType: null,
      },
      {
        Key: 'locked',
        Value: 'N',
        OperatorType: 'contains',
      },
      {
        Key: 'disabled',
        Value: 'N',
        OperatorType: 'contains',
      },
    ];
    seriesRequestBody.SortColumn = 'name';
    const seriesListResponse = await lastValueFrom(
      this.agenericRepositoryForCfl.PostAPI(
        GlobalProperties.getApiUrl +
        'DocumentNumberingSetup/GetDocumentNumberingSetupListService',
        seriesRequestBody
      )
    );
    this.seriesList = seriesListResponse.responseData;

    const requestBody = new WrapperStandardRequest();
    requestBody.SortColumn = 'branchName';
    const branchListResponse = await lastValueFrom(
      this.agenericRepositoryForCfl.PostAPI(
        GlobalProperties.getApiUrl + 'Branch/GetBranchListService',
        requestBody
      )
    );
    this.branchList = branchListResponse.responseData;

    // Auto-select only occurs in New/Add mode (getFormMode == 0)
    // and if the value is not already set.
    if (this.getFormMode == 0) {
      // 1. Branch auto-select (index 0)
      if (!this.getEntryFormDataSource.bpL_IDAssignedToInvoice && this.branchList && this.branchList.length > 0) {
        const currentBranch = this.branchList[0];
        this.getEntryFormDataSource.bpL_IDAssignedToInvoice = currentBranch.bplid;
        this.getEntryFormDataSource.branchName = currentBranch.branchName;
        this.getEntryFormDataSource.vatRegNum = currentBranch.federalTaxID;
      }

      // 2. Doc. Series auto-select (index 0)
      if (!this.getEntryFormDataSource.series && this.seriesList && this.seriesList.length > 0) {
        const currentSeries = this.seriesList[0];
        this.getEntryFormDataSource.series = currentSeries.series;
        this.getEntryFormDataSource.seriesName = currentSeries.name;
      }
    }
  }

  showBatchMessage() {
    this.snackbarService.showMessage(
      'Please check the base document for Batch/Serial',
      'X'
    );
  }

  showSerialMessage() {
    this.snackbarService.showMessage(
      'Please check the base document for Batch/Serial',
      'X'
    );
  }

  addtex(leneItem: any) {
    if (leneItem.taxRate !== undefined && leneItem.taxRate !== null && leneItem.taxRate !== '') {
      leneItem.taxTotal = (leneItem.taxRate * (leneItem.price || 0) * (leneItem.quantity || 0)) / 100;
    } else {
      leneItem.taxTotal = leneItem.taxTotal || 0;
    }
    leneItem.lineTotal = leneItem.taxTotal + ((leneItem.price || 0) * (leneItem.quantity || 0));
    this.calculateTotals();
    this.calculateDiscountAmt();
  }

  getEinvoiceData(data: IMarketingDocument) {
    if (
      this.getFormSubTitle == 'Sales Invoice' ||
      this.getFormSubTitle == 'Credit Notes' /* && this.screenName != 'add'*/
    ) {
      this.eInvoiceComp.docData = data;
      this.eInvoiceComp.getEinvoiceData(data, this.getFormSubTitle);
      this.einvoiceBtnComp.docEntry = data.docEntry.toString();
      this.einvoiceBtnComp.objectType = this.getFormSubTitle.includes(
        'Sales Invoice'
      )
        ? '13'
        : '14';
      this.einvoiceBtnComp.screenType = this.getFormMode;
    }
  }

  checkIfEway() {
    let flag: boolean = false;
    if (this.getFormSubTitle == 'Sales Invoice') {
      flag = true;
    }
    return flag;
  }

  setIrnFlag(event: string) {
    this.einvoiceBtnComp.irnFlag = event ? true : false;
    this.eWayTabComp.IRN = event;
  }

  ngAfterViewInit(): void {
    this.activated.url.subscribe(() => {
      setTimeout(() => {
        this.checkMenuPermissions();
      }, 100);
    });
    this.pickers = this.pickersQueryList.toArray();
    this.getEwayBillData('dropdown', this.getEntryFormDataSource);
  }


  getCustomerDetails(cardCode: any) {

    let res: any = {};
    if (this.getFormSubTitle != 'Purchase Request') {
      (async () => {
        console.log('in asyn in customer');
        const payload = new WrapperStandardRequest();
        payload.RequestData = cardCode;
        const customerResponse = await lastValueFrom(
          this.agenericRepositoryForCfl.PostAPI(
            GlobalProperties.getApiUrl +
            'BusinessPartner/GetBusinessPartnerService',
            payload
          )
        );
        res.event = customerResponse.responseData;
        this.getEntryFormDataSource.cardCode = res.event.cardCode;
        this.getEntryFormDataSource.cardName = res.event.cardName;
        this.getEntryFormDataSource.contactPersonCodeName =
          res.event.contactPerson;
        this.getEntryFormDataSource.contactPersonCode =
          res.event.contactPersonCode;
        this.getEntryFormDataSource.salesPersonCode = res.event.slpCode;
        this.getEntryFormDataSource.docCurrency = res.event.currency;
        this.getEntryFormDataSource.docCurrencyName =
          res.event.currencyName;
        this.getEntryFormDataSource.salesPersonCodeName =
          res.event.slpName;
        this.getEntryFormDataSource.paymentGroupCode =
          res.event.payTermsGrpCode;
        this.getEntryFormDataSource.paymentGroupCodeName =
          res.event.payTermsGrpCodeName;
        this.billToAddress = [];
        this.shipToAddress = [];
        this.currencyList = [];
        this.getEntryFormDataSource.address = '';
        this.getEntryFormDataSource.address2 = '';
        // this.getEntryFormDataSource.payToCode = '';
        // this.getEntryFormDataSource.shipToCode = res.event.rowNum;
        if (
          this.getFormSubTitle == 'Sales Invoice' ||
          this.getFormSubTitle == 'Credit Notes'
        ) {
          this.getEntryFormDataSource.payToCode =
            res.event.billtoDefault;
          this.getEntryFormDataSource.shipToCode =
            res.event.shipToDefault;
        }
        if (res.event.currencyName !== '##') {
          this.currencyList.push(res.event.currencyName);
        }
        if (res.event.bpAddresses) {
          res.event.bpAddresses.forEach((ele: any) => {
            if (ele.addressType == 'bo_BillTo') {
              this.billToAddress.push(ele);
            } else if (ele.addressType == 'bo_ShipTo') {
              this.shipToAddress.push(ele);
            }
          });
        }

        this.selectAddress(
          this.billToAddress.find((res) => res.isDefaultAddress)
        );
        this.selectAddress(
          this.shipToAddress.find((res) => res.isDefaultAddress)
        );
        if (this.getFormSubTitle == 'Sales Invoice') {
          this.eWayTabComp.docData = this.getEntryFormDataSource;
          this.eWayTabComp.screenName = this.getFormSubTitle;
          this.eWayTabComp.shipToData = {
            shipList: this.shipToAddress,
            value: this.getEntryFormDataSource.shipToCode,
          };
        }
        //check for NonIRN Customer when add
        if (
          this.getFormSubTitle == 'Sales Invoice' ||
          this.getFormSubTitle == 'Credit Notes'
        ) {
          this.checkNonIRNCustomer(customerResponse.responseData);
        }
      })();
    }

    if (
      this.getEntryFormDataSource.cardCode &&
      this.getEntryFormDataSource.documentLines.length > 0
    ) {
      for (
        let index = 0;
        index < this.getEntryFormDataSource.documentLines.length;
        index++
      ) {
        (async () => {
          const payload = new WrapperStandardRequest();
          payload.RequestData = {
            itemCode:
              this.getEntryFormDataSource.documentLines[index].itemCode,
            cardCode:
              this.getFormSubTitle == 'Purchase Request'
                ? this.getEntryFormDataSource.documentLines[index]
                  .lineVendor
                : this.getEntryFormDataSource.cardCode,
            itemName:
              this.getEntryFormDataSource.documentLines[index]
                .itemDescription,
          };

          const customerResponse = await lastValueFrom(
            this.agenericRepositoryForCfl.PostAPI(
              GlobalProperties.getApiUrl + 'Item/FetchItemPrice',
              payload
            )
          );

          // console.log('customerResponse',customerResponse.responseData.price)
          try {
            let curItemCode = (res.event.itemCode || (this.getEntryFormDataSource.documentLines[index] && this.getEntryFormDataSource.documentLines[index].itemCode)) || '';
            if (curItemCode) {
              const fetchUDF = async (endpoint: string, overrideReqData?: any) => {
                const payload = new WrapperStandardRequest();
                payload.RequestData = overrideReqData !== undefined ? overrideReqData : curItemCode;
                payload.PageSize = 1;
                payload.PageRecordCount = 10;
                payload.SortColumn = "";
                payload.IsAcending = true;
                try {
                  const resp = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + endpoint, payload));
                  if (resp) {
                    if (resp.responseData !== undefined) {
                      return resp.responseData.list ? resp.responseData.list[0] : (Array.isArray(resp.responseData) ? resp.responseData[0] : resp.responseData);
                    } else if (Array.isArray(resp)) {
                      return resp[0];
                    }
                    return resp;
                  }
                } catch (err) { console.error(endpoint, err); }
                return null;
              };

              const docLine = this.getEntryFormDataSource.documentLines[index];
              const reqPOPR = {
                DocEntry: Number(docLine.baseEntry ? docLine.baseEntry : (docLine.docEntry || 0)),
                LineNum: Number(docLine.baseLine ?? docLine.lineNum ?? 0)
              };

              const [] = await Promise.all([
              ]);

              console.log('Fetched UDFs RAW:', {});

              const extractVal = (obj: any, keys: string[]) => {
                if (obj === null || obj === undefined) return '';
                if (typeof obj !== 'object') return obj;
                for (let k of keys) {
                  if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
                }
                return obj.fldValue || obj.descr || obj.value || obj.Value || obj.name || obj.Name || obj.code || obj.Code || '';
              };

              if (this.getEntryFormDataSource.documentLines[index]) {
                // removed assignment to u_BasePrice
                // removed assignment to u_MinPP
                // removed assignment to u_MaxPP
                // removed assignment to u_LPP
                // removed assignment to u_LPVndr
                // removed assignment to u_MPIN
                // removed assignment to u_CurYear
                // removed assignment to u_LstYear
                // removed assignment to u_BaseQty
              }
            }
          } catch (e) { console.error('Get UDFs failed', e); }
          if (customerResponse.responseData) {
            this.getEntryFormDataSource.documentLines[index].unitPrice =
              customerResponse.responseData.price;

            this.getEntryFormDataSource.documentLines[
              index
            ].discountPercent = 0;
            this.getEntryFormDataSource.documentLines[index].taxCode =
              '';
            this.getEntryFormDataSource.documentLines[index].price =
              this.getEntryFormDataSource.documentLines[index]
                .unitPrice -
              (this.getEntryFormDataSource.documentLines[index]
                .unitPrice *
                this.getEntryFormDataSource.documentLines[index]
                  .discountPercent) /
              100;
            this.getEntryFormDataSource.documentLines[index].lineTotal =
              this.getEntryFormDataSource.documentLines[index].price *
              this.getEntryFormDataSource.documentLines[index].quantity;
            this.getEntryFormDataSource.totalBeforeDiscount =
              this.getEntryFormDataSource.documentLines[index].price *
              this.getEntryFormDataSource.documentLines[index].quantity;
            this.calculateTotals();
            this.calculateDiscountAmt();
          }
        })();
      }
    }

    if (this.getFormSubTitle == 'Purchase Request') {
      if (this.getEntryFormDataSource.documentLines.length > 0) {
        for (
          let index = 0;
          index < this.getEntryFormDataSource.documentLines.length;
          index++
        ) {
          (async () => {
            const payload = new WrapperStandardRequest();
            payload.RequestData = {
              itemCode:
                this.getEntryFormDataSource.documentLines[index]
                  .itemCode,
              cardCode:
                this.getFormSubTitle == 'Purchase Request'
                  ? this.getEntryFormDataSource.documentLines[index]
                    .lineVendor
                  : this.getEntryFormDataSource.cardCode,
              itemName:
                this.getEntryFormDataSource.documentLines[index]
                  .itemDescription,
            };

            const customerResponse = await lastValueFrom(
              this.agenericRepositoryForCfl.PostAPI(
                GlobalProperties.getApiUrl + 'Item/FetchItemPrice',
                payload
              )
            );

            // console.log('customerResponse',customerResponse.responseData.price)
            try {
              let curItemCode = (res.event.itemCode || (this.getEntryFormDataSource.documentLines[index] && this.getEntryFormDataSource.documentLines[index].itemCode)) || '';
              if (curItemCode) {
                const fetchUDF = async (endpoint: string, overrideReqData?: any) => {
                  const payload = new WrapperStandardRequest();
                  payload.RequestData = overrideReqData !== undefined ? overrideReqData : curItemCode;
                  payload.PageSize = 1;
                  payload.PageRecordCount = 10;
                  payload.SortColumn = "";
                  payload.IsAcending = true;
                  try {
                    const resp = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + endpoint, payload));
                    if (resp) {
                      if (resp.responseData !== undefined) {
                        return resp.responseData.list ? resp.responseData.list[0] : (Array.isArray(resp.responseData) ? resp.responseData[0] : resp.responseData);
                      } else if (Array.isArray(resp)) {
                        return resp[0];
                      }
                      return resp;
                    }
                  } catch (err) { console.error(endpoint, err); }
                  return null;
                };

                const docLine = this.getEntryFormDataSource.documentLines[index];
                const reqPOPR = {
                  DocEntry: Number(docLine.baseEntry || docLine.docEntry || 0),
                  LineNum: Number(docLine.baseLine ?? docLine.lineNum ?? 0)
                };

                const [] = await Promise.all([
                ]);

                console.log('Fetched UDFs RAW:', {});

                const extractVal = (obj: any, keys: string[]) => {
                  if (obj === null || obj === undefined) return '';
                  if (typeof obj !== 'object') return obj;
                  for (let k of keys) {
                    if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
                  }
                  return obj.fldValue || obj.descr || obj.value || obj.Value || obj.name || obj.Name || obj.code || obj.Code || '';
                };

                if (this.getEntryFormDataSource.documentLines[index]) {
                  // removed assignment to u_BasePrice
                  // removed assignment to u_MinPP
                  // removed assignment to u_MaxPP
                  // removed assignment to u_LPP
                  // removed assignment to u_LPVndr
                  // removed assignment to u_MPIN
                  // removed assignment to u_CurYear
                  // removed assignment to u_LstYear
                  // removed assignment to u_BaseQty
                }
              }
            } catch (e) { console.error('Get UDFs failed', e); }
            if (customerResponse.responseData) {
              this.getEntryFormDataSource.documentLines[
                index
              ].unitPrice = customerResponse.responseData.price;

              this.getEntryFormDataSource.documentLines[
                index
              ].discountPercent = 0;
              this.getEntryFormDataSource.documentLines[index].taxCode =
                '';
              this.getEntryFormDataSource.documentLines[index].price =
                this.getEntryFormDataSource.documentLines[index]
                  .unitPrice -
                (this.getEntryFormDataSource.documentLines[index]
                  .unitPrice *
                  this.getEntryFormDataSource.documentLines[index]
                    .discountPercent) /
                100;
              this.getEntryFormDataSource.documentLines[
                index
              ].lineTotal =
                this.getEntryFormDataSource.documentLines[index].price *
                this.getEntryFormDataSource.documentLines[index]
                  .quantity;
              this.getEntryFormDataSource.totalBeforeDiscount =
                this.getEntryFormDataSource.documentLines[index].price *
                this.getEntryFormDataSource.documentLines[index]
                  .quantity;
              this.calculateTotals();
              this.calculateDiscountAmt();
            }
          })();
        }
      }
    }
  }


  async getOrders() {
    let url = 'Orders';
    const result = await this.generic.GetAPIForSAP(GlobalProperties.getApiUrlSap + url);

    let orderResult = result.value[0];

    // Create a form group dynamically
    let formControls: any = {};

    // Loop through properties in orderResult
    for (const key in orderResult) {
      if (orderResult.hasOwnProperty(key) && key.startsWith('U_')) {
        // Create a form control for each property starting with "U_"
        formControls[key] = new FormControl(orderResult[key] || '');
      }
    }

    // Assuming you have a FormGroup instance, e.g., this.myForm
    this.myForm = new FormGroup(formControls);


  }

  onSubmit() {
    console.log(this.myForm.value);
  }

  async testt() {
    let formControls: any = {};
    let formControlsLineLevel: any = {};

    let skip = 0;
    let keepGoing = true;
    let pageSize = 160;
    while (keepGoing) {
      const url = `UserFieldsMD?$filter=TableName eq 'ORDR'&$top=${pageSize}&$skip=${skip}`;
      const urlForLineLeve = `UserFieldsMD?$filter=TableName eq 'RDR1'&$top=${pageSize}&$skip=${skip}`
      try {
        const response: any = await this.generic.GetAPIForSAP(GlobalProperties.getApiUrlSap + url);
        const responseLineLevel: any = await this.generic.GetAPIForSAP(GlobalProperties.getApiUrlSap + urlForLineLeve);

        const results = response.value || response; // some APIs wrap in `value`
        const resultsLine = responseLineLevel.value || responseLineLevel; // some APIs wrap in `value`
        this.allResults = this.allResults.concat(results);
        this.allResultsLIneLevel = this.allResultsLIneLevel.concat(resultsLine);

        if (skip > pageSize) {
          keepGoing = false; // Last page
        } else {
          skip += 20;
        }
      } catch (error) {
        console.error('Error fetching user fields:', error);
        keepGoing = false; // Stop loop on error
      }
    }

    console.log('allResults', this.allResults)
    console.log('allResultsLine', this.allResultsLIneLevel)
    //  formControls[key] = new FormControl(orderResult[key] || '');

    // return allResults;


    this.allResults.forEach(res => {

      formControls['U_' + res.Name] = new FormControl(res.DefaultValue || '',);

    })
    this.allResultsLIneLevel.forEach(res => {

      formControlsLineLevel['U_' + res.Name] = new FormControl(res.DefaultValue || '',);

    })

    this.myForm = new FormGroup(formControls);
    //  this.myFormLineLevel=new FormGroup(formControlsLineLevel);
    // this.lineLevelFormGroupArray.push()
    this.lineLevelFormGroupArray.push(new FormGroup(formControlsLineLevel));
    console.log(' this.myForm', this.myForm)

  }




  openPopup(templateRef: TemplateRef<any>, index: number): void {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    this.lineLevelFormGroup = this.lineLevelFormGroupArray[index]
    this.dialog.open(templateRef);
  }

  toggleSection() {
    this.isExpanded = !this.isExpanded;
  }

  onDebundleChange(event: any) {
    this.getEntryFormDataSource.u_TIDEBTYPE = event.checked ? 'Y' : 'N';
  }

  numbersOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow only numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    return false;
  }





  onShipToBranchSelect(selectedValue: string) {

    const selectedBranch = this.shipToBranch.find(
      branch => branch.viewValue === selectedValue
    );

    this.getEntryFormDataSource.u_TIShipAdr =
      selectedBranch ? selectedBranch.shipToAddress : '';
  }

  clearCflData(value: string, index?: number) {
    if (value == 'Department') {
      this.getEntryFormDataSource.department = null as any;
      this.getEntryFormDataSource.departmentName = null as any;
    } else if (value == 'Transaction') {
      this.getEntryFormDataSource.gstTranTyp = null as any;
      this.getEntryFormDataSource.gstTranTypName = null as any;
      this.getEntryFormDataSource.series = null as any;
      this.getEntryFormDataSource.seriesName = null as any;
    } else if (value == 'Branch') {
      this.getEntryFormDataSource.bpL_IDAssignedToInvoice = null as any;
      this.getEntryFormDataSource.branchName = null as any;
    } else if (value == 'Customer' || value == 'Vendor') {
      if (this.getFormSubTitle == 'Purchase Request' && index !== undefined && index !== null && this.getEntryFormDataSource.documentLines[index]) {
        this.getEntryFormDataSource.documentLines[index].lineVendor = null as any;
        this.getEntryFormDataSource.documentLines[index].lineVendorName = null as any;
      } else {
        this.getEntryFormDataSource.cardCode = null as any;
        this.getEntryFormDataSource.cardName = null as any;
        this.getEntryFormDataSource.contactPersonCode = null as any;
        this.getEntryFormDataSource.contactPersonCodeName = null as any;
        this.getEntryFormDataSource.salesPersonCode = null as any;
        this.getEntryFormDataSource.docCurrency = null as any;
        this.getEntryFormDataSource.docCurrencyName = null as any;
        this.getEntryFormDataSource.salesPersonCodeName = null as any;
        this.getEntryFormDataSource.paymentGroupCode = null as any;
        this.getEntryFormDataSource.paymentGroupCodeName = null as any;
        this.getEntryFormDataSource.payToCode = null as any;
        this.getEntryFormDataSource.shipToCode = null as any;
        this.getEntryFormDataSource.address = null as any;
        this.getEntryFormDataSource.address2 = null as any;
        this.billToAddress = [];
        this.shipToAddress = [];
      }
    } else if (value == 'state') {
      this.getEntryFormDataSource.placeOfSupplyCode = null as any;
      this.getEntryFormDataSource.placeOfSupplyCodeName = null as any;
    } else if (value == 'incoterms') {
      // removed assignment to u_InCoTerm
      // removed assignment to u_InCoTermName
    } else if (value == 'payment') {
      this.getEntryFormDataSource.paymentGroupCode = null as any;
    } else if (value == 'salesPerson') {
      this.getEntryFormDataSource.salesPersonCode = null as any;
    } else if (value == 'shippingType') {
      this.getEntryFormDataSource.shipPlace = null as any;
      this.getEntryFormDataSource.shipPlaceName = null as any;
    } else if (value == 'importOrExportType') {
      if (this.getEntryFormDataSource.taxExtension) {
        this.getEntryFormDataSource.taxExtension.importOrExportType = null as any;
      }
    } else if (value == 'seriesName') {
      this.getEntryFormDataSource.series = null as any;
      this.getEntryFormDataSource.seriesName = null as any;
    } else if (value == 'sequence') {
      this.getEntryFormDataSource.seqCode = null as any;
      this.getEntryFormDataSource.seqName = null as any;
      this.getEntryFormDataSource.nextNum = null as any;
    } else if (value == 'Owner') {
      this.getEntryFormDataSource.ownerCode = null as any;
      (this.getEntryFormDataSource as any).ownerCodeName = null as any;
    } else if (value == 'Requester') {
      this.getEntryFormDataSource.reqType = null as any;
      this.getEntryFormDataSource.requester = null as any;
      this.getEntryFormDataSource.requesterName = null as any;
      this.getEntryFormDataSource.email = null as any;
    }

    if (index !== undefined && index !== null && this.getEntryFormDataSource.documentLines[index]) {
      if (value == 'taxCode') {
        this.getEntryFormDataSource.documentLines[index].taxCode = null as any;
        this.getEntryFormDataSource.documentLines[index].taxTotal = null as any;
      } else if (value == 'itemCode') {
        this.getEntryFormDataSource.documentLines[index].itemCode = null as any;
        this.getEntryFormDataSource.documentLines[index].itemDescription = null as any;
        this.getEntryFormDataSource.documentLines[index].uoMCode = null as any;
        this.getEntryFormDataSource.documentLines[index].warehouseCode = null as any;
        this.getEntryFormDataSource.documentLines[index].wareHouseName = null as any;
        this.getEntryFormDataSource.documentLines[index].locationCode = null as any;
        this.getEntryFormDataSource.documentLines[index].locationName = null as any;
        this.getEntryFormDataSource.documentLines[index].warehouseQuantity = 0 as any;
        this.getEntryFormDataSource.documentLines[index].taxCode = null as any;
        this.getEntryFormDataSource.documentLines[index].hsnEntry = null as any;
        this.getEntryFormDataSource.documentLines[index].sacEntry = null as any;
        this.getEntryFormDataSource.documentLines[index].chapterID = null as any;
        this.getEntryFormDataSource.documentLines[index].lineVendor = null as any;
        this.getEntryFormDataSource.documentLines[index].lineVendorName = null as any;
        this.getEntryFormDataSource.documentLines[index].unitPrice = 0;
        this.getEntryFormDataSource.documentLines[index].price = 0;
        this.getEntryFormDataSource.documentLines[index].discountPercent = 0;
        this.getEntryFormDataSource.documentLines[index].quantity = 0;
        this.getEntryFormDataSource.documentLines[index].lineTotal = 0;
        // removed assignment to u_BasePrice
        // removed assignment to u_MinPP
        // removed assignment to u_MaxPP
        // removed assignment to u_LPP
        // removed assignment to u_LPVndr
        // removed assignment to u_MPIN
        // removed assignment to u_CurYear
        // removed assignment to u_LstYear
        // removed assignment to u_BaseQty
        this.getEntryFormDataSource.documentLines[index].ocrCode = null as any;
        this.getEntryFormDataSource.documentLines[index].ocrName = null as any;
        // removed assignment to u_Category
        // removed assignment to u_BudAmt
        // removed assignment to u_UtiBud
        // removed assignment to u_ComBud
        // removed assignment to u_REmBudg
      } else if (value == 'warehouse') {
        this.getEntryFormDataSource.documentLines[index].warehouseCode = null as any;
        this.getEntryFormDataSource.documentLines[index].wareHouseName = null as any;
        this.getEntryFormDataSource.documentLines[index].locationCode = null as any;
        this.getEntryFormDataSource.documentLines[index].locationName = null as any;
        this.getEntryFormDataSource.documentLines[index].warehouseQuantity = 0 as any;
      } else if (value == 'hsnNum') {
        this.getEntryFormDataSource.documentLines[index].hsnEntry = null as any;
        this.getEntryFormDataSource.documentLines[index].sacEntry = null as any;
        this.getEntryFormDataSource.documentLines[index].chapterID = null as any;
      } else if (value == 'UOM') {
        this.getEntryFormDataSource.documentLines[index].uoMCode = null as any;
        (this.getEntryFormDataSource.documentLines[index] as any).uomCode = null as any;
      } else if (value == 'Distribution') {
        this.getEntryFormDataSource.documentLines[index].ocrCode = null as any;
        this.getEntryFormDataSource.documentLines[index].ocrName = null as any;
        // removed assignment to u_Category
        // removed assignment to u_BudAmt
        // removed assignment to u_UtiBud
        // removed assignment to u_ComBud
        // removed assignment to u_REmBudg
      } else if (value == 'BudgetCategory') {
        // removed assignment to u_Category
        // removed assignment to u_BudAmt
        // removed assignment to u_UtiBud
        // removed assignment to u_ComBud
        // removed assignment to u_REmBudg
      } else if (value == 'Project') {
        this.getEntryFormDataSource.documentLines[index].projectCode = null as any;
        this.getEntryFormDataSource.documentLines[index].projectName = null as any;
      } else if (value == 'configuration') {
        // removed assignment to u_Configuration
      }

      this.calculateTotals();
      this.calculateDiscountAmt();
    }

    if (value == 'frightTaxCode' && index !== undefined && index !== null && this.getEntryFormDataSource.documentAdditionalExpenses[index]) {
      this.getEntryFormDataSource.documentAdditionalExpenses[index].taxCode = null as any;
      this.calculateTotals();
      this.calculateDiscountAmt();
    }
  }

  async onTableScroll(event: any) {
    const paginatedForms = ['Purchase Quotation', 'Purchase Request', 'Purchase Order', 'Sales Down Payment Request', 'Sales Quotation', 'Sales Order', 'Delivery Challans', 'Sales Invoice', 'Credit Notes', 'Purchase Down Payment Request', 'GRPO', 'Purchase Invoice', 'Debit Notes', 'Outgoing Payment'];
    if (!paginatedForms.includes(this.getFormSubTitle)) {
      return;
    }
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 10) {
      if (!this.isLoadingMoreLines && this.hasMoreLines && this.getFormMode === 1) {
        this.loadMoreDocumentLines();
      }
    }
  }

  async loadMoreDocumentLines() {
    if (!this.hasMoreLines || this.isLoadingMoreLines) return;

    this.isLoadingMoreLines = true;
    this.pageNumber++;

    const request = new WrapperStandardRequest();
    request.RequestData = this.getRequestDataForFormModeEdit;
    request.PageSize = this.pageNumber;
    request.PageRecordCount = 10;
    request.SortColumn = "itemDescription";


    try {
      const url = this.getURLForFormModeEdit;
      const result: any = await this.agenericRepository.PostAPI(url, request).toPromise();

      let data = result && result.responseData ? result.responseData : null;
      if (Array.isArray(data) && data.length > 0) {
        data = data[0];
      }

      if (data && data.documentLines) {
        const newLines = data.documentLines;

        if (newLines.length > 0) {
          const existingLineNums = new Set(this.getEntryFormDataSource.documentLines.map((l: any) => l.lineNum ?? l.LineNum));
          const uniqueNewLines = newLines.filter((l: any) => !existingLineNums.has(l.lineNum ?? l.LineNum));

          if (uniqueNewLines.length > 0) {
            this.getEntryFormDataSource.documentLines = [
              ...this.getEntryFormDataSource.documentLines,
              ...uniqueNewLines
            ];
            this.originalDocumentLines = [
              ...this.originalDocumentLines,
              ...JSON.parse(JSON.stringify(uniqueNewLines))
            ];
          }
        }

        if (newLines.length < 10) {
          this.hasMoreLines = false;
        }
      } else {
        this.hasMoreLines = false;
      }
    } catch (error) {
      console.error('Error loading more document lines', error);
      this.pageNumber--;
    } finally {
      this.isLoadingMoreLines = false;
    }
  }

  filterDirtyDocumentLines(currentDtoLines: any[]): { dirtyLines: any[], deletedLines: number[] } {
    // If not in Edit mode or original lines missing, return full lines
    if (this.getFormMode !== 1 || !this.originalDocumentLines || this.originalDocumentLines.length === 0) {
      return { dirtyLines: currentDtoLines, deletedLines: [] };
    }

    // Map original lines to SAP format for 1-to-1 comparison
    const tempOriginalDoc = new MarketingDocument();
    tempOriginalDoc.documentLines = this.originalDocumentLines;
    const originalDtoLines = mapper.map(
      tempOriginalDoc,
      MarketingDocument,
      MarketingDocumentSAP
    )?.DocumentLines || [];

    const pipe = new DatePipe('en-US');
    if (originalDtoLines.length) {
      originalDtoLines.forEach((line: any) => {
        line.ShipDate = pipe.transform(line.ShipDate, 'y-MM-d');
        // removed assignment to U_ETADate
        line.RemainingOpenQuantity = line.Quantity;
      });
    }

    const dirtyLines: any[] = [];
    const deletedLines: number[] = [];

    // Find deleted lines
    for (const origLine of originalDtoLines) {
      const origLineNum = origLine.LineNum ?? (origLine as any).lineNum;
      if (!currentDtoLines.find((l: any) => l.LineNum === origLineNum)) {
        if (origLineNum !== undefined && origLineNum !== null) {
          deletedLines.push(origLineNum);
        }
      }
    }

    for (const currentLine of currentDtoLines) {
      const origLine: any = originalDtoLines.find((l: any) => (l.LineNum ?? l.lineNum) === currentLine.LineNum);

      // If no matching original line, it's new
      if (!origLine) {
        dirtyLines.push(currentLine);
        continue;
      }

      const dirtyLine: any = { LineNum: currentLine.LineNum };
      let hasChanges = false;

      // Compare properties
      for (const key of Object.keys(currentLine)) {
        if (key === 'LineNum') continue;

        const origKey = key.charAt(0).toLowerCase() + key.slice(1);
        const origValue = origLine[key] !== undefined ? origLine[key] : origLine[origKey];

        // Use deep comparison for objects/arrays to avoid false positives (e.g. empty arrays like SerialNumbers)
        let isChanged = false;
        if (typeof currentLine[key] === 'object' && currentLine[key] !== null) {
          isChanged = JSON.stringify(currentLine[key]) !== JSON.stringify(origValue);
        } else {
          isChanged = currentLine[key] !== origValue;
        }

        if (isChanged) {
          dirtyLine[key] = currentLine[key];
          hasChanges = true;
        }
      }

      // Only include the line if at least one field changed
      if (hasChanges) {
        dirtyLines.push(dirtyLine);
      }
    }

    return { dirtyLines, deletedLines };
  }

}





















